/* Generated by scripts/build_shopify.py: src/backdrop.js + src/engine.js + src/shopify.js. Edit src/, then rebuild. */
/* Backdrop for The Armory: one full-screen shader. Room index = THEMES[i].t in engine.js:
   0 limestone plaster        1 open sky (time-of-day mode only)        2 black castle stone
   4 galaxy                   5 digital rain (falling glyphs)           6 night of floating 8-bit lanterns
   7 white wall, cherry tree, falling petals                            9 heaven (hidden: click a glowing bolt)
   Wall rooms (0 2 7) have a soft key light from the upper left and catch the rack's shadows. Open rooms (1 4 5 6)
   have no wall: the rail's brackets are bolted into the scene itself, with a gold glow around each bolt.
   Removed rooms: forest (3) and butterflies + doves (8) in src/archive/release-b-draft1/; white gallery, concrete,
   sandy castle and boho in src/archive/. Coordinates are CSS px, y down. */
window.OTK_BACKDROP = {
vert: `
void main(){ gl_Position = vec4(position.xy, 0.9999, 1.0); }`,
frag: `
precision highp float;
uniform vec2 uRes; uniform float uDpr, uTime;
uniform int uTheme, uPrev; uniform float uMix; uniform vec2 uReveal;
uniform vec4 uRail; uniform vec2 uRailOff; uniform float uRailDepth;
uniform float uS;                                   // garment scale (px): sizes the bolt glow and the petals
uniform sampler2D uSakura, uGlyphs; uniform float uSakuraAspect;
uniform float uGlow, uStars, uDrift;                // light around the bolts; stars (time-of-day nights); petals' gust drift (px)
uniform vec3 uZen, uHor, uCLit, uCShade, uSunC; uniform vec2 uSunP, uToSun, uMoonP;   // the sky's palette for this hour
vec3 starField(vec2 p, float t, float band);
float shootingStar(vec2 p, float wk);
vec2 boltAt(float x);
float halo(vec2 p, vec2 c, float seed);

float h21(vec2 p){ p = fract(p * vec2(123.34, 456.21)); p += dot(p, p + 45.32); return fract(p.x * p.y); }
float vn(vec2 p){ vec2 i = floor(p), f = fract(p); vec2 u = f * f * (3.0 - 2.0 * f);
  return mix(mix(h21(i), h21(i + vec2(1.0, 0.0)), u.x), mix(h21(i + vec2(0.0, 1.0)), h21(i + vec2(1.0, 1.0)), u.x), u.y); }
float fbm(vec2 p){ float s = 0.0, a = 0.5; for (int i = 0; i < 5; i++){ s += a * vn(p); p = p * 2.03 + vec2(17.1, 9.2); a *= 0.5; } return s; }
float fbm3(vec2 p){ float s = 0.0, a = 0.5; for (int i = 0; i < 3; i++){ s += a * vn(p); p = p * 2.07 + vec2(5.3, 11.7); a *= 0.5; } return s; }
mat2 rot(float a){ float c = cos(a), s = sin(a); return mat2(c, -s, s, c); }
float bayer2(vec2 a){ a = floor(a); return fract(dot(a, vec2(0.5, a.y * 0.75))); }
float bayer4(vec2 a){ return bayer2(0.5 * a) * 0.25 + bayer2(a); }
float sdSeg(vec2 p, vec2 a, vec2 b){ vec2 pa = p - a, ba = b - a; return length(pa - ba * clamp(dot(pa, ba) / dot(ba, ba), 0.0, 1.0)); }
float lum(vec3 c){ return dot(c, vec3(0.299, 0.587, 0.114)); }

/* =============================== wall rooms =============================== */
vec4 limestone(vec2 p){
  return vec4(vec3(0.80, 0.785, 0.75) * (0.94 + 0.08 * fbm3(p * 0.004 + 3.0)) * (0.97 + 0.03 * vn(p * 0.2)),
              fbm(p * 0.012) * 0.6 + vn(p * 0.09) * 0.25 + vn(p * 0.35) * 0.15);
}
// black castle: coursed rubble ashlar in near-black basalt, pillowed faces, deep dusty joints
vec4 blackStone(vec2 p){
  float rowH = 68.0; float row = floor(p.y / rowH); float ly = p.y - row * rowH;
  float x = p.x + h21(vec2(row, 3.0)) * 400.0;
  float k = floor(x / 130.0);
  float b0 = k * 130.0 + (h21(vec2(k, row)) - 0.5) * 70.0, b1 = (k + 1.0) * 130.0 + (h21(vec2(k + 1.0, row)) - 0.5) * 70.0;
  if (x < b0) { b1 = b0; k -= 1.0; b0 = k * 130.0 + (h21(vec2(k, row)) - 0.5) * 70.0; }
  else if (x > b1) { b0 = b1; k += 1.0; b1 = (k + 1.0) * 130.0 + (h21(vec2(k + 1.0, row)) - 0.5) * 70.0; }
  float lx = x - b0, w = b1 - b0;
  float e = min(min(lx, w - lx), min(ly, rowH - ly)) + (fbm3(p * 0.06) - 0.5) * 7.0;
  float id = h21(vec2(k, row) + 0.37);
  float mortar = smoothstep(5.5, 2.0, e);
  float pillow = pow(smoothstep(0.0, 16.0, e), 0.7);
  float face = fbm(p * 0.045 + id * 31.0);
  float chip = smoothstep(0.62, 0.8, vn(p * 0.12 + id * 9.0)) * smoothstep(14.0, 3.0, e);
  float grit = vn(p * 0.32 + id * 13.0) * 0.5 + vn(p * 0.9) * 0.5;
  float h = pillow * (0.75 + face * 0.6 + grit * 0.12) - chip * 0.45 - mortar * 0.9 + vn(p * 1.3) * 0.08 * mortar;
  vec3 c1 = vec3(0.115, 0.112, 0.118), c2 = vec3(0.165, 0.157, 0.15), c3 = vec3(0.085, 0.09, 0.1);
  vec3 stone = id < 0.4 ? mix(c1, c2, id / 0.4) : id < 0.75 ? mix(c2, c3, (id - 0.4) / 0.35) : mix(c3, c1 * 1.1, (id - 0.75) / 0.25);
  stone *= (0.78 + 0.4 * face) * (0.9 + 0.16 * grit);
  stone *= 1.0 - 0.25 * smoothstep(0.45, 0.8, fbm3(vec2(p.x * 0.03, p.y * 0.004)));       // soot runs
  stone *= 1.0 - 0.3 * chip;
  vec3 mort = vec3(0.21, 0.2, 0.19) * (0.85 + 0.3 * vn(p * 0.8));
  vec3 a = mix(stone, mort, mortar);
  a *= 0.75 + 0.25 * smoothstep(0.0, 10.0, e + 3.0);
  // moss: where the wall stays damp. Big soft colonies come and go across the wall (two scales of noise), small
  // clumps sit in the joints, and every patch creeps a little onto the stone along the top of the joint below it; a
  // fuzzy, raised, two-tone green that never fills a stone face edge to edge
  float joint = smoothstep(9.0, 1.0, e), shelf = smoothstep(rowH * 0.5, rowH, ly) * smoothstep(14.0, 2.0, rowH - ly);
  float colony = fbm3(p * 0.0032 + 3.1) * 0.6 + fbm3(p * 0.011 + 7.7) * 0.4;     // where the wall stays damp
  float fuzz = vn(p * 0.85 + 2.0) * 0.55 + vn(p * 2.4 + 5.0) * 0.45;
  float mJ = joint * smoothstep(0.43, 0.56, colony);                                 // joints fill first
  float mF = smoothstep(0.55, 0.67, colony + shelf * 0.07 + joint * 0.05);          // the dampest spots spread over the stone
  float tuft = smoothstep(0.8, 0.9, vn(p * 0.05 + id * 5.3)) * joint * smoothstep(0.28, 0.42, colony);   // odd small tufts
  float lump = vn(p * 0.16 + id * 3.0) * 0.6 + vn(p * 0.42 + 1.7) * 0.4;           // cushions a few px to a couple of cm
  float m = max(max(mJ, mF), tuft);
  m = smoothstep(0.4, 0.62, m * (0.72 + 0.55 * lump) + (fuzz - 0.5) * 0.2);       // dense inside, a fine fringe at the edge
  vec3 moss = mix(vec3(0.045, 0.08, 0.022), vec3(0.15, 0.24, 0.055), lump * 0.7 + fuzz * 0.3);   // shaded hollows to lit tips
  moss = mix(moss, vec3(0.19, 0.21, 0.075), smoothstep(0.72, 0.95, vn(p * 0.09 + 9.0)) * 0.5);  // some yellower, drier
  a = mix(a, moss, m * 0.94);
  h += m * (0.22 + 0.32 * lump);
  return vec4(a, h);
}
vec4 surf(int t, vec2 p){
  if (t == 2) return blackStone(p);
  if (t == 7) return vec4(vec3(0.95, 0.947, 0.94) * (0.988 + 0.012 * fbm3(p * 0.003)), vn(p * 0.6) * 0.05 + fbm3(p * 0.008) * 0.08);
  return limestone(p);
}
float bumpK(int t){ return t == 2 ? 3.4 : t == 7 ? 0.8 : 1.3; }
float ambient(int t){ return t == 2 ? 0.42 : t == 7 ? 0.86 : 0.78; }
float keyI(int t){ return t == 2 ? 0.95 : t == 7 ? 0.32 : 0.5; }
vec3 keyC(int t){ return t == 2 ? vec3(1.0, 0.92, 0.8) : t == 7 ? vec3(1.0, 0.98, 0.95) : vec3(1.0, 0.94, 0.84); }

// ---- cherry tree (texture, anchored bottom-left, taller than the room) with petals drifting down from it
vec4 treeAt(vec2 p, float bias){
  float h = uRes.y * 1.06, w = h * uSakuraAspect;
  vec2 uv = (p - vec2(0.0, uRes.y - h)) / vec2(w, h);
  vec4 c = texture2D(uSakura, vec2(uv.x, 1.0 - uv.y), bias);           // sample first, then mask (see engine.js samp)
  return (uv.x < 0.0 || uv.x > 1.0 || uv.y < 0.0 || uv.y > 1.0) ? vec4(0.0) : c;
}
vec4 petals(vec2 p, float t){
  vec4 acc = vec4(0.0);
  float k = uRes.y / 860.0, canopyR = min(uRes.x, uRes.y * 1.06 * uSakuraAspect * 0.78);
  for (int L = 0; L < 2; L++){
    float fl = float(L), cell = (L == 0 ? 52.0 : 84.0) * k;
    vec2 wind = vec2(16.0 + 12.0 * fl, 30.0 + 16.0 * fl) * k;            // drifting right and down, nearer = faster
    vec2 g = (p - wind * t - vec2(uDrift * (0.8 + 0.4 * fl), 0.0)) / cell + fl * 31.0;   // gusts carry them sideways
    vec2 id = floor(g), f = fract(g);
    float h = h21(id + fl * 7.0);
    float dens = mix(0.06, 0.5, smoothstep(canopyR * 1.15, canopyR * 0.25, p.x));   // most fall under the canopy
    if (h > dens) continue;
    vec2 d = (f - (vec2(h21(id + 1.3), h21(id + 2.7)) * 0.5 + 0.25)) * cell;
    d.x += sin(t * 1.3 + h * 40.0) * 6.0 * k;                             // flutter
    d = rot(t * (0.8 + 1.8 * h21(id + 4.4)) + h * 20.0) * d;
    float flip = abs(sin(t * (1.2 + 1.6 * h) + h * 9.0));                 // tumbling: turns edge-on and back
    vec2 sz = vec2(5.2, 3.8) * k * (0.85 + 0.45 * fl);
    vec2 e = d / (sz * vec2(max(flip, 0.18), 1.0));
    float r = length(e) + 0.35 * smoothstep(0.5, 1.0, e.y) * smoothstep(0.3, 0.0, abs(e.x));   // notched tip
    float a = smoothstep(1.0, 0.82, r);
    vec3 pc = mix(vec3(0.99, 0.83, 0.88), vec3(0.95, 0.64, 0.75), h21(id + 6.0)) * (0.82 + 0.18 * flip);
    acc = vec4(mix(acc.rgb, pc, a), max(acc.a, a));
  }
  return acc;
}
vec3 sakura(vec2 p, vec3 col, vec3 lf){
  float k = uRes.y / 860.0;
  col *= 1.0 - 0.2 * treeAt(p - vec2(12.0, 20.0) * k, 3.5).a;              // the tree's soft shadow on the wall
  vec4 tr = treeAt(p, 0.0);
  col = mix(col, tr.rgb * lf, tr.a);
  col *= 1.0 - 0.1 * petals(p - vec2(5.0, 9.0) * k, uTime).a;               // petal shadows
  vec4 pe = petals(p, uTime);
  return mix(col, pe.rgb * lf * 1.04, pe.a);
}

vec3 wallRoom(int t, vec2 p){
  vec4 s0 = surf(t, p);
  float h0 = s0.w, hx = surf(t, p + vec2(1.5, 0.0)).w, hy = surf(t, p + vec2(0.0, 1.5)).w;
  float k = bumpK(t);
  vec3 N = normalize(vec3(-(hx - h0) * k, -(hy - h0) * k, 1.0));
  vec3 Lk = normalize(vec3(-0.35, -0.55, 0.76));
  float E = max(dot(N, Lk), 0.0) * keyI(t);
  // the rail's soft shadow on the wall, thrown down and a little right by the key light
  float sy = uRail.z + uRailOff.y + uS * 0.05 + 2.0, sx = uRailOff.x + uS * 0.02;
  float soft = uRail.w * 2.2 + 5.0;
  float band = exp(-pow((p.y - sy) / soft, 2.0)) * smoothstep(uRail.x + sx - soft, uRail.x + sx + soft, p.x) * smoothstep(uRail.y + sx + soft, uRail.y + sx - soft, p.x);
  E *= 1.0 - 0.42 * band;
  float amb = ambient(t);
  vec2 uv = p / uRes;
  float vig = 1.0 - 0.24 * pow(length((uv - vec2(0.5, 0.42)) * vec2(1.0, 1.25)), 2.2);
  vec3 light = amb * vig * (1.0 - 0.08 * band) * vec3(0.97, 0.98, 1.0) + E * keyC(t) * (0.85 + 0.15 * N.z);
  vec3 col = s0.rgb * light;
  if (t == 2) col += vec3(0.85, 0.82, 0.78) * pow(max(dot(reflect(-Lk, N), vec3(0.0, 0.0, 1.0)), 0.0), 26.0) * 0.16;   // basalt sheen
  vec3 lf = amb * vig * vec3(0.97, 0.98, 1.0) + keyI(t) * 0.75 * keyC(t);    // flat light for things in front of the wall
  if (t == 7) col = sakura(p, col, lf);   // (the sumi-e ink strokes were removed by the owner: src/archive/release-b-draft5/)
  col = 1.0 - exp(-col * 1.85);                             // soft film shoulder
  // the same gold light round each bolt as in the open rooms, here leaking round the wall plate (a click opens heaven).
  // Laid on after the shoulder, as a tint toward gold plus a little light, so it reads on the white walls too
  float g = (halo(p, boltAt(uRail.x), 1.7) + halo(p, boltAt(uRail.y), 5.3)) * uGlow;
  vec3 gold = vec3(1.0, 0.7, 0.28);
  return mix(col, gold, clamp(g * (t == 2 ? 0.3 : 0.5), 0.0, 0.7)) + gold * g * (t == 2 ? 0.35 : 0.12);
}

/* =============================== open rooms =============================== */
// ---- sky: cumulus on a perspective layer (horizon below the frame), lit from the upper left; faint cirrus above
vec2 skyPlane(vec2 p){
  float d = 1.0 / (1.75 - p.y / uRes.y);
  return vec2((p.x - uRes.x * 0.5) / uRes.y * d, d * 1.6);
}
float billow(vec2 q, int oct){
  float s = 0.0, a = 0.5;
  for (int i = 0; i < 5; i++){ if (i >= oct) break; s += a * abs(vn(q) * 2.0 - 1.0); q = q * 2.07 + vec2(13.7, 7.1); a *= 0.5; }
  return s;
}
float cloudField(vec2 s, float t, int oct){
  s.x -= t * 0.011;
  vec2 w = vec2(vn(s * 1.3 + vec2(0.0, t * 0.01)), vn(s * 1.3 + vec2(5.2, 1.3 - t * 0.008))) - 0.5;
  float banks = fbm3(s * 1.05 + vec2(1.7, 4.2));
  return banks * 1.15 + billow(s * 3.4 + w * 0.7, oct) * 0.6 - 0.5;
}
const float CLOUD_TH = 0.33;
vec3 skyColor(vec2 p){
  float W = uRes.x, H = uRes.y, t = uTime, y = p.y / H;
  vec3 zen = uZen, hor = uHor;
  vec3 col = mix(zen, hor, pow(smoothstep(-0.15, 1.2, y), 1.25));
  float sd = length(p - uSunP * uRes) / H;
  col += uSunC * 0.2 * exp(-sd * 1.7) * (1.0 - smoothstep(0.3, 0.9, uStars));      // the sun's glow (none at night)
  if (uStars > 0.01) {                                                  // night: stars and a shooting star now and then (no moon: owner)
    col += starField(p, t, 0.15) * uStars;
    col += vec3(1.0, 0.97, 0.9) * shootingStar(p, 1.0) * smoothstep(0.4, 0.9, uStars);
  }
  vec2 c2 = vec2(p.x / H * 0.8 - t * 0.004, y * 3.0);
  float cir = smoothstep(0.56, 0.86, fbm3(c2 * vec2(1.3, 1.0) + vec2(0.0, fbm3(c2 * 1.9) * 0.7)));
  col = mix(col, uCLit * vec3(0.96, 0.975, 1.0), cir * 0.28 * (1.0 - smoothstep(0.15, 0.75, y)));
  vec2 s = skyPlane(p);
  float f = cloudField(s, t, 5);
  float a = smoothstep(CLOUD_TH, CLOUD_TH + 0.045, f);
  if (a > 0.001) {
    float thick = smoothstep(CLOUD_TH, CLOUD_TH + 0.3, f);
    vec2 toSun = uToSun;
    float occ = 0.0;
    for (int i = 1; i <= 3; i++) occ += max(cloudField(s + toSun * float(i), t, 3) - CLOUD_TH, 0.0);
    float light = exp(-occ * 3.2);
    vec3 cloud = mix(uCShade, uCLit, clamp(light + (1.0 - thick) * 0.45, 0.0, 1.0));
    cloud += uSunC * 0.1 * exp(-sd * 1.4) * light;
    float haze = smoothstep(0.5, 1.1, y);
    cloud = mix(cloud, hor * 1.04, haze * 0.5);
    col = mix(col, cloud, a * (1.0 - haze * 0.3));
  }
  return col;
}

// ---- a shooting star about every 7 s: it always enters from the left, at a random height, angle and speed; a bright
// head, a tail that thins and fades, a short life. wk scales the width (the 8-bit lantern night passes its pixel size).
float shootingStar(vec2 p, float wk){
  float P = 7.0, c = floor(uTime / P), r1 = h21(vec2(c, 17.0)), r2 = h21(vec2(c, 29.0)), r3 = h21(vec2(c, 41.0));
  float life = 0.85 + 0.45 * r3, tt = uTime - c * P - 0.9 * r1;
  if (tt < 0.0 || tt > life) return 0.0;
  float ang = mix(0.06, 0.34, r2);                                    // a little downward, never the same twice
  vec2 dir = vec2(cos(ang), sin(ang)), a0 = vec2(-0.03 * uRes.x, mix(0.03, 0.24, r3) * uRes.y);   // across the upper sky
  vec2 head = a0 + dir * uRes.x * mix(0.95, 1.35, r1) * tt, d = p - head;
  float along = -dot(d, dir), across = abs(dot(d, vec2(-dir.y, dir.x))), tail = uRes.x * mix(0.12, 0.2, r2);
  float w = mix(1.3, 0.25, clamp(along / tail, 0.0, 1.0)) * wk;
  float streak = smoothstep(w + 0.7 * wk, w * 0.2, across) * step(-0.5 * wk, along) * pow(1.0 - clamp(along / tail, 0.0, 1.0), 1.6);
  float glow = exp(-length(d) / (2.2 * wk)) * 1.3;
  return (streak + glow) * smoothstep(0.0, 0.12, tt) * (1.0 - smoothstep(life * 0.65, life, tt));
}

// ---- galaxy: a Milky-Way band with coloured nebulae and dust lanes, three sizes of stars, turning very slowly
vec3 starField(vec2 p, float t, float band){
  vec3 acc = vec3(0.0);
  for (int L = 0; L < 3; L++){
    float fl = float(L), cell = L == 0 ? 7.0 : L == 1 ? 23.0 : 71.0;
    vec2 g = p / cell + fl * 19.0, id = floor(g), f = fract(g) - 0.5;
    float h = h21(id + cell);
    float dens = L == 0 ? 0.18 + 0.5 * band : L == 1 ? 0.22 + 0.25 * band : 0.3;
    if (h > dens) continue;
    vec2 o = (vec2(h21(id + 3.1), h21(id + 7.7)) - 0.5) * 0.8;
    vec2 d = (f - o) * cell;
    float r = length(d), sz = L == 0 ? 0.7 : L == 1 ? 1.1 : 1.6;
    float tw = 0.7 + 0.3 * sin(t * (0.8 + 2.5 * h21(id + 9.0)) + h * 50.0);
    float b = smoothstep(sz, 0.0, r) + (L == 2 ? (exp(-abs(d.x) * 2.2) * exp(-abs(d.y) * 0.35) + exp(-abs(d.y) * 2.2) * exp(-abs(d.x) * 0.35)) * 0.25 : 0.0);
    vec3 c = mix(vec3(0.75, 0.85, 1.0), vec3(1.0, 0.85, 0.65), h21(id + 5.0));
    acc += c * b * tw * (0.45 + 0.75 * h21(id + 2.0)) * (L == 2 ? 1.6 : 1.15);
  }
  return acc;
}
vec3 galaxyColor(vec2 p){
  float H = uRes.y, t = uTime;
  vec2 q = rot(t * 0.003) * ((p - uRes * 0.5) / H);
  vec2 dir = normalize(vec2(1.0, -0.42));
  float along = dot(q, dir), across = dot(q, vec2(-dir.y, dir.x)) + 0.05 * sin(along * 2.3);
  float band = exp(-pow(across / 0.26, 2.0));
  vec2 w = vec2(fbm3(q * 1.6 + 3.0), fbm3(q * 1.6 + 8.0));
  float neb = fbm(q * 2.4 + w * 1.2);
  vec3 col = vec3(0.006, 0.008, 0.024);
  vec3 nebC = mix(vec3(0.36, 0.12, 0.5), vec3(0.06, 0.3, 0.55), smoothstep(0.3, 0.7, w.x));
  nebC = mix(nebC, vec3(0.75, 0.25, 0.35), smoothstep(0.6, 0.8, w.y) * 0.5);
  col += nebC * pow(neb, 1.8) * (0.32 + 2.1 * band);
  col += vec3(1.0, 0.82, 0.62) * exp(-pow(across / 0.085, 2.0)) * exp(-pow((along - 0.12) / 0.6, 2.0)) * 0.55;
  float dust = smoothstep(0.47, 0.72, fbm(vec2(along * 4.0, across * 11.0) + 21.0)) * band;
  col *= 1.0 - 0.8 * dust;
  col += starField(q * H, t, band) * (1.0 - 0.6 * dust);
  return col;
}

// ---- digital rain: columns of mirrored katakana falling, a bright head and a fading trail, two depths
vec3 matrixColor(vec2 p){
  float t = uTime, k = uRes.y / 860.0;
  vec3 col = vec3(0.0, 0.018, 0.008);
  for (int L = 0; L < 2; L++){
    float fl = float(L), cw = (L == 0 ? 11.0 : 17.0) * k, ch = cw * 1.3;
    vec2 g = vec2(p.x / cw + fl * 0.5, p.y / ch), id = floor(g), f = fract(g);
    float cs = h21(vec2(id.x, fl * 7.0 + 1.0));
    float speed = mix(5.0, 13.0, cs) * (L == 0 ? 0.65 : 1.0);
    float len = mix(8.0, 28.0, h21(vec2(id.x, 3.0 + fl)));
    float period = uRes.y / ch + len + 18.0 * cs;
    float headY = mod(t * speed + cs * period * 7.0, period);
    float dist = headY - id.y;
    float lit = step(0.0, dist) * step(dist, len);
    float gi = floor(h21(id + floor(t * (1.5 + 7.0 * h21(id + 1.7)))) * 64.0);
    vec2 a = vec2(mod(gi, 8.0), floor(gi / 8.0));
    float glyph = texture2D(uGlyphs, (a + vec2(f.x, 1.0 - f.y) * 0.86 + 0.07) / 8.0).a;   // no mipmaps: safe per cell
    float fade = pow(clamp(1.0 - dist / len, 0.0, 1.0), 1.5);
    vec3 gc = dist < 1.0 ? vec3(0.78, 1.0, 0.86) : vec3(0.1, 0.95, 0.38) * fade;
    col += gc * glyph * lit * (L == 0 ? 0.42 : 1.0);
    col += vec3(0.05, 0.6, 0.22) * lit * fade * 0.05 * (L == 0 ? 0.5 : 1.0);                   // glow of the column
  }
  return col * (0.93 + 0.07 * sin(p.y * uDpr * 1.6));                                          // faint scanlines
}

// ---- night of floating lanterns, drawn as 8-bit pixel art: dithered sky, twinkling pixel stars, three depths of lanterns
vec3 lanternSprite(vec2 s, out float a){
  // a 7 x 9 sprite; s is the sprite pixel relative to its centre
  a = 0.0; vec3 c = vec3(0.0);
  float x = abs(s.x), y = s.y;
  if (y == -4.0 && x <= 1.0) { a = 1.0; c = vec3(0.22, 0.08, 0.06); }
  else if ((y == -3.0 || y == 3.0) && x <= 2.0) { a = 1.0; c = vec3(0.45, 0.13, 0.07); }
  else if (y >= -2.0 && y <= 2.0 && x <= ((y == -2.0 || y == 2.0) ? 2.0 : 3.0)) {
    a = 1.0;
    c = mix(vec3(1.0, 0.82, 0.42), vec3(0.88, 0.38, 0.12), x / 3.0);
    if (x == 2.0 && abs(y) <= 1.0) c *= 0.72;                                   // the ribs
    if (x == 0.0 && y == 0.0) c = vec3(1.0, 0.95, 0.7);                        // flame
  }
  else if (y == 4.0 && x == 0.0) { a = 1.0; c = vec3(0.95, 0.65, 0.2); }       // tassel
  return c;
}
vec3 lanternColor(vec2 p){
  float W = uRes.x, H = uRes.y, t = uTime;
  float px = max(2.0, floor(H / 200.0));
  vec2 c = floor(p / px), q = (c + 0.5) * px;
  float y = q.y / H, dth = bayer4(c);
  float band = floor(clamp(y * 1.05, 0.0, 1.0) * 5.0 + dth * 0.999);
  vec3 col = mix(vec3(0.02, 0.02, 0.085), vec3(0.24, 0.1, 0.3), band / 5.0);
  float sh = h21(c);
  if (sh > 0.996 - 0.003 * (1.0 - y)) col = mix(col, vec3(0.95, 0.92, 0.8), (0.55 + 0.45 * step(0.5, sin(t * 1.6 + sh * 90.0))) * (1.0 - y));
  col = mix(col, vec3(1.0, 0.96, 0.82), step(dth * 0.85 + 0.08, shootingStar(q, px * 0.95)));   // an 8-bit shooting star, dithered tail
  for (int L = 0; L < 3; L++){
    float fl = float(L), scale = fl + 1.0;
    float cell = (34.0 + 6.0 * fl) * scale * px;
    float speed = (5.0 + 3.0 * fl) * px * 0.5;
    vec2 g = vec2(q.x / cell, (q.y + t * speed) / cell) + fl * 17.0, id = floor(g), f = fract(g);
    if (h21(id + fl * 5.0) > 0.55 - 0.1 * fl) continue;
    vec2 o = vec2(0.25 + 0.5 * h21(id + 2.0), 0.25 + 0.5 * h21(id + 4.0));
    o.x += sin(t * 0.6 + h21(id) * 6.28) * 0.06;
    vec2 s = floor((f - o) * cell / (px * scale) + 0.5);
    float ga = 0.0;
    vec3 lc = lanternSprite(s, ga);
    float r = length(s);
    float glow = smoothstep(8.0, 2.5, r) * step(dth, 0.55 * smoothstep(8.0, 3.0, r));
    float depth = 1.0 - fl / 2.0;
    col += vec3(0.9, 0.45, 0.15) * glow * 0.22 * (1.0 - 0.5 * depth);
    lc = mix(lc, col, depth * 0.38);                                              // far lanterns fade into the night
    col = mix(col, lc, ga);
  }
  return col;
}

// ---- light around the bolts where the brackets meet an open room: a thin gold rim hugging the wall plate, as if lit
// from behind like an eclipse, a soft bloom, slow fine streamers and a faint anamorphic streak along the rail. It
// breathes at rest, brightens when a bolt is hovered and while a piece is lifted (uGlow); a click on it opens heaven.
vec2 boltAt(float x){
  float D = uRes.y * 0.5 / 0.267949, f = D / (D + uRailDepth);
  return uRes * 0.5 + (vec2(x + uRailOff.x, uRail.z + uRailOff.y) - uRes * 0.5) * f;
}
float halo(vec2 p, vec2 c, float seed){
  float D = uRes.y * 0.5 / 0.267949, rf = uRail.w * 2.5 * D / (D + uRailDepth);   // the flange's radius on screen
  vec2 d = p - c; float r = length(d), th = atan(d.y, d.x), e = max(r - rf, 0.0);
  float rim = exp(-pow((r - rf * 1.06) / (0.8 + rf * 0.07), 2.0));
  float bloom = exp(-e / (uS * 0.045)) * 0.55 + exp(-e / (uS * 0.16)) * 0.22;
  float rays = pow(vn(vec2(th * 5.0 + seed * 7.0, uTime * 0.12 + seed)), 3.0) * exp(-e / (uS * 0.11)) * smoothstep(rf * 0.9, rf * 1.3, r);
  float streak = exp(-abs(d.y) / 1.1) * exp(-abs(d.x) / (uS * 0.55)) * 0.45;
  return (rim * 1.25 + bloom + rays * 0.8 + streak) * (0.9 + 0.1 * sin(uTime * 1.3 + seed * 2.0));
}
vec3 openColor(int t, vec2 p){
  if (t == 4) return galaxyColor(p);
  if (t == 5) return matrixColor(p);
  if (t == 6) return lanternColor(p);
  return skyColor(p);
}
vec3 openRoom(int t, vec2 p){
  vec3 col = openColor(t, p);
  float g = halo(p, boltAt(uRail.x), 1.7) + halo(p, boltAt(uRail.y), 5.3);
  vec3 lc = mix(vec3(1.0, 0.74, 0.36), vec3(1.0, 0.95, 0.84), clamp(g - 0.6, 0.0, 1.0));   // gold, white-hot at the rim
  col += lc * g * uGlow * 0.85;
  return col + (h21(p * 1.37) - 0.5) / 255.0;
}

// ---- heaven (hidden; reached by clicking a glowing bolt): warm light from above, god rays, luminous clouds, rising motes
vec3 heavenColor(vec2 p){
  float W = uRes.x, H = uRes.y, t = uTime, y = p.y / H;
  vec2 d = p - vec2(0.5 * W, -0.3 * H); float r = length(d) / H, ang = atan(d.x, d.y);
  vec3 col = mix(vec3(0.99, 0.88, 0.62), vec3(0.86, 0.62, 0.34), smoothstep(0.0, 1.2, y));   // gold, deepening downward
  col += vec3(1.0, 0.97, 0.86) * 0.5 * exp(-r * 1.8);
  float rays = pow(fbm3(vec2(ang * 7.0, t * 0.04)), 2.2) * 1.6 + pow(vn(vec2(ang * 23.0, t * 0.1)), 4.0) * 0.7;
  col = mix(col * 0.86, col + vec3(1.0, 0.94, 0.75) * 0.35, clamp(rays * smoothstep(1.7, 0.15, r), 0.0, 1.0));   // god rays with shade between them
  vec2 s = skyPlane(p) + vec2(4.0, 2.0);
  float f = cloudField(s, t * 0.6, 4);
  float a = smoothstep(CLOUD_TH - 0.06, CLOUD_TH + 0.1, f) * smoothstep(0.18, 0.6, y);
  col = mix(col, mix(vec3(1.0, 0.84, 0.62), vec3(1.0, 0.99, 0.95), smoothstep(CLOUD_TH, CLOUD_TH + 0.32, f)), a * 0.88);
  vec2 mg = vec2(p.x + sin(t * 0.3) * 10.0, p.y + t * 14.0) / 34.0, id = floor(mg);
  float mote = smoothstep(0.08, 0.0, length(fract(mg) - 0.5 - (vec2(h21(id), h21(id + 3.0)) - 0.5) * 0.6)) * step(0.86, h21(id + 7.0));
  col += vec3(1.0, 0.95, 0.75) * mote * 0.9;
  return min(col, vec3(1.0)) + (h21(p * 1.37) - 0.5) / 255.0;
}

vec3 room(int t, vec2 p){ return t == 9 ? heavenColor(p) : (t == 1 || t == 4 || t == 5 || t == 6) ? openRoom(t, p) : wallRoom(t, p); }

void main(){
  vec2 p = vec2(gl_FragCoord.x, uRes.y * uDpr - gl_FragCoord.y) / uDpr;
  vec3 c = room(uTheme, p);
  if (uMix < 1.0) {
    float rmax = length(uRes) * 1.05;
    float d = length(p - uReveal) - uMix * rmax;
    vec3 prev = room(uPrev, p);
    c = mix(c, prev, smoothstep(-30.0, 30.0, d));
    c += vec3(1.0, 0.82, 0.42) * exp(-pow(d / 14.0, 2.0)) * 0.55 * (1.0 - uMix);
  }
  gl_FragColor = vec4(c, 1.0);
}`
};

/* OTK_ARMORY(root, opts) mounts one rack into `root` (a .armory element) and returns its API, including destroy().
   opts: garments (packed list), decor (logos, peg rail, hats), room (default room index), roomKey (localStorage key for
   the visitor's chosen room; null = don't remember), newTab (open product links in a new tab, default true).
   Needs window.THREE (r128) and window.OTK_BACKDROP. */
window.OTK_ARMORY = function (root, opts) {
'use strict';
opts = opts || {};
const DATA = opts.garments || [];
if (!root || !window.THREE || !DATA.length) return null;

const $ = s => root.querySelector(s);
const rackCanvas = $('.armory__gl--rack'), liftCanvas = $('.armory__gl--lift');
const labelEl = $('.armory__label'), veil = $('.armory__veil');
const soundBtn = $('.armory__sound'), hintEl = $('.armory__hint'), a11yList = $('.armory__a11y');
const ui = { count: $('.armory__count'), name: $('.armory__name'), sub: $('.armory__sub'), cta: $('.armory__cta'), drag: $('.armory__drag'),
  close: $('.armory__close'), prev: $('.armory__nav--prev'), next: $('.armory__nav--next') };

const REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
const COARSE = matchMedia('(hover: none)').matches;
if (COARSE && hintEl) hintEl.textContent = 'Tap a piece to turn it around. Tap again to take it off the rail. Swipe across the rail to brush through.';

const TAU = Math.PI * 2, HALF = Math.PI / 2;
const clamp = (v, a, b) => v < a ? a : v > b ? b : v;
const lerp = (a, b, t) => a + (b - a) * t;
const smooth = (a, b, x) => { const t = clamp((x - a) / (b - a), 0, 1); return t * t * (3 - 2 * t); };
const price = p => '$' + (Math.round(parseFloat(p) * 100) % 100 === 0 ? parseFloat(p).toFixed(0) : parseFloat(p).toFixed(2));
const priceOf = d => d.available === false ? 'Sold out' : d.priceText || price(d.price);

/* ---------------- renderers ---------------- */
const FOV = 30;
const mkRenderer = c => { const r = new THREE.WebGLRenderer({ canvas: c, antialias: true, alpha: true, premultipliedAlpha: true, powerPreference: 'high-performance' });
  r.setPixelRatio(Math.min(window.devicePixelRatio || 1, COARSE ? 1.5 : 2)); r.setClearColor(0x000000, 0); return r; };
let renA, renB;
try { renA = mkRenderer(rackCanvas); renB = mkRenderer(liftCanvas); } catch (e) { if (renA) renA.dispose(); root.classList.add('is-nogl'); return null; }
const scene = new THREE.Scene();
const cam = new THREE.PerspectiveCamera(FOV, 1, 1, 10000);

/* ---------------- shaders ---------------- */
const VERT = `
uniform vec4 uRect; uniform float uBend, uYawMode, uZ, uMinW, uShadow, uSpread;
uniform vec2 uPivot, uView, uShadowOff; uniform float uPivotZ, uYawTop, uYawHem, uSwing, uHem, uPitch, uRipple, uTime, uShoulder, uHemY, uShear, uWallZ, uSeed;
varying vec2 vQ; varying float vT, vYaw, vRip;
void main(){
  vec2 e = vec2(uShadow * uSpread * 3.4);
  vec2 q = mix(uRect.xy - e, uRect.zw + e, vec2(uv.x, 1.0 - uv.y));
  vQ = q;
  float t = clamp((q.y - uShoulder) / max(1.0, uHemY - uShoulder), 0.0, 1.0);
  float tb = t * uBend;
  float yaw = mix(uYawTop, uYawHem, pow(tb, 1.25));
  vYaw = yaw; vT = t;
  vec3 p;
  if (uYawMode > 0.5 && uYawMode < 1.5) {
    float c = cos(yaw), s = sin(yaw);
    if (uMinW > 0.0) c = (c < 0.0 ? -1.0 : 1.0) * max(abs(c), uMinW);
    p = vec3(q.x * c, q.y, -q.x * s + uZ);
  } else if (uYawMode > 1.5) {
    float c = cos(yaw), s = sin(yaw);
    p = vec3(-q.x * s, q.y, -q.x * c + uZ);
  } else {
    p = vec3(q.x, q.y, uZ);
  }
  // resting drape: soft vertical folds that only read when the fabric turns
  float fold = sin(q.x * 0.045 + uSeed) * 0.012 * (uHemY - uShoulder) * tb;
  p.z += fold;
  float ph = uv.x * 7.0 + uTime * 7.5 + t * 4.5 + uSeed;
  p.z += uRipple * sin(ph) * tb;
  vRip = uRipple * cos(ph) * tb;
  float a = uSwing + (uHem - uSwing) * pow(tb, 1.6);
  float ca = cos(a), sa = sin(a);
  vec2 r = vec2(p.x * ca + p.y * sa, -p.x * sa + p.y * ca);
  float b = uPitch * (0.55 + 0.45 * tb);
  float y3 = r.y * cos(b);
  float z3 = p.z - r.y * sin(b);
  vec3 w = vec3(uPivot.x + r.x - uView.x * 0.5, uView.y * 0.5 - (uPivot.y + y3), uPivotZ + z3);
  if (uShadow > 0.5) { w.x += uShadowOff.x; w.y -= uShadowOff.y; w.z = uWallZ; }
  gl_Position = projectionMatrix * viewMatrix * vec4(w, 1.0);
}`;
const FRAG = `
uniform sampler2D uTexA, uTexB; uniform vec4 uRectA, uRectB; uniform float uMode, uAlpha, uShadow, uSpread, uWF, uWS, uHasSide, uYawMid; uniform vec2 uLight;
uniform vec4 uCut; uniform vec3 uRecolor, uRecolorBase; uniform float uRecolorOn;
float faceVis(float yaw){ if (uHasSide < 0.5) return 1.0; float af = uWF * abs(cos(yaw)), as = uWS * abs(sin(yaw)); return step(0.5, af / (af + as + 0.001)); }
float hash(vec2 p){ p = floor(p); return fract(52.9829189 * fract(dot(p, vec2(0.06711056, 0.00583715)))); }
varying vec2 vQ; varying float vT, vYaw, vRip;
vec4 samp(sampler2D t, vec2 q, vec4 r, float bias){
  vec2 uv = (q - r.xy) / (r.zw - r.xy);
  // sample BEFORE the range test: inside a branch the mip level is undefined where a 2x2 pixel block straddles the
  // rect edge, and real GPUs (Apple/Metal) then read a tiny mip, drawing a faint line of the shirt's average colour
  // around every texture rect (the "rectangles"). Software GL never showed it.
  vec4 c = texture2D(t, vec2(uv.x, 1.0 - uv.y), bias);
  return (uv.x < 0.0 || uv.x > 1.0 || uv.y < 0.0 || uv.y > 1.0) ? vec4(0.0) : c;
}
void main(){
  if (uShadow > 0.5) {
    float acc = 0.0;
    float rot = hash(gl_FragCoord.xy) * 6.2832;
    for (int i = 0; i < 20; i++) {
      float fi = float(i) + 0.5;
      float an = fi * 2.39996 + rot; float rr = sqrt(fi / 20.0) * uSpread * 2.6;
      vec2 o = vec2(cos(an), sin(an)) * rr;
      if (uMode < 0.5) acc += max(samp(uTexA, vQ + o, uRectA, 3.0).a, samp(uTexB, vec2(-vQ.x, vQ.y) + o, uRectB, 3.0).a);
      else acc += samp(uTexA, vQ + o, uRectA, 3.0).a;
    }
    float a = acc / 20.0 * uAlpha; if (a < 0.003) discard; gl_FragColor = vec4(0.0, 0.0, 0.0, a); return;
  }
  float bias = 0.0;
  vec4 c; vec3 n = vec3(0.0, 0.0, 1.0);
  if (uMode < 0.5) {
    if (gl_FrontFacing) { c = samp(uTexA, vQ, uRectA, bias); n = vec3(sin(vYaw), 0.0, cos(vYaw)); }
    else { c = samp(uTexB, vec2(-vQ.x, vQ.y), uRectB, bias); n = -vec3(sin(vYaw), 0.0, cos(vYaw)); }
  } else if (uMode < 1.5) {
    n = vec3(cos(vYaw), 0.0, -sin(vYaw));
    if (gl_FrontFacing) c = samp(uTexA, vQ, uRectA, bias); else { c = samp(uTexB, vec2(-vQ.x, vQ.y), uRectB, bias); n = -n; }
  } else {
    c = samp(uTexA, vQ, uRectA, bias);
  }
  if (uRecolorOn > 0.5) {                       // colourway preview: fabric-coloured pixels take the new dye, the print stays
    vec3 rgb = c.rgb / max(c.a, 0.001);
    float l = dot(rgb, vec3(0.299, 0.587, 0.114)), lb = max(dot(uRecolorBase, vec3(0.299, 0.587, 0.114)), 0.03);
    float fab = (1.0 - smoothstep(0.05, 0.16, length(rgb / max(l, 0.03) - uRecolorBase / lb))) * smoothstep(0.08, 0.28, l);
    c.rgb = mix(rgb, rgb * uRecolor, fab) * c.a;
  }
  if (uCut.x > 0.5) {                           // the drop bag unzipping: a V opens down from the top along the zipper
    float zp = uCut.z + uCut.y * uCut.w, hwc = max(zp - vQ.y, 0.0) * 0.45;
    if (vQ.y < zp && abs(vQ.x) < hwc) discard;
    c.rgb *= 1.0 - 0.55 * step(vQ.y, zp) * smoothstep(hwc + 7.0, hwc, abs(vQ.x));   // dark lining at the opened edges
  }
  if (uMode < 1.5) { float fv = faceVis(uYawMid); float h = clamp(hash(gl_FragCoord.xy), 0.002, 0.998); if (uMode < 0.5 ? h > fv : h <= fv) discard; }
  n.x += vRip * 0.05; n = normalize(n);
  vec3 L = normalize(vec3(uLight.x, 0.55, 1.0));
  float diff = max(dot(n, L), 0.0);
  float shade = (0.58 + 0.46 * diff) * mix(1.04, 0.9, vT);
  if (uMode > 1.5) shade = 1.0;
  float a = c.a * uAlpha;
  if (a < 0.02) discard;
  gl_FragColor = vec4(c.rgb * shade * uAlpha, a);
}`;

const globals = { uView: { value: new THREE.Vector2(1, 1) }, uTime: { value: 0 }, uHookJ: { value: new THREE.Vector2(10, 20) }, uWallZ: { value: -46 }, uSpread: { value: 6 }, uOpen: { value: 0 },
  uEnvTop: { value: new THREE.Vector3(0.3, 0.5, 0.82) }, uEnvHor: { value: new THREE.Vector3(0.7, 0.82, 0.94) }, uEnvLow: { value: new THREE.Vector3(0.33, 0.35, 0.32) }, uEnvSun: { value: 1 } };

/* ---------------- textures ---------------- */
const loader = new THREE.TextureLoader();
let pending = 0;
const textures = [];
const loadTex = src => { pending++; const t = loader.load(src, () => { pending--; }, undefined, () => { pending--; }); textures.push(t);
  t.minFilter = THREE.LinearMipmapLinearFilter; t.magFilter = THREE.LinearFilter; t.generateMipmaps = true; t.anisotropy = 4; t.premultiplyAlpha = true; return t; };
const canvasTex = c => { const t = new THREE.CanvasTexture(c); t.minFilter = THREE.LinearMipmapLinearFilter; t.generateMipmaps = true; return t; };


/* ---------------- metal: hooks + rail are real 3D geometry ---------------- */
const METAL_VERT = `
uniform vec2 uPivot, uView, uRailOff, uHookJ; uniform float uPivotZ, uSwing, uPitch, uRail, uHookYaw, uHookExt, uHookZ;
varying vec3 vN; varying vec3 vP;
void main(){
  vec3 p = position; vec3 n = normal;
  vec3 w;
  // the straight shank (below uHookJ.x, down to uHookJ.y at the collar) stretches by uHookExt: with the front to you it
  // runs on through the neck opening into the top of the hanger bar
  if (uRail < 0.5 && p.y > uHookJ.x) p.y = uHookJ.x + (p.y - uHookJ.x) * (1.0 + uHookExt / max(1.0, uHookJ.y - uHookJ.x));
  // the straight shank comes forward to just in front of its own shirt (each tee hangs a little in front of the last,
  // uZ): otherwise the shirt hid its lower end and only the stem painted in the texture showed, thin, under a thick hook
  float zf = uRail < 0.5 ? uHookZ * smoothstep(uHookJ.x - 2.0, uHookJ.x + 6.0, p.y) : 0.0;
  if (uRail > 0.5) {
    w = vec3(p.x + uPivot.x - uView.x * 0.5 + uRailOff.x, uView.y * 0.5 - (uPivot.y + uRailOff.y) + p.y, p.z);
  } else {
    float ch = cos(uHookYaw), shh = sin(uHookYaw);
    p = vec3(p.x * ch + p.z * shh, p.y, -p.x * shh + p.z * ch);
    n = vec3(n.x * ch + n.z * shh, n.y, -n.x * shh + n.z * ch);
    float ca = cos(uSwing), sa = sin(uSwing);
    vec2 r = vec2(p.x * ca + p.y * sa, -p.x * sa + p.y * ca);
    vec2 rn = vec2(n.x * ca + n.y * sa, -n.x * sa + n.y * ca);
    float cb = cos(uPitch), sb = sin(uPitch);
    float y3 = r.y * cb + p.z * sb, z3 = p.z * cb - r.y * sb;
    float ny = rn.y * cb + n.z * sb, nz = n.z * cb - rn.y * sb;
    w = vec3(uPivot.x + r.x - uView.x * 0.5, uView.y * 0.5 - (uPivot.y + y3), uPivotZ + z3 + zf);
    n = vec3(rn.x, -ny, nz);
  }
  vN = n; vP = w;
  gl_Position = projectionMatrix * viewMatrix * vec4(w, 1.0);
}`;
const METAL_FRAG = `
uniform vec2 uLight; uniform vec3 uBase; uniform float uAlpha, uOpen, uEnvSun; uniform vec3 uEnvTop, uEnvHor, uEnvLow;
varying vec3 vN; varying vec3 vP;
vec3 env(vec3 r){
  // the room around the rack: bright ceiling + softbox above, limestone wall behind, a pale floor below
  float up = r.y;
  vec3 sky = mix(vec3(0.84, 0.85, 0.86), vec3(1.0), smoothstep(0.05, 0.7, up));
  vec3 floorC = mix(vec3(0.36, 0.35, 0.34), vec3(0.62, 0.61, 0.59), smoothstep(-1.0, -0.05, up));
  vec3 c = up > 0.0 ? sky : floorC;
  c = mix(c, vec3(0.80, 0.79, 0.76), smoothstep(0.0, -0.7, r.z) * (1.0 - smoothstep(0.35, 0.8, abs(up))));
  c -= vec3(0.28) * exp(-pow((up + 0.04) / 0.05, 2.0));                           // the dark seam under the horizon
  c += vec3(0.45) * exp(-pow((up - 0.04) / 0.03, 2.0));                           // crisp horizon highlight
  c += vec3(1.5) * exp(-pow((r.x - uLight.x * 0.5) / 0.22, 2.0) - pow((up - 0.55) / 0.2, 2.0)); // softbox
  // open rooms (no wall): the chrome mirrors that room's surroundings: sky above, its horizon, what lies below
  vec3 o = up > 0.0 ? mix(uEnvHor, uEnvTop, smoothstep(0.0, 0.75, up)) : mix(uEnvLow, uEnvHor, smoothstep(-1.0, -0.05, up));
  o += vec3(1.6) * uEnvSun * exp(-pow((r.x + 0.45) / 0.2, 2.0) - pow((up - 0.6) / 0.18, 2.0));   // the sun, upper left
  return mix(c, o, uOpen);
}
void main(){
  vec3 n = normalize(vN); if (!gl_FrontFacing) n = -n;
  vec3 V = vec3(0.0, 0.0, 1.0);
  vec3 R = reflect(-V, n);
  vec3 L = normalize(vec3(uLight.x, 0.8, 0.9));
  float spec = pow(max(dot(reflect(-L, n), V), 0.0), 120.0);
  float fres = 0.65 + 0.35 * pow(1.0 - max(n.z, 0.0), 2.0);
  vec3 col = env(R) * uBase * fres + vec3(1.0) * spec * 1.2;
  gl_FragColor = vec4(col * uAlpha, uAlpha);
}`;
let hookGeo = new THREE.BufferGeometry();
function mkMetal(sh, rail) {
  const u = { uPivot: sh ? sh.uPivot : { value: new THREE.Vector2() }, uPivotZ: sh ? sh.uPivotZ : { value: 0 }, uSwing: sh ? sh.uSwing : { value: 0 },
    uPitch: sh ? sh.uPitch : { value: 0 }, uLight: sh ? sh.uLight : { value: new THREE.Vector2() }, uView: globals.uView,
    uRailOff: { value: new THREE.Vector2() }, uRail: { value: rail ? 1 : 0 }, uHookYaw: sh ? sh.uHookYaw : { value: 0 }, uHookExt: sh ? sh.uHookExt : { value: 0 }, uHookZ: sh ? sh.uHookZ : { value: 0 }, uHookJ: globals.uHookJ, uAlpha: { value: 1 }, uOpen: globals.uOpen, uEnvTop: globals.uEnvTop, uEnvHor: globals.uEnvHor, uEnvLow: globals.uEnvLow, uEnvSun: globals.uEnvSun,
    uBase: { value: rail ? new THREE.Color(0.93, 0.95, 0.98) : new THREE.Color(0.92, 0.94, 0.97) } };
  return new THREE.ShaderMaterial({ uniforms: u, vertexShader: METAL_VERT, fragmentShader: METAL_FRAG, transparent: false, side: THREE.DoubleSide });
}
const railMat = mkMetal(null, true);
const railMesh = new THREE.Mesh(new THREE.BufferGeometry(), railMat); railMesh.frustumCulled = false; railMesh.renderOrder = -50; scene.add(railMesh);
function buildMetal() {
  // hook: a wire that curls OVER the rail (front to back, tip hidden behind it), swings back under the rail's centre and
  // drops straight into the collar. The shank stays on the hook's own axis (x = z = 0), so however the hook and the tee
  // turn (the viewer turns the hook to show its curl), it always lands on the hanger at the collar. Heights only ever
  // increase down the shank: an earlier path doubled back above the collar and showed as a kink in the viewer.
  const wire = Math.max(1.8, S * 0.0105), rr = (railRad + wire * 0.5 + 0.8) / Math.cos(0.26);
  const end = hangDrop + S * 0.004, yJ = Math.min(rr * 2.1, end * 0.72);   // where the bend meets the straight shank
  const pts = [
    [0, rr * 0.75, -rr * 0.9], [0, 0, -rr], [0, -rr * 0.71, -rr * 0.71], [0, -rr, 0], [0, -rr * 0.71, rr * 0.71], [0, 0, rr],
    [0, yJ * 0.45, rr * 0.82], [0, yJ * 0.8, rr * 0.32], [0, yJ, 0], [0, lerp(yJ, end, 0.5), 0], [0, end, 0]
  ].map(p => new THREE.Vector3(p[0], p[1], p[2]));
  const curve = new THREE.CatmullRomCurve3(pts, false, 'centripetal');
  const g = new THREE.TubeGeometry(curve, 64, wire / 2, 10, false);
  globals.uHookJ.value.set(yJ + 0.5, end);
  G.forEach(x => { if (x.parts && x.parts.hook) x.parts.hook.geometry = g; });
  if (hookGeo) hookGeo.dispose(); hookGeo = g;
  // rail: a real cylinder so the hook tip can pass behind it
  const len = (railR - railL) - railRad * 1.2;
  const cyl = new THREE.CylinderGeometry(railRad, railRad, len, 28, 1, false); cyl.rotateZ(Math.PI / 2);
  railMesh.geometry.dispose(); railMesh.geometry = cyl;
  railMat.uniforms.uPivot.value.set((railL + railR) / 2, railY);
}

/* ---------------- sizing ---------------- */
let W = 1, H = 1, S = 200, D = 1000, railY = 200, railL = 0, railR = 1, railRad = 5, hangDrop = 20, Lb = 100, spacing = 70, visibleN = DATA.length, inset = 0;

/* ---------------- garments ---------------- */
const shared = () => ({
  uPivot: { value: new THREE.Vector2() }, uPivotZ: { value: 0 }, uYawTop: { value: HALF }, uYawHem: { value: HALF },
  uSwing: { value: 0 }, uHem: { value: 0 }, uPitch: { value: 0 }, uRipple: { value: 0 }, uShoulder: { value: 0 }, uHemY: { value: 1 },
  uShear: { value: 0 }, uHookYaw: { value: 0.45 }, uHookExt: { value: 0 }, uHookZ: { value: 1.5 }, uWF: { value: 1 }, uWS: { value: 1 }, uYawMid: { value: HALF }, uHasSide: { value: 1 }, uLight: { value: new THREE.Vector2(0, 0) }, uShadowOff: { value: new THREE.Vector2(8, 20) }, uSeed: { value: Math.random() * 6 },
  uCut: { value: new THREE.Vector4(0, 0, 0, 1) }, uRecolor: { value: new THREE.Vector3(1, 1, 1) }, uRecolorBase: { value: new THREE.Vector3(1, 1, 1) }, uRecolorOn: { value: 0 }
});
const geoBend = new THREE.PlaneGeometry(1, 1, 14, 26), geoFlat = new THREE.PlaneGeometry(1, 1, 1, 1);
function mkMat(sh, o) {
  const u = Object.assign({}, sh, globals, {
    uRect: { value: new THREE.Vector4() }, uRectA: { value: new THREE.Vector4() }, uRectB: { value: new THREE.Vector4() },
    uTexA: { value: o.texA || null }, uTexB: { value: o.texB || null }, uMode: { value: o.mode }, uAlpha: { value: 1 },
    uShadow: { value: o.shadow ? 1 : 0 }, uBend: { value: o.bend ? 1 : 0 }, uYawMode: { value: o.yaw === 'side' ? 2 : o.yaw ? 1 : -1 }, uZ: { value: o.z || 0 }, uMinW: { value: o.minW || 0 }
  });
  const m = new THREE.ShaderMaterial({ uniforms: u, vertexShader: VERT, fragmentShader: FRAG, transparent: true, premultipliedAlpha: true,
    depthWrite: !o.shadow, depthTest: true, side: o.mode === 0 ? THREE.DoubleSide : THREE.DoubleSide });
  return m;
}

function mkGarment(d, i) {
  const sh = shared();
  const v = d.views, heroBack = d.hero === 'back';
  const front = v.front, back = v.back || v.front, side = v.side || null, sideR = v.sideR || v.side || null;
  const texF = loadTex(front.src), texB = v.back ? loadTex(back.src) : texF, texS = side ? loadTex(side.src) : null, texSR = v.sideR ? loadTex(v.sideR.src) : texS;
  const parts = {};
  parts.shadowFace = new THREE.Mesh(geoBend, mkMat(sh, { mode: 0, texA: texF, texB: texB, shadow: true, bend: true, yaw: true }));
  if (side) parts.shadowSide = new THREE.Mesh(geoBend, mkMat(sh, { mode: 1, texA: texS, texB: texSR, shadow: true, bend: true, yaw: 'side' }));
  parts.face = new THREE.Mesh(geoBend, mkMat(sh, { mode: 0, texA: texF, texB: texB, bend: true, yaw: true, z: i * 0.55 }));
  if (side) parts.side = new THREE.Mesh(geoBend, mkMat(sh, { mode: 1, texA: texS, texB: texSR, bend: true, yaw: 'side', z: i * 0.55 }));
  parts.hook = new THREE.Mesh(hookGeo, mkMetal(sh));
  sh.uHasSide.value = side ? 1 : 0;
  sh.uHookZ.value = i * 0.55 + 1.5;   // just in front of this tee's face (z = i * 0.55)
  Object.values(parts).forEach(m => { m.frustumCulled = false; scene.add(m); });
  const restYaw = side ? -HALF + (Math.random() - 0.5) * 0.06 : (heroBack ? Math.PI - 1.3 : 1.3);
  const [name, sub] = d.display || [d.title, ''];
  return {
    i, d, name, sub, sh, parts, side: !!side, heroYaw: heroBack ? Math.PI : 0, restYaw,
    x: 0, vx: 0, ax: 0, tx: 0, y: -400, vy: 0, z: 0, vz: 0, zJit: 0,
    hookYaw: (i % 2 ? 1 : -1) * (0.17 + Math.random() * 0.07), hookYawV: 0, hookRest: 0, yaw: restYaw, yawV: 0, yawH: restYaw, yawHV: 0, yawTarget: restYaw,
    phi: (Math.random() - 0.5) * 0.02, phiV: 0, hem: 0, hemV: 0, pitch: 0, pitchV: 0, rip: 0, torque: 0,
    state: 'wait', delay: 0, layer: 0, wF: 1, wS: 1, liftT: 0, flightT: 0, visible: true, lastClink: 0, sideA: 1, faceA: 0,
    rects: { front, back, side, sideR: v.sideR || side }, kind: 'tee', order: i
  };
}
const G = DATA.map(mkGarment);
/* the next drop: a zipped garment bag on the rail with a countdown tag; at release it unzips and the tee inside joins
   the rack (opts.drop from the section settings; ?armory-drop=now previews the reveal a few seconds after load).
   With no drop scheduled, opts.drop.placeholder hangs the bag empty: "Next drop, coming soon", no countdown. */
const PLACEHOLDER = { title: 'Next drop', display: ['Next drop', 'Coming soon'], price: '', placeholder: true,
  verse: 'Behold, I make all things new.', ref: 'Revelation 21:5' };
const DROP = (() => {
  const dr = opts.drop; if (!dr || !dr.bag) return null;
  const time = opts.dropPreview ? Date.now() + 7000 : dr.time;
  const real = !!dr.garment && time > Date.now();
  if (!real && !dr.placeholder) return null;
  const views = dr.bag.back ? { front: dr.bag, back: dr.bag.back } : { front: dr.bag };
  const bag = mkGarment(Object.assign({}, real ? dr.garment : PLACEHOLDER, { hero: 'front', views }), G.length);
  // it hangs back-out like the tees hang side-on; hovering turns it round to its zip and OTK mark
  bag.kind = 'bag'; bag.order = -1; bag.restYaw = bag.yaw = bag.yawH = bag.yawTarget = dr.bag.back ? Math.PI - 0.35 : 0.42; bag.heroYaw = 0; G.push(bag);
  if (!real) return { placeholder: true, time: dr.time > Date.now() ? dr.time : 0, bag, tee: null, state: 'zipped', t: 0, focusT: 0 };
  const tee = mkGarment(dr.garment, G.length); tee.kind = 'drop'; tee.order = -1; tee.visible = false; G.push(tee);
  Object.values(tee.parts).forEach(m => { if (m.material.uniforms.uZ) m.material.uniforms.uZ.value = bag.i * 0.55 - 0.3; });
  return { time, bag, tee, state: 'zipped', t: 0, focusT: 0 };
})();

// the drop bag hangs at the far left end of the rail, apart from the tees: BAG_ROOM (in S) is the rail it takes
const BAG_ROOM_WIDE = 1.05, BAG_ROOM_PHONE = 0.9;
// how many tees hang on this width (the bag is extra): phones 4-5, tablets 7-8, small laptops 11, wider screens all
const teesFor = (n, bag) => W < 640 ? Math.min(bag ? 4 : 5, n) : W < 980 ? Math.min(bag ? 7 : 8, n) : W < 1280 ? Math.min(11, n) : n;
let BAG_ROOM = BAG_ROOM_WIDE;
const bagOnRail = () => G.some(g => g.kind === 'bag');
let teeCX = 0, railC = 0;
function layoutMetrics() {
  const r = root.getBoundingClientRect(); W = Math.max(320, r.width); H = Math.max(480, r.height);
  inset = parseFloat(getComputedStyle(root).getPropertyValue('--armory-inset')) || 0;
  BAG_ROOM = W < 640 ? BAG_ROOM_PHONE : BAG_ROOM_WIDE;   // phones are tight: less of a gap
  const nT = G.filter(g => g.kind === 'tee').length, bagK = bagOnRail() ? BAG_ROOM : 0;
  visibleN = teesFor(nT, !!bagK);
  // a long, well-stocked rail: on wide screens it spans most of the width and the tees hang a little closer once
  // there are many (15 since 2026-10-03), so they keep a good size
  const many = visibleN > 10;
  const railLen = Math.min(W * (W < 640 ? (bagOnRail() ? 0.95 : 0.92) : many ? 0.9 : 0.8), 1700);
  const headEl = $('.armory__head'), headB = headEl.offsetTop + headEl.offsetHeight;
  layoutRacks();
  if (W <= 760) racks.forEach(rk => { rk.el.style.top = (headB + 6) + 'px'; rk.el.style.bottom = 'auto'; });   // phones: above the rail, under the title
  else racks.forEach(rk => { rk.el.style.top = ''; rk.el.style.bottom = ''; });
  const shelfEl = $('.armory__rack--l'), shelfB = shelfEl ? shelfEl.offsetTop + shelfEl.offsetHeight + (W > 760 ? 20 : 26) : 0;
  railY = Math.max(H * (W < 640 ? 0.36 : 0.33), headB + 40, shelfB + 36);
  const pack = W < 640 ? 0.36 : many ? 0.34 : 0.385;
  const slack = bagK || (W >= 980 ? 1.05 : 0);   // desktop: the tees keep the size they had beside the bag
  const sW = railLen / (visibleN * pack + (W < 640 ? 1.05 : 0.85) + slack);
  const sH = (H - railY - 150) / 1.08;
  S = Math.max(70, Math.min(sW, sH, 420));
  hangDrop = S * 0.1; Lb = S * 0.5; spacing = S * pack;
  railRad = clamp(S * 0.018, 3.5, 7.5);
  const usedLen = Math.min(railLen, visibleN * spacing + S * (1.1 + bagK));
  railC = W / 2;   // the rack stays centred on the page (owner); the knight sits below the tees at the right
  railL = railC - usedLen / 2; railR = railC + usedLen / 2;
  D = (H / 2) / Math.tan((FOV / 2) * Math.PI / 180);
  cam.aspect = W / H; cam.position.set(0, 0, D); cam.near = 10; cam.far = D * 4; cam.updateProjectionMatrix();
  renA.setSize(W, H, false); renB.setSize(W, H, false);
  globals.uView.value.set(W, H); globals.uSpread.value = Math.max(4, S * 0.04); globals.uWallZ.value = -Math.max(30, S * 0.17);
  layoutDecor();
  buildMetal();
  layoutDecor(); buildBrackets();
  G.forEach(g => {
    g.visible = true;
    const f = g.rects.front, b = g.rects.back, s = g.rects.side;
    // a hoodie's hood stands above its neckline: the piece hangs from the neck, `lift` (frame widths) below its top
    const rectOf = v => { const y0 = hangDrop - (v.lift || 0) * S; return [(v.bb[0] - v.neck) * S, y0, (v.bb[2] - v.neck) * S, y0 + (v.bb[3] - v.bb[1]) * S]; };
    const rf = rectOf(f), rb = rectOf(b);
    const union = [Math.min(rf[0], -rb[2]), Math.min(rf[1], rb[1]), Math.max(rf[2], -rb[0]), Math.max(rf[3], rb[3])];
    g.wF = (f.bb[2] - f.bb[0]) * S; g.h = (f.bb[3] - f.bb[1] - (f.lift || 0)) * S; g.lift = (f.lift || 0) * S;   // h: neck to hem
    g.wS = s ? (s.bb[2] - s.bb[0]) * S : 0;
    const set = (m, rect, a, b2) => { if (!m) return; const u = m.material.uniforms; u.uRect.value.set(...rect); u.uRectA.value.set(...(a || rect)); u.uRectB.value.set(...(b2 || rect)); };
    set(g.parts.face, union, rf, rb); set(g.parts.shadowFace, union, rf, rb);
    if (s) { const rs = rectOf(s), rr = rectOf(g.rects.sideR); set(g.parts.side, rs, rs, rr); set(g.parts.shadowSide, rs, rs, rr); }
    g.sh.uWF.value = g.wF; g.sh.uWS.value = g.wS || 1;
    g.sh.uShoulder.value = hangDrop + S * 0.13; g.sh.uHemY.value = hangDrop + g.h; g.sh.uShear.value = S * 0.12;
  });
  assignSlots(true);
  if (!introDone && !REDUCED) G.forEach(g => { if (g.state === 'wait') g.y = railY - S * 1.4 - 160; });
  title.prepare();
  if (tagFocus) tagFocus.size();
  if (dropTag) dropTag.size();
  if (knight) knight.layout();
}

// which tees hang on the rail (in order), which are visible on this width, and their rest x; the drop bag, if any, at
// the far left end of the rail with a gap before the first tee
function assignSlots(snap) {
  const slots = G.filter(g => g.kind === 'tee').sort((a, b) => a.order - b.order || a.i - b.i), bag = G.find(g => g.kind === 'bag');
  visibleN = teesFor(slots.length, !!bag);
  G.forEach(g => { g.visible = slots.indexOf(g) >= 0 && slots.indexOf(g) < visibleN; });
  if (bag) bag.visible = true;
  if (DROP && (DROP.state === 'unzip')) DROP.tee.visible = true;
  if (DROP && DROP.bag.kind === 'falling') DROP.bag.visible = true;
  const vis = slots.filter(g => g.visible);
  teeCX = railC + (bag ? BAG_ROOM * S / 2 : 0);
  const put = (g, x) => { g.rest = x; if (snap && (g.state === 'hung' || g.state === 'wait')) { g.x = x; g.tx = x; } };
  vis.forEach((g, k) => put(g, teeCX + (k - (vis.length - 1) / 2) * spacing));
  if (bag) put(bag, railL + S * 0.5);
}

/* ---------------- sound ---------------- */
const Sound = {
  ctx: null, on: false, slideGain: null, swishGain: null,
  init() {
    if (this.ctx) return; const AC = window.AudioContext || window.webkitAudioContext; if (!AC) return;
    const ctx = this.ctx = new AC(); const len = ctx.sampleRate * 2, buf = ctx.createBuffer(1, len, ctx.sampleRate), d = buf.getChannelData(0);
    for (let i = 0; i < len; i++) d[i] = Math.random() * 2 - 1;
    this.noise = buf; this.master = ctx.createGain(); this.master.gain.value = 0.9; this.master.connect(ctx.destination);
    const mkLoop = (type, f, q) => { const src = ctx.createBufferSource(); src.buffer = buf; src.loop = true; const fl = ctx.createBiquadFilter(); fl.type = type; fl.frequency.value = f; fl.Q.value = q;
      const g = ctx.createGain(); g.gain.value = 0; src.connect(fl).connect(g).connect(this.master); src.start(); return g; };
    this.slideGain = mkLoop('bandpass', 3400, 1.4); this.swishGain = mkLoop('lowpass', 700, 0.5);
  },
  clink(v) {
    if (!this.on || !this.ctx) return; const ctx = this.ctx, t = ctx.currentTime, k = 0.9 + Math.random() * 0.25;
    [[2350, 1, .26], [3720, .55, .17], [5480, .35, .1], [7900, .18, .06]].forEach(([f, a, dec]) => {
      const o = ctx.createOscillator(), g = ctx.createGain(); o.frequency.value = f * k; o.type = 'sine';
      g.gain.setValueAtTime(0, t); g.gain.linearRampToValueAtTime(0.09 * a * v, t + 0.002); g.gain.exponentialRampToValueAtTime(0.0001, t + dec);
      o.connect(g).connect(this.master); o.start(t); o.stop(t + dec + 0.02);
    });
  },
  thud(v) {
    if (!this.on || !this.ctx) return; const ctx = this.ctx, t = ctx.currentTime;
    const s = ctx.createBufferSource(); s.buffer = this.noise; const f = ctx.createBiquadFilter(); f.type = 'lowpass'; f.frequency.value = 420; const g = ctx.createGain();
    g.gain.setValueAtTime(0.25 * v, t); g.gain.exponentialRampToValueAtTime(0.0001, t + 0.14); s.connect(f).connect(g).connect(this.master); s.start(t); s.stop(t + 0.16);
  },
  update(slide, swish) {
    if (!this.ctx) return; const t = this.ctx.currentTime;
    this.slideGain.gain.setTargetAtTime(this.on ? clamp(slide, 0, 1) * 0.05 : 0, t, 0.05);
    this.swishGain.gain.setTargetAtTime(this.on ? clamp(swish, 0, 1) * 0.12 : 0, t, 0.06);
  }
};
if (soundBtn) soundBtn.addEventListener('click', () => {
  Sound.init(); Sound.on = !Sound.on; if (Sound.ctx && Sound.ctx.state === 'suspended') Sound.ctx.resume();
  soundBtn.setAttribute('aria-pressed', String(Sound.on)); soundBtn.querySelector('span').textContent = Sound.on ? 'Sound on' : 'Sound off';
  soundBtn.querySelector('.w').setAttribute('opacity', Sound.on ? '1' : '.25'); if (Sound.on) Sound.clink(0.8);
});

/* ---------------- interaction state ---------------- */
const P = { x: -9999, y: -9999, vx: 0, vy: 0, inside: false, t: 0, down: false, type: 'mouse' };
let labelX = 0, labelFor = -1;
let focus = -1, kbdFocus = false, unfocusTimer = 0, lifted = -1, introDone = false, running = false, lightX = 0, rail = { ox: 0, ov: 0, oy: 0, oyv: 0, ax: 0, grab: false, gx: 0 };
let viewerDrag = null, dragHintGone = false, tapStart = null;

function bodyRect(g) {
  const w = Math.max(g.wv || g.wS || g.wF * 0.4, S * 0.18);
  const cx = g.x + rail.ox + Math.sin(g.phi) * Lb * 0.6;
  return { l: cx - w / 2, r: cx + w / 2, t: g.y + hangDrop, b: g.y + hangDrop + g.h, cx };
}
function pick(px, py) {
  let best = -1, bd = 1e9;
  for (const g of G) {
    if (!g.visible || (g.kind !== 'tee' && g.kind !== 'bag') || g.state === 'lift' || g.state === 'return' || g.state === 'wait') continue;
    const r = bodyRect(g), pad = g.i === focus ? 14 : 0;
    if (px >= r.l - pad && px <= r.r + pad && py >= r.t - pad - hangDrop && py <= r.b + pad) {
      const d = Math.abs(px - r.cx) - (g.i === focus ? 1e4 : 0); if (d < bd) { bd = d; best = g.i; }
    }
  }
  return best;
}
function inRackBand(px, py) { return px > railL - 30 && px < railR + 30 && py > railY - 30 && py < railY + hangDrop + S * 1.02 + 20; }
function setFocus(i, viaKbd = false) {
  if (i === focus) { kbdFocus = viaKbd; return; }
  const prev = G[focus]; focus = i; kbdFocus = viaKbd;
  if (prev) { prev.pitchV += REDUCED ? 0 : 0.35; }
  const g = G[i];
  if (g) { g.pitchV += REDUCED ? 0 : -0.55; g.phiV += REDUCED ? 0 : (Math.random() - 0.5) * 0.4;
    fillLabel(g);
    if (Sound.on) Sound.clink(0.35);
  }
}
// the floating label under the hovered piece: name (+ a NEW / LAST FEW badge; NEW glows), colour and price. The drop
// bag's label reads "Next drop" with "Coming soon" or the countdown (kept live by dropFrame).
function fillLabel(g) {
  const b = labelEl.querySelector('b'), sp = labelEl.querySelector(':scope > span'), d = g.d;
  sp.textContent = '';
  if (g.kind === 'bag') {   // "Next drop", the product (if one is set) and the countdown, or "Coming soon"
    b.textContent = 'Next drop'; if (!d.placeholder) sp.append(g.name);
    const em = document.createElement('em'); em.className = 'armory__left'; if (d.placeholder) em.style.marginLeft = '0';
    em.textContent = DROP && DROP.time > Date.now() ? fmtLeft(DROP.time - Date.now()) : 'Coming soon'; sp.append(em);
    return;
  }
  b.textContent = '';
  const nm = document.createElement('span'); nm.className = 'armory__nm'; nm.textContent = g.name; b.append(nm);
  const badge = d.available === false ? '' : d.isNew ? 'NEW' : d.lowStock ? 'LAST FEW' : '';
  if (badge) { const i = document.createElement('i'); i.className = 'armory__badge' + (badge === 'NEW' ? ' is-new' : ''); i.textContent = badge; nm.append(i); }   // off the name's end: the name stays centred
  sp.append(d.color || ''); const em = document.createElement('em'); em.textContent = priceOf(d); sp.append(em);
}

function localXY(e) { const r = root.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; }
root.addEventListener('pointermove', e => {
  const [x, y] = localXY(e), now = performance.now(), dt = Math.max(8, now - P.t) / 1000;
  if (P.t && P.inside) { P.vx = lerp(P.vx, (x - P.x) / dt, 0.5); P.vy = lerp(P.vy, (y - P.y) / dt, 0.5); }
  P.x = x; P.y = y; P.t = now; P.inside = true; P.type = e.pointerType;
  if (viewerDrag) {
    const dx = x - viewerDrag.x0; const g = viewerDrag.cap ? null : G[lifted];
    if (viewerDrag.cap) { capView.angT = viewerDrag.y0 + dx * 0.55; viewerDrag.v = lerp(viewerDrag.v, (x - viewerDrag.lx) / dt * 0.55, 0.4); viewerDrag.lx = x; }   // same way round as the tees
    if (g) { g.yawTarget = viewerDrag.y0 + dx * 0.0105; viewerDrag.v = lerp(viewerDrag.v, (x - viewerDrag.lx) / dt * 0.0105, 0.4); viewerDrag.lx = x; }
    if (!dragHintGone && Math.abs(dx) > 30) { dragHintGone = true; ui.drag.classList.add('is-gone'); }
    return;
  }
  if (rail.grab) { rail.gx = x; return; }
  if (lifted >= 0 || capView.active) return;
  if (e.target.closest && e.target.closest('.armory__tag')) { clearTimeout(unfocusTimer); unfocusTimer = 0; return; }   // reading the tag keeps its tee
  const bh = boltHit(x, y); boltHover = !!bh; if (bh) { rackCanvas.style.cursor = 'pointer'; return; }
  if (e.pointerType === 'touch') return; // touch brushes but doesn't change focus
  const hit = pick(x, y);
  const nearRail = Math.abs(y - railY) < railRad + 10 && x > railL && x < railR;
  rackCanvas.style.cursor = hit >= 0 ? 'pointer' : nearRail ? 'grab' : 'default';
  if (hit >= 0) { clearTimeout(unfocusTimer); unfocusTimer = 0; setFocus(hit); }
  else if (!inRackBand(x, y)) { if (focus >= 0 && !unfocusTimer) unfocusTimer = setTimeout(() => { setFocus(-1); unfocusTimer = 0; }, 140); }
}, { passive: true });
// a lifted finger always "leaves"; on touch, focus is cleared by tapping the wall instead (endPointer)
root.addEventListener('pointerleave', e => { P.inside = false; P.vx = P.vy = 0; if (lifted < 0 && !kbdFocus && e.pointerType !== 'touch') setFocus(-1); });

rackCanvas.addEventListener('pointerdown', e => {
  const [x, y] = localXY(e); P.x = x; P.y = y; P.t = performance.now(); P.down = true; P.type = e.pointerType;
  const bh = boltHit(x, y); if (bh) { enterHeaven(bh); return; }
  if (Math.abs(y - railY) < railRad + 10 && x > railL && x < railR && e.pointerType !== 'touch') {
    rail.grab = true; rail.g0 = x; rail.gx = x; rackCanvas.setPointerCapture(e.pointerId); rackCanvas.style.cursor = 'grabbing'; return;
  }
  tapStart = { x, y, t: performance.now() };
});
const endPointer = e => {
  P.down = false;
  if (rail.grab) { rail.grab = false; rackCanvas.style.cursor = 'grab'; return; }
  if (!tapStart) return; const [x, y] = localXY(e); const moved = Math.hypot(x - tapStart.x, y - tapStart.y), dt = performance.now() - tapStart.t; tapStart = null;
  if (moved > 12 || dt > 600 || lifted >= 0) return;
  const hit = pick(x, y);
  if (hit < 0) { if (e.pointerType === 'touch') setFocus(-1); return; }
  if ((e.pointerType === 'touch' && hit !== focus) || G[hit].kind !== 'tee') { setFocus(hit); return; }   // the bag only shows its label
  openViewer(hit, 0, false);
};
rackCanvas.addEventListener('pointerup', endPointer);
rackCanvas.addEventListener('pointercancel', () => { tapStart = null; rail.grab = false; P.down = false; });

veil.addEventListener('pointerdown', e => { if (capView.active) { const [cx] = localXY(e); viewerDrag = { cap: true, x0: cx, lx: cx, y0: capView.angT, v: 0 }; veil.setPointerCapture(e.pointerId); veil.classList.add('is-dragging'); return; }
  if (lifted < 0) return; const [x] = localXY(e); const g = G[lifted];
  viewerDrag = { x0: x, lx: x, y0: g.yawTarget, v: 0 }; veil.setPointerCapture(e.pointerId); veil.classList.add('is-dragging'); });
const endViewerDrag = () => { if (!viewerDrag) return; if (viewerDrag.cap) { capView.snap(viewerDrag.v); viewerDrag = null; veil.classList.remove('is-dragging'); return; } const g = G[lifted];
  if (g) { const proj = g.yawTarget + clamp(viewerDrag.v, -12, 12) * 0.18; g.yawTarget = Math.round((proj - g.heroYaw) / Math.PI) * Math.PI + g.heroYaw; }
  viewerDrag = null; veil.classList.remove('is-dragging'); };
veil.addEventListener('pointerup', endViewerDrag); veil.addEventListener('pointercancel', endViewerDrag);

/* ---------------- viewer ---------------- */
let returnFocusTo = null;
// the lifted tee, hook and all, fits between the theme's nav (the hero slides under it: `inset`) and the top of the
// info panel (name, colours, sizes, buttons: measured when the viewer opens), centred in that band
let infoTop = 0;
function viewerTarget(g) {
  const Ha = H - inset, top = inset + Math.max(10, Ha * 0.035), bottom = (infoTop > top + 120 ? infoTop : H * 0.72) - 12;
  const hookK = (hangDrop + railRad * 2.2) / g.h;   // the hook above the collar, as a share of the tee's height
  const want = Math.max(80, Math.min(Ha * (W < 640 ? 0.42 : 0.5), (W * 0.62) / (g.wF / g.h), (bottom - top) / (1 + hookK)));
  const scale = want / g.h, z = D * (1 - 1 / scale);
  const teeTop = top + hookK * want + Math.max(0, (bottom - top) - want * (1 + hookK)) * 0.5;
  const screenPivotY = teeTop - hangDrop * scale;
  return { x: W / 2, y: H / 2 + (screenPivotY - H / 2) / scale, z, scale };
}
let openedByKbd = false;
function openViewer(i, dir = 0, kbd = openedByKbd) {
  openedByKbd = kbd;
  const g = G[i]; if (!g || g.state === 'wait') return;
  if (lifted >= 0 && lifted !== i) returnGarment(G[lifted]);
  lifted = i; returnFocusTo = returnFocusTo || document.activeElement;
  setFocus(-1); clearTimeout(unfocusTimer);
  g.state = 'lift'; g.flightT = 0; g.layer = 1; setLayer(g, 1);
  g.x += rail.ox; // detach from rail motion
  g.yawTarget = nearestEquiv(g.heroYaw, g.yaw);
  g.vy -= REDUCED ? 0 : 260; // the little tug upward as it leaves the hook
  if (dir) g.vx += dir * -200;
  root.classList.add('is-open');
  ui.count.textContent = `${visIndex(g) + 1} of ${G.filter(x => x.visible && x.kind === 'tee').length}`;
  ui.name.textContent = g.name;
  ui.sub.textContent = ''; ui.sub.append(`${g.sub}${g.d.color ? ', ' + g.d.color.toLowerCase() : ''}`); const em = document.createElement('em'); em.textContent = priceOf(g.d); ui.sub.append(em);
  ui.cta.href = g.d.url;
  buy.open(g.d, (name, rgb) => { recolor(g, rgb); ui.sub.firstChild.textContent = `${g.sub}, ${String(name).toLowerCase()}`; });
  { const info = $('.armory__info'); if (info) infoTop = info.getBoundingClientRect().top - root.getBoundingClientRect().top; }
  if (Sound.on) { Sound.clink(0.7); }
  if (kbd) setTimeout(() => { if (lifted === i) ui.close.focus({ preventScroll: true }); }, 50);
  const r = root.getBoundingClientRect(); if (r.top < -20 || r.bottom > innerHeight + 20) root.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'center' });
}
function returnGarment(g) { g.state = 'return'; g.flightT = 0; g.yawTarget = nearestEquiv(g.restYaw, g.yaw); g.sh.uRecolorOn.value = 0; }
// colourway preview on the lifted tee: dye ratio from the packed colour to the chosen swatch
function recolor(g, rgb) {
  const sw = (opts.swatches || {})[g.d.handle] || {}, key = Object.keys(sw).find(k => k.toLowerCase() === String(g.d.color || '').toLowerCase());
  const base = key && sw[key], on = !!(rgb && base && rgb.join() !== base.join());
  g.sh.uRecolorOn.value = on ? 1 : 0;
  if (on) { g.sh.uRecolor.value.set(rgb[0] / base[0], rgb[1] / base[1], rgb[2] / base[2]); g.sh.uRecolorBase.value.set(base[0] / 255, base[1] / 255, base[2] / 255); }
}
function closeViewer() {
  if (capView.active) { capView.close(); return; }
  if (lifted < 0) return; returnGarment(G[lifted]); lifted = -1; root.classList.remove('is-open'); openedByKbd = false;
  const back = returnFocusTo; returnFocusTo = null; if (back && back.focus && root.contains(back)) back.focus({ preventScroll: true });
}
function step(dir) {
  if (capView.active) { capView.step(dir); return; }
  const vis = G.filter(g => g.visible && g.kind === 'tee'); if (lifted < 0) return;
  const k = (visIndex(G[lifted]) + dir + vis.length) % vis.length; openViewer(vis[k].i, dir);
}
const visIndex = g => G.filter(x => x.visible && x.kind === 'tee').indexOf(g);
const nearestEquiv = (target, current) => target + Math.round((current - target) / TAU) * TAU;
ui.close.addEventListener('click', closeViewer); ui.prev.addEventListener('click', () => step(-1)); ui.next.addEventListener('click', () => step(1));
const onKey = e => {
  if (lifted < 0 && !capView.active) return;
  if (e.key === 'Escape') { e.preventDefault(); closeViewer(); }
  else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
  else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
};
document.addEventListener('keydown', onKey);
if (opts.newTab === false) ui.cta.removeAttribute('target');
function setLayer(g, l) { Object.values(g.parts).forEach(m => m.layers.set(l)); }

/* ---------------- viewer shopping: colour swatches, sizes, add to cart (Shopify passes opts.addToCart) ---------------- */
const buy = (() => {
  const sw = $('.armory__swatches'), sz = $('.armory__sizes'), add = $('.armory__add'), msg = $('.armory__msg');
  const can = !!(opts.addToCart && add);
  if (can) root.classList.add('has-buy');
  let d = null, sel = {}, onColour = null;
  const COLOR = /^colou?r$/i, SIZE = /^size$/i;
  const idx = re => ((d && d.options) || []).findIndex(o => re.test(o));
  const rgbOf = name => { const m = (opts.swatches || {})[d.handle] || {}, k = Object.keys(m).find(x => x.toLowerCase() === String(name).toLowerCase()); return k ? m[k] : null; };
  const variantFor = s => (d.variants || []).find(v => d.options.every((o, k) => s[o] === undefined || v.o[k] === s[o]));
  function render() {
    sw.textContent = ''; sz.textContent = '';
    if (!d || !can || !(d.variants || []).length) { if (add) add.hidden = true; return; }
    add.hidden = false;
    const ci = idx(COLOR), si = idx(SIZE);
    if (ci >= 0) [...new Set(d.variants.map(v => v.o[ci]))].forEach(v => {
      const b = document.createElement('button'); b.type = 'button'; b.className = 'armory__swatch'; b.setAttribute('role', 'radio'); b.setAttribute('aria-label', v); b.title = v;
      const c = rgbOf(v); b.style.background = c ? `rgb(${c.join(',')})` : '#888';
      b.setAttribute('aria-checked', String(sel[d.options[ci]] === v));
      b.addEventListener('click', () => { sel[d.options[ci]] = v; msg.textContent = ''; render(); if (onColour) onColour(v, c); });
      sw.append(b);
    });
    const SIZES = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', 'XXL', '3XL', 'XXXL', '4XL', '5XL'], rank = v => { const k = SIZES.indexOf(String(v).toUpperCase()); return k < 0 ? 99 : k; };
    if (si >= 0) [...new Set(d.variants.map(v => v.o[si]))].sort((a, b) => rank(a) - rank(b)).forEach(v => {
      const b = document.createElement('button'); b.type = 'button'; b.className = 'armory__size'; b.textContent = v; b.setAttribute('role', 'radio');
      const vv = variantFor(Object.assign({}, sel, { [d.options[si]]: v }));
      b.disabled = !vv || !vv.a; b.setAttribute('aria-checked', String(sel[d.options[si]] === v));
      b.addEventListener('click', () => { sel[d.options[si]] = v; msg.textContent = ''; render(); });
      sz.append(b);
    });
    const need = d.options.filter(o => sel[o] === undefined), v = need.length ? null : variantFor(sel);
    add.disabled = !v || !v.a;
    add.textContent = need.length ? `Choose a ${need[0].toLowerCase()}` : v && v.a ? `Add to cart · ${v.p}` : 'Sold out';
  }
  function open(data, colourCb) {
    d = data; onColour = colourCb; sel = {}; msg.textContent = '';
    if (d && d.options && d.variants && d.variants.length) {
      const ci = idx(COLOR);
      if (ci >= 0) { const want = d.variants.find(v => String(v.o[ci]).toLowerCase() === String(d.color || '').toLowerCase()) || d.variants.find(v => v.a) || d.variants[0]; sel[d.options[ci]] = want.o[ci]; }
      d.options.forEach((o, k) => { const vals = [...new Set(d.variants.map(v => v.o[k]))]; if (vals.length === 1) sel[o] = vals[0]; });   // one-size / one-colour
    }
    ui.cta.textContent = can && d && d.variants && d.variants.length ? 'View details' : 'Shop this tee';
    render();
  }
  if (add) add.addEventListener('click', () => {
    const v = variantFor(sel); if (!v || !can) return;
    add.disabled = true; add.textContent = 'Adding…'; msg.textContent = '';
    opts.addToCart(v.id).then(() => { add.textContent = 'Added ✓'; setTimeout(render, 1800); })
      .catch(err => { msg.textContent = (err && err.message) || 'That could not be added to your cart.'; render(); });
  });
  return { open, get selected() { return sel; } };
})();

/* keyboard / screen reader list */
a11yList.textContent = '';
G.filter(g => g.kind !== 'bag').forEach(g => { const li = document.createElement('li'); const b = document.createElement('button'); b.type = 'button';
  b.textContent = `${g.name}, ${g.sub}, ${g.d.color || ''}, ${priceOf(g.d)}. Open details`;
  b.addEventListener('focus', () => { if (lifted < 0) setFocus(g.i, true); });
  b.addEventListener('blur', () => { if (lifted < 0 && kbdFocus) { kbdFocus = false; setFocus(-1); } });
  b.addEventListener('click', () => { returnFocusTo = b; openViewer(g.i, 0, true); });
  g.btn = b; li.append(b); a11yList.append(li); });

/* ---------------- swing tags: a small black card with gold foil hanging from under the hem; hover / tap brings it up to read, then it flips to the verse ---------------- */
// the verse: the first quotation in the product description with its reference, else the config's fallback
function verseOf(d) {
  if (d.verseCache !== undefined) return d.verseCache;
  const t = (d.about || '').replace(/\s+/g, ' ');
  const REF = /((?:[1-3]\s?)?[A-Z][a-z]+\.?\s\d{1,3}:\d{1,3}(?:\s?[-–]\s?\d{1,3})?)/;
  let v = null;
  const m = t.match(/[“"]([^”"]{12,500})[”"]/);
  if (m) {
    const after = t.slice(m.index + m[0].length, m.index + m[0].length + 48).match(REF), before = t.slice(Math.max(0, m.index - 40), m.index).match(REF);
    const ref = (after || before || [])[1];
    if (ref) v = { q: m[1].trim(), ref: ref.trim() };
  }
  if (!v && d.verse) v = { q: d.verse, ref: d.ref || '' };
  if (v && v.q.length > 150) v.q = v.q.slice(0, v.q.lastIndexOf(' ', 146)).replace(/[,;:.\s]+$/, '') + '…';
  return (d.verseCache = v);
}
function SwingTag(kind) {
  const el = document.createElement('div'); el.className = 'armory__tag'; el.setAttribute('aria-hidden', 'true');
  el.innerHTML = '<span class="armory__tag-string"></span><div class="armory__tag-card"><div class="armory__tag-face armory__tag-front"><i class="armory__tag-hole"></i><span class="armory__tag-brand">OTK</span><b></b><span class="armory__tag-sub"></span><em></em><span class="armory__tag-stamp"></span></div><div class="armory__tag-face armory__tag-back"><i class="armory__tag-hole"></i><q></q><cite></cite></div></div>';
  root.append(el);
  const card = el.querySelector('.armory__tag-card'), q = sel => el.querySelector(sel);
  const st = { gi: -1, a: 0, av: 0, ax: null, vx: 0, flip: false, zoom: false, side: 1, tz: 0 };
  let flipT = 0;
  const flip = v => { st.flip = v; el.classList.toggle('is-flip', v); };
  // at rest the tag is small; reaching for it brings it up to reading size (front: name, price, NEW), and after a moment
  // it turns over to the verse
  const zoom = v => { st.zoom = v; el.classList.toggle('is-zoom', v); clearTimeout(flipT); if (!v) flip(false); };
  card.addEventListener('pointerenter', e => { if (e.pointerType === 'touch') return; zoom(true); if (kind !== 'drop') flipT = setTimeout(() => { if (st.zoom) flip(true); }, 1100); });
  card.addEventListener('pointerleave', e => { if (e.pointerType !== 'touch') zoom(false); });
  card.addEventListener('click', e => { e.stopPropagation();
    if (COARSE) { if (!st.zoom) zoom(true); else flip(!st.flip); }
    else if (kind === 'drop') flip(!st.flip);
    else if (st.gi >= 0) openViewer(st.gi, 0, false); });
  function fill(g) {
    const d = g.d;
    q('b').textContent = kind === 'drop' ? 'Next drop' : g.name;
    q('.armory__tag-sub').textContent = kind === 'drop' ? (d.placeholder ? 'Coming soon' : g.name) : [g.sub, d.color].filter(Boolean).join(' · ');
    el.classList.toggle('is-new', kind !== 'drop' && d.available !== false && !!d.isNew);   // NEW glows
    q('.armory__tag-front em').textContent = kind === 'drop' ? '' : priceOf(d);
    q('.armory__tag-stamp').textContent = kind === 'drop' ? '' : d.available === false ? 'SOLD OUT' : d.isNew ? 'NEW' : d.lowStock ? 'LAST FEW' : '';
    const v = verseOf(d); q('q').textContent = v ? v.q : g.sub; q('cite').textContent = v ? v.ref : '';
  }
  const tw = () => clamp(S * 0.144, 34, 48);   // 2.5x smaller than the first tags (owner, 2026-10-02)
  const ts = () => clamp(S * 0.05, 7, 14);
  function size() { el.style.setProperty('--tw', tw().toFixed(1) + 'px'); el.style.setProperty('--ts', ts().toFixed(1) + 'px'); }
  // per frame: the string comes out from under the hem of garment gi, a little toward its outer side; the tag swings
  // like a little pendulum and follows the hem as it sways
  function update(gi, show, dt) {
    if (gi >= 0 && gi !== st.gi) { st.gi = gi; fill(G[gi]); st.ax = null; zoom(false); st.side = G[gi].x + rail.ox < W / 2 ? -1 : 1; }
    el.classList.toggle('is-on', !!show && st.gi >= 0);
    if (!show && st.zoom) zoom(false);
    if (st.gi < 0) return;
    const g = G[st.gi], onRail = g.state !== 'lift' && g.state !== 'return';
    const px = g.x + (onRail ? rail.ox : 0), py = g.y;
    const wv = Math.max(g.wv || 0, g.wF * 0.5), ly = hangDrop + g.h * 0.985, ca = Math.cos(g.hem), sa = Math.sin(g.hem);
    const at = side => { const lx = side * 0.24 * wv; return [px + lx * ca + ly * sa, py - lx * sa + ly * ca]; };
    if (Math.abs(at(st.side)[0] - W / 2) > W / 2 - tw() / 2 - 6) st.side = -st.side;   // it would hang off the screen: the other side
    const [x, y] = at(st.side);
    // brought up to read: as large as the space under the hem allows (up to 2.5x), above the ticker
    const tz = clamp((H - 40 - y - ts()) / (tw() * 1.5), 1.3, 2.5);
    if (Math.abs(tz - st.tz) > 0.02) { st.tz = tz; el.style.setProperty('--tz', tz.toFixed(2)); }
    if (st.ax === null) { st.ax = x; st.vx = 0; st.a = 0; st.av = 0; }
    const dts = Math.max(dt, 1e-3), vx = (x - st.ax) / dts, acc = (vx - st.vx) / dts; st.vx = vx; st.ax = x;
    const L = ts() + tw() * 0.75;
    const n = Math.max(1, Math.ceil(dt / (1 / 240))), h = dt / n;
    for (let k = 0; k < n; k++) {
      let tq = -(2600 / L) * Math.sin(st.a) - 2.4 * st.av - clamp(acc, -8000, 8000) / L * Math.cos(st.a) * 0.6;
      tq += (breezeNow() - 1) * 0.7 * Math.sin(simT * 1.4 + st.side * 2.0);
      st.av += tq * h; st.a += st.av * h;
    }
    st.a = clamp(st.a, -0.9, 0.9);
    el.style.transform = `translate(${x.toFixed(1)}px,${y.toFixed(1)}px) rotate(${st.a.toFixed(4)}rad)`;
  }
  return { el, update, size, fill, flip, zoom, em(t) { q('.armory__tag-front em').textContent = t; }, get gi() { return st.gi; } };
}
// swing tags are off for now (owner, 2026-10-03: the hover label is back instead); opts.tags = true brings them back
const tagFocus = opts.tags === true ? SwingTag('focus') : null;
if (tagFocus) root.classList.add('has-tags');

/* ---------------- breeze: outdoors (sky, forest, night) the air moves the tees, tags and caps ---------------- */
let breezeK = 1;
function breezeNow() { return breezeK; }

/* ---------------- gusts: every 5-12 s, when nobody is reaching for the clothes, a gust pulls through along the rail:
   the tees swing and twist one after another as its front passes, the hangers slide a little, the caps rock, the petals
   race, the lamb flicks an ear ---------------- */
const wind = { wait: 4 + Math.random() * 3, on: false, age: 0, dir: 1, str: 1, fade: 0, speed: 1, x0: 0, span: 1, drift: 0 };
const gustCalm = () => REDUCED || focus >= 0 || lifted >= 0 || capView.active || P.down || rail.grab || (P.inside && P.type !== 'touch' && inRackBand(P.x, P.y));
function gustStep(dt) {
  wind.wait -= dt;
  if (wind.wait <= 0) {
    wind.wait = 5 + Math.random() * 7;
    if (introDone && !gustCalm()) {
      wind.on = true; wind.age = 0; wind.dir = wind.forceDir || (Math.random() < 0.5 ? 1 : -1); wind.forceDir = 0; wind.str = 0.65 + Math.random() * 0.35; wind.fade = 1;
      wind.span = (railR - railL) + W * 0.3; wind.speed = wind.span / (1.0 + Math.random() * 0.5);
      wind.x0 = wind.dir > 0 ? railL - W * 0.15 : railR + W * 0.15;
    }
  }
  if (!wind.on) return;
  wind.age += dt;
  wind.fade = gustCalm() ? Math.max(0, wind.fade - dt * 2.5) : Math.min(1, wind.fade + dt * 2);   // someone reached in: it dies down
  if (wind.age > wind.span / wind.speed + 3 || wind.fade <= 0) wind.on = false;
  wind.drift += gustAt(W / 2) * S * 2.6 * dt;
}
// the gust's push at x (signed by its direction, about -1 .. 1): it arrives with the front and dies away over a second
function gustAt(x) {
  if (!wind.on) return 0;
  const tau = wind.age - (x - wind.x0) * wind.dir / wind.speed;
  if (tau <= 0) return 0;
  return wind.dir * wind.str * wind.fade * Math.min(1, tau / 0.22) * Math.exp(-Math.max(0, tau - 0.22) / 0.7) * (1 + 0.22 * Math.sin(tau * 9 + x * 0.013));
}

/* ---------------- physics ---------------- */
const K = REDUCED
  ? { hook: 260, hookC: 32, yaw: 150, yawC: 25, hemY: 90, hemYC: 19, w0: 30, phiC: 9, hemS: 80, hemSC: 18, pitch: 42, pitchC: 13, brush: 0, breeze: 0 }
  : { hook: 230, hookC: 21, yaw: 150, yawC: 14.5, hemY: 95, hemYC: 7.5, w0: 30, phiC: 2.2, hemS: 62, hemSC: 3.8, pitch: 42, pitchC: 3.2, brush: 1.15, breeze: 0.16 };

function solveTargets() {
  const items = G.filter(g => g.visible && g.state !== 'lift' && (g.kind === 'tee' || g.kind === 'bag'));
  items.sort((a, b) => a.rest - b.rest);
  const xs = items.map(g => g.rest);
  const width = g => g.side ? Math.max(g.wF * Math.abs(Math.cos(g.yaw)), g.wS * Math.abs(Math.sin(g.yaw))) : g.wF * Math.max(0.36, Math.abs(Math.cos(g.yaw)));
  items.forEach(g => { g.wv = width(g); g.open = Math.abs(Math.cos(g.yaw)) * (g.side ? 1 : 0.7); });
  // when a piece is off the rail, its neighbours drift into the gap
  const gone = G.find(g => g.visible && g.state === 'lift');
  if (gone) { const ts = items.filter(g => g.kind === 'tee'), n = ts.length; ts.forEach((g, k) => { xs[items.indexOf(g)] = teeCX + (k - (n - 1) / 2) * spacing * (n + 1) / n * 0.98; }); }
  const em = W < 640 ? 0.17 : 0.06, lo = railL + S * em, hi = railR - S * em;
  for (let it = 0; it < 18; it++) {
    for (let k = 0; k < items.length - 1; k++) {
      const a = items[k], b = items[k + 1];
      const pk = lerp(0.84, 1.05, Math.max(a.open, b.open));
      const dmin = 0.5 * (a.wv + b.wv) * pk;
      const d = xs[k + 1] - xs[k];
      if (d < dmin) {
        const ma = a.i === focus ? 0.12 : 1, mb = b.i === focus ? 0.12 : 1, c = dmin - d;
        xs[k] -= c * ma / (ma + mb); xs[k + 1] += c * mb / (ma + mb);
      }
    }
    for (let k = 0; k < xs.length; k++) xs[k] = clamp(xs[k], lo, hi);
  }
  items.forEach((g, k) => g.tx = xs[k]);
  return items;
}


/* Soft fabric contact between neighbours, tested at chest and hem height.
   The contact width is narrower than the drawn width (sleeves and drape compress), restitution is low so the
   bump is absorbed like cloth, and a little momentum goes into the neighbour's hook so it slides along the rail. */
const CONTACT = { width: 0.9, e: 0.12, push: 0.35, hook: 0.12, heights: [0.5, 1.0] };
function bodyAt(g, t) {
  const y = hangDrop + t * g.h, w = Math.pow(t, 1.6);
  const ang = g.phi + (g.hem - g.phi) * w, angV = g.phiV + (g.hemV - g.phiV) * w;
  return { x: g.x + y * Math.sin(ang), v: g.vx + y * Math.cos(ang) * angV, y, w, c: Math.cos(ang) };
}
function collide(a, b) {
  if (REDUCED) return;
  const d0 = CONTACT.width * 0.5 * (a.wv + b.wv);
  for (const t of CONTACT.heights) {
    const A = bodyAt(a, t), B = bodyAt(b, t);
    const pen = d0 - (B.x - A.x);
    if (pen <= 0) continue;
    const vrel = B.v - A.v;
    if (vrel < 0) {
      const dv = -(1 + CONTACT.e) * vrel * 0.5;           // each side takes half the change
      const dwA = dv / (A.y * Math.max(0.3, A.c)), dwB = dv / (B.y * Math.max(0.3, B.c));
      // the hem is the part that touches first, so split the response between body swing and hem lag
      a.phiV -= dwA * (1 - 0.6 * A.w); a.hemV -= dwA * (1 + 0.4 * A.w);
      b.phiV += dwB * (1 - 0.6 * B.w); b.hemV += dwB * (1 + 0.4 * B.w);
      a.vx -= dv * CONTACT.hook; b.vx += dv * CONTACT.hook;
      if (-vrel > 160 && Sound.on) Sound.thud(clamp(-vrel / 4000, 0.03, 0.12));
    }
    // ease them apart (fabric squash), never a hard snap
    const corr = pen * CONTACT.push * 0.5;
    a.phi -= corr / A.y * (1 - 0.5 * A.w); a.hem -= corr / A.y;
    b.phi += corr / B.y * (1 - 0.5 * B.w); b.hem += corr / B.y;
  }
}

let clinkBudget = 0;
function physics(dt, t) {
  breezeK += ((THEMES[themeApplied].breeze || 1) - breezeK) * Math.min(1, dt * 0.6);
  const gust = breezeK > 1.01 ? 0.45 + 0.55 * Math.max(0, Math.sin(t * 0.23) * Math.sin(t * 0.11 + 1.3) + 0.4) : 1;
  const items = solveTargets();
  gustStep(dt);
  // rail spring (grab + ring)
  const railTarget = rail.grab ? clamp((rail.gx - rail.g0) * 0.4, -S * 0.32, S * 0.32) : 0;
  const prevOV = rail.ov;
  rail.ov += ((rail.grab ? 520 : 240) * (railTarget - rail.ox) - (rail.grab ? 40 : 7) * rail.ov) * dt;
  rail.ox += rail.ov * dt; rail.ax = (rail.ov - prevOV) / dt;
  rail.oyv += (-2400 * rail.oy - 9 * rail.oyv) * dt; rail.oy += rail.oyv * dt;
  const railYNow = railY + rail.oy;

  // brushing: the cursor moving through fabric
  const pv = Math.hypot(P.vx, P.vy);
  P.vx *= Math.pow(0.0008, dt); P.vy *= Math.pow(0.0008, dt);

  let slideAcc = 0, swishAcc = 0;
  for (const g of G) {
    if (!g.visible || g.kind === 'drop') continue;
    if (g.kind === 'falling') { g.vy += 2900 * dt; g.y += g.vy * dt; g.phiV += (Math.sin(t * 7.0) * 0.6 - 0.8 * g.phiV) * dt; g.phi += g.phiV * dt; continue; }
    let ax = 0, ay = 0;
    const L = Lb;
    // --- hook / flight translation
    if (g.state === 'hung' || g.state === 'drop' || g.state === 'intro') {
      const prevV = g.vx;
      g.vx += (K.hook * (g.tx - g.x) - K.hookC * g.vx) * dt;
      g.x += g.vx * dt; ax = (g.vx - prevV) / dt + rail.ax;
      slideAcc += Math.abs(g.vx);
      if (g.state === 'hung') { g.y = railYNow; g.vy = 0; }
      else {
        if (t < g.delay) { g.y = railY - S * 1.4 - 160; }
        else {
          g.vy += 2900 * dt; g.y += g.vy * dt; ay = 2900;
          if (g.y >= railYNow) {
            g.y = railYNow;
            if (g.vy > 140) { const v = g.vy; Sound.clink(clamp(v / 1400, 0.25, 1)); Sound.thud(clamp(v / 2200, 0.1, .6)); rail.oyv += v * 0.006; g.phiV += (Math.random() - 0.5) * (REDUCED ? 0 : 2.2); g.pitchV += REDUCED ? 0 : 0.6; g.vy = -v * 0.18; }
            else { g.vy = 0; g.state = 'hung'; }
          }
        }
      }
      g.z += (g.zJit - g.z) * Math.min(1, dt * 6); g.vz = 0;
    } else if (g.state === 'lift' || g.state === 'return') {
      g.flightT += dt;
      let T;
      if (g.state === 'lift') T = viewerTarget(g);
      else T = { x: g.tx + rail.ox, y: railYNow - S * 0.22, z: g.zJit };
      const k = g.state === 'lift' ? 64 : 95, c = g.state === 'lift' ? 13 : 17.5;
      const pvx = g.vx, pvy = g.vy;
      g.vx += (k * (T.x - g.x) - c * g.vx) * dt; g.vy += (k * (T.y - g.y) - c * g.vy) * dt; g.vz += (k * (T.z - g.z) - c * g.vz) * dt;
      g.x += g.vx * dt; g.y += g.vy * dt; g.z += g.vz * dt;
      ax = (g.vx - pvx) / dt; ay = (g.vy - pvy) / dt;
      if (g.state === 'return' && ((Math.abs(T.x - g.x) < 5 && Math.abs(T.y - g.y) < 8 && Math.abs(g.z - T.z) < 8) || g.flightT > 1.1)) {
        g.state = 'drop'; g.x -= rail.ox; g.vy = Math.max(0, g.vy); g.delay = 0; setLayer(g, 0); g.layer = 0;
      }
    }

    // --- hook swivel: angled on the rail, turns to show its curl when held up in the viewer
    if (!g.hookRest) g.hookRest = g.hookYaw;
    const hyT = (g.state === 'lift') ? Math.sign(g.hookRest) * 1.3 : g.hookRest;
    g.hookYawV += (120 * (hyT - g.hookYaw) - 16 * g.hookYawV) * dt; g.hookYaw += g.hookYawV * dt;
    // --- yaw (turn) with a lagging hem that twists
    const yPrev = g.yawV;
    g.yawTarget = g.state === 'lift' ? g.yawTarget : g.state === 'return' || g.state === 'drop' ? g.yawTarget : (g.i === focus ? nearestEquiv(g.heroYaw, g.yaw) : nearestEquiv(g.restYaw, g.yaw));
    g.yawV += (K.yaw * (g.yawTarget - g.yaw) - K.yawC * g.yawV) * dt; g.yaw += g.yawV * dt;
    g.yawHV += (K.hemY * (g.yaw - g.yawH) - K.hemYC * g.yawHV) * dt; g.yawH += g.yawHV * dt;
    { const tw = g.yawH - g.yaw, lim = 0.34; if (Math.abs(tw) > lim) { g.yawH = g.yaw + Math.sign(tw) * (lim + (Math.abs(tw) - lim) * 0.25); g.yawHV = g.yawV + (g.yawHV - g.yawV) * 0.5; } }
    swishAcc += Math.abs(g.yawV);

    // --- pendulum swing about the hook
    let tq = 0;
    tq += -K.w0 * Math.sin(g.phi) - (g.state === 'lift' ? K.phiC * 2.2 : K.phiC) * g.phiV;
    tq += -(ax / L) * Math.cos(g.phi) * (g.state === 'lift' || g.state === 'return' ? 0.32 : 0.4) - (ay / L) * Math.sin(g.phi) * 0.3;
    tq += K.breeze * breezeK * gust * Math.sin(t * 0.55 + g.i * 1.7) * (1 + 0.6 * Math.sin(t * 0.21 + g.i * 2.3));
    const gw = g.state === 'hung' ? gustAt(g.x + rail.ox) : 0;
    if (gw) { tq += 5.2 * gw; g.yawV += 11 * gw * dt * (g.i % 2 ? 1 : 0.7); g.vx += gw * S * 0.9 * dt; g.pitchV += Math.abs(gw) * 0.35 * dt; }
    tq += g.torque; g.torque = 0;
    // cursor brushing through the garment
    if (K.brush && P.inside && pv > 40 && lifted < 0 && (g.state === 'hung')) {
      const r = bodyRect(g), half = (r.r - r.l) / 2 + 10;
      const dx = P.x - r.cx, inY = P.y > r.t - hangDrop && P.y < r.b + 6;
      if (inY && Math.abs(dx) < half * 1.6) {
        const prox = Math.abs(dx) < half ? 1 - Math.abs(dx) / half * 0.5 : 0.25 * (1 - (Math.abs(dx) - half) / (half * 0.6));
        const lever = clamp((P.y - r.t) / g.h, 0.15, 1);
        tq += K.brush * clamp(P.vx, -2600, 2600) * prox * lever / L;
        g.pitchV += clamp(P.vy, -2000, 2000) * prox * lever * 0.0009;
        g.vx += clamp(P.vx, -2600, 2600) * prox * dt * 1.1;
      }
    }
    if (g.state === 'lift' && P.inside && pv > 40 && !viewerDrag && lifted === g.i) tq += K.brush * 0.35 * clamp(P.vx, -2000, 2000) / (L * 4);
    g.phiV += tq * dt; g.phi += g.phiV * dt;
    g.phi = clamp(g.phi, -0.9, 0.9);
    // hem follows the body with lag (cloth secondary motion)
    g.hemV += (K.hemS * (g.phi - g.hem) - K.hemSC * g.hemV) * dt; g.hem += g.hemV * dt;
    g.pitchV += (-K.pitch * g.pitch - K.pitchC * g.pitchV) * dt; g.pitch += g.pitchV * dt; g.pitch = clamp(g.pitch, -0.5, 0.5);
    const ripT = REDUCED ? 0 : clamp((breezeK - 1) * 0.0035 * S * gust + Math.abs(gw) * 0.018 * S + Math.abs(g.yawV) * 0.011 * S + Math.abs(g.phiV) * 0.03 * S + Math.abs(g.pitchV) * 0.02 * S + Math.abs(g.yaw - g.yawH) * 0.03 * S, 0, 0.04 * S);
    g.rip += (ripT - g.rip) * Math.min(1, dt * 10);
  }

  // fabric-on-fabric contact: neighbours bump and absorb instead of passing through each other
  const hung = items.filter(g => g.state === 'hung' || g.state === 'drop').sort((a, b) => a.x - b.x);
  for (let k = 0; k < hung.length - 1; k++) {
    const a = hung[k], b = hung[k + 1];
    collide(a, b);
    // hooks knocking together
    const rel = a.vx - b.vx, hd = b.x - a.x;
    if (rel > 220 && hd < 0.5 * (a.wv + b.wv) * 0.8 && t - a.lastClink > 0.12 && clinkBudget < 3) { a.lastClink = t; clinkBudget++; Sound.clink(clamp(rel / 1500, 0.15, 0.7)); }
  }
  Sound.update(slideAcc / 2200, swishAcc / 30);
  // while the bag unzips, the tee inside hangs on the same hook
  if (DROP && DROP.state === 'unzip') { const b = DROP.bag, tee = DROP.tee;
    tee.x = b.x; tee.y = b.y; tee.vx = b.vx; tee.phi = b.phi; tee.phiV = b.phiV; tee.hem = b.hem; tee.pitch = b.pitch; tee.z = b.z; tee.hookYaw = b.hookYaw; }
}


/* ---------------- rooms, spotlight, decor ---------------- */
// the shield cycles the visible rooms in this order (the visitor's pick is stored by this index); t = the room's index in
// the backdrop shader. "open" rooms have no wall: no wall shadows, the brackets are bolted into the scene with a glow
// around each bolt, and the chrome reflects env (top, horizon, below, sun strength). Hidden rooms are not in the cycle.
const THEMES = [
  { id: 'limestone', t: 0, tone: 'light', kt: [1, 0.99, 0.97] },
  { id: 'castle', t: 2, tone: 'dark', kt: [0.66, 0.6, 0.55] },
  { id: 'galaxy', t: 4, tone: 'dark', open: true, kt: [0.52, 0.5, 0.66], env: [[0.16, 0.1, 0.3], [0.12, 0.14, 0.24], [0.02, 0.02, 0.05], 0.15] },
  { id: 'matrix', t: 5, tone: 'dark', open: true, kt: [0.44, 0.58, 0.47], env: [[0.06, 0.34, 0.14], [0.03, 0.18, 0.07], [0.0, 0.04, 0.02], 0.12] },
  { id: 'lanterns', t: 6, tone: 'dark', open: true, kt: [0.6, 0.48, 0.5], breeze: 1.7, env: [[0.1, 0.07, 0.22], [0.55, 0.3, 0.18], [0.04, 0.03, 0.08], 0.25] },
  { id: 'sakura', t: 7, tone: 'light', kt: [1.02, 1.0, 0.99] },
  // the open sky shows only in the time-of-day mode (the left shield), at the visitor's hour
  { id: 'sky', t: 1, tone: 'light', open: true, hidden: true, kt: [1, 0.99, 0.96], breeze: 3.4, env: [[0.3, 0.5, 0.82], [0.7, 0.82, 0.94], [0.33, 0.35, 0.32], 1] },
  // reached only by clicking a glowing bolt in an open room
  { id: 'heaven', t: 9, tone: 'light', open: true, hidden: true, kt: [1.06, 1.0, 0.88], breeze: 1.5, env: [[1.0, 0.93, 0.76], [1.0, 0.86, 0.62], [0.62, 0.52, 0.38], 1.4] },
];
const HEAVEN = THEMES.findIndex(x => x.id === 'heaven'), SKY = THEMES.findIndex(x => x.id === 'sky');
let heavenFrom = 0, boltHover = false, glow = 0.3;
function nextRoom() { let n = THEMES[theme].hidden ? heavenFrom : theme; do n = (n + 1) % THEMES.length; while (THEMES[n].hidden); return n; }
const SAKURA = THEMES.findIndex(x => x.id === 'sakura');
// every visit lands on the section's default room (owner: the cherry blossom); opts.roomKey would remember a pick
const ROOM_KEY = opts.roomKey || null;
let theme = clamp(opts.room | 0, 0, THEMES.length - 1), themePrev = theme, themeMix = 1, themeT = 1, themeApplied = theme, lastDt = 1 / 60, toneAt = 0.5;
try { const t = ROOM_KEY ? parseInt(localStorage.getItem(ROOM_KEY), 10) : NaN; if (t >= 0 && t < THEMES.length && !THEMES[t].hidden) theme = themePrev = themeApplied = t; } catch (e) {}
if (THEMES[theme].hidden) theme = themePrev = themeApplied = 0;
const reveal = new THREE.Vector2(0, 0);
const spotS = { x: 0, y: 0, vx: 0, vy: 0 }, spotFixture = { x: 0, y: 0, z: 0 };

const bgMat = new THREE.ShaderMaterial({
  vertexShader: window.OTK_BACKDROP.vert, fragmentShader: window.OTK_BACKDROP.frag, depthTest: false, depthWrite: false,
  uniforms: {
    uRes: { value: new THREE.Vector2(1, 1) }, uDpr: { value: 1 }, uTime: globals.uTime,
    uTheme: { value: THEMES[theme].t }, uPrev: { value: THEMES[theme].t }, uMix: { value: 1 }, uReveal: { value: reveal },
    uTarget: { value: new THREE.Vector2() }, uFixture: { value: new THREE.Vector3() },
    uRail: { value: new THREE.Vector4() }, uRailOff: { value: new THREE.Vector2() }, uRailDepth: { value: 46 },
    uS: { value: 200 },
    uSakura: { value: blankTex() }, uSakuraAspect: { value: 1.6 }, uGlyphs: { value: glyphAtlas() }, uGlow: { value: 0.3 }, uDrift: { value: 0 },
    // the sky's palette: day by default; the time-of-day mode feeds the hour's colours
    uZen: { value: new THREE.Vector3(0.15, 0.38, 0.75) }, uHor: { value: new THREE.Vector3(0.66, 0.8, 0.93) },
    uCLit: { value: new THREE.Vector3(1.0, 0.985, 0.955) }, uCShade: { value: new THREE.Vector3(0.5, 0.57, 0.69) },
    uSunC: { value: new THREE.Vector3(1.0, 0.95, 0.84) }, uSunP: { value: new THREE.Vector2(-0.12, -0.4) }, uToSun: { value: new THREE.Vector2(-0.03, -0.024) },
    uStars: { value: 0 }, uMoonP: { value: new THREE.Vector2(0.8, 0.2) }
  }
});
function blankTex() { const t = new THREE.DataTexture(new Uint8Array([0, 0, 0, 0]), 1, 1); t.needsUpdate = true; textures.push(t); return t; }
// 64 mirrored half-width katakana, digits and symbols in an 8 x 8 sheet for the digital rain. No mipmaps, so sampling
// per cell can't hit the undefined-mip-level problem described in samp().
function glyphAtlas() {
  const c = document.createElement('canvas'); c.width = c.height = 256; const g = c.getContext('2d');
  const chars = 'ｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝ0123456789Z:.=*+-<>';
  g.fillStyle = '#fff'; g.textAlign = 'center'; g.textBaseline = 'middle';
  g.font = 'bold 25px "Hiragino Kaku Gothic ProN","Hiragino Sans","Meiryo","Noto Sans JP","MS Gothic",monospace';
  for (let i = 0; i < 64; i++) { g.save(); g.translate((i % 8) * 32 + 16, Math.floor(i / 8) * 32 + 17); g.scale(-1, 1); g.fillText(chars[i % chars.length], 0, 0); g.restore(); }
  const t = new THREE.CanvasTexture(c); t.minFilter = t.magFilter = THREE.LinearFilter; t.generateMipmaps = false; textures.push(t); return t;
}
let sakuraState = 0;
function needSakura() {
  const src = (opts.decor || {}).sakura; if (sakuraState || !src) return; sakuraState = 1;
  const gate = !introStart; if (gate) pending++;   // the landing room: the intro waits for its tree
  loader.load(src, tx => { tx.minFilter = THREE.LinearMipmapLinearFilter; tx.generateMipmaps = true; tx.anisotropy = 4; textures.push(tx);
    bgMat.uniforms.uSakura.value = tx; bgMat.uniforms.uSakuraAspect.value = tx.image.width / tx.image.height; sakuraState = 2; if (gate) pending--; },
    undefined, () => { sakuraState = 0; if (gate) pending--; });
}
const bgMesh = new THREE.Mesh(new THREE.PlaneGeometry(2, 2), bgMat);
bgMesh.frustumCulled = false; bgMesh.renderOrder = -1000; scene.add(bgMesh);

// wall brackets in the same chrome as the rail, in every room (in open rooms they bolt into the scene, which glows round them)
const metalExtras = [];
function metalPiece(geo, x, y) { const m = new THREE.Mesh(geo, mkMetal(null, true)); m.material.uniforms.uPivot.value.set(x, y); m.frustumCulled = false; scene.add(m); metalExtras.push(m); return m; }
function buildBrackets() {
  metalExtras.splice(0).forEach(m => { scene.remove(m); m.geometry.dispose(); m.material.dispose(); });
  const depth = -globals.uWallZ.value, r = railRad;
  [railL, railR].forEach(x => {
    const arm = new THREE.CylinderGeometry(r * 0.8, r * 0.8, depth, 16); arm.rotateX(Math.PI / 2); arm.translate(0, 0, -depth / 2);
    const fl = new THREE.CylinderGeometry(r * 2.5, r * 2.5, 3, 28); fl.rotateX(Math.PI / 2); fl.translate(0, 0, -depth + 1.5);
    const cap = new THREE.SphereGeometry(r * 1.15, 18, 12);
    metalPiece(arm, x, railY); metalPiece(fl, x, railY); metalPiece(cap, x, railY);
  });
}

function updateSpot(dt) {
  // a motorised follow-spot: fixed fixture, the beam pans after the cursor with a little inertia
  const idle = !(P.inside && lifted < 0);
  const tx = idle ? W / 2 + Math.sin(simT * 0.17) * W * 0.05 : clamp(P.x, W * 0.08, W * 0.92);
  const cy = railY + S * 0.45;
  const ty = idle ? cy : clamp(cy + (P.y - cy) * 0.3, railY - S * 0.1, railY + S * 1.0);
  const n = Math.max(1, Math.ceil(dt / (1 / 120))), h = dt / n;
  for (let k = 0; k < n; k++) {
    spotS.vx += (14 * (tx - spotS.x) - 6.2 * spotS.vx) * h; spotS.x += spotS.vx * h;
    spotS.vy += (14 * (ty - spotS.y) - 6.2 * spotS.vy) * h; spotS.y += spotS.vy * h;
  }
  // theme reveal progress
  if (themeT < 1) {
    themeT = Math.min(1, themeT + dt / (REDUCED ? 0.01 : 1.5));
    themeMix = themeT < 0.5 ? 2 * themeT * themeT : 1 - Math.pow(-2 * themeT + 2, 2) / 2;
    if ((themeMix >= toneAt || themeT >= 1) && themeApplied !== theme) { themeApplied = theme; applyThemeDom(); }
  }
  // shelves catch the light like everything else on the wall
  racks.forEach(rk => {
    const cx = rk.el.offsetLeft + rk.el.offsetWidth / 2, cy2 = rk.el.offsetTop + rk.el.offsetHeight / 2;
    const b = 1;
    if (Math.abs(b - rk.b) > 0.004) { rk.b = b; rk.el.style.filter = `brightness(${b.toFixed(3)})`; }
  });
  updateHats(dt);
}
function syncBackdrop() {
  const u = bgMat.uniforms;
  u.uRes.value.set(W, H); u.uDpr.value = renA.getPixelRatio();
  u.uTheme.value = THEMES[theme].t; u.uPrev.value = THEMES[themePrev].t; u.uMix.value = themeMix;
  u.uTarget.value.set(spotS.x, spotS.y);
  u.uFixture.value.set(spotFixture.x, spotFixture.y, spotFixture.z);
  u.uRail.value.set(railL, railR, railY, railRad); u.uRailOff.value.set(rail.ox, rail.oy);
  u.uRailDepth.value = -globals.uWallZ.value;
  u.uS.value = S;
  u.uDrift.value = wind.drift;
}

/* ---------------- "One True King" <-> logo: particles diffuse from one into the other on each hover (tap on touch) ---------------- */
const title = (() => {
  const el = $('.armory__title'), cv = $('.armory__title-fx');
  if (!el || !cv) return { prepare() {}, tick() {} };
  const g = cv.getContext('2d');
  // it starts as the OTK logo (owner, 2026-10-03); a hover turns it into "One True King", the next back to the logo
  let N = 0, ax, ay, bx, by, ca, cb, dl, an, am, cw = 0, ch = 0, buf = null, t = 1, target = 1, shown = -1, logo = null, logoRect = null, ready = false;
  const rnd = (i, k) => { const x = Math.sin(i * 12.9898 + k * 78.233) * 43758.5453; return x - Math.floor(x); };
  // ---- at rest the title is drawn in WebGL (the rack's renderer): liquid gold lettering with a soft bevel, reflections
  // that roll with the light, a light that follows the cursor and a sheen that sweeps across every few seconds; the
  // logo gets the same sheen. Under it a soft shadow (light rooms) or a warm glow (dark rooms) lifts it off any room.
  // The DOM text stays (transparent) for screen readers and the hover; the particle canvas still does the morph.
  const glT = (() => {
    const TV = `
uniform vec4 uRect; uniform vec2 uView; varying vec2 vF;
void main(){ vF = vec2(uv.x, 1.0 - uv.y); vec2 px = uRect.xy + vF * uRect.zw;
  gl_Position = projectionMatrix * viewMatrix * vec4(px.x - uView.x * 0.5, uView.y * 0.5 - px.y, 0.0, 1.0); }`;
    const TF = `
uniform sampler2D uText, uLogo; uniform vec2 uTexel, uLight; uniform float uMode, uAlpha, uDark, uSweep;
varying vec2 vF;
vec4 tx(sampler2D t, vec2 f, float b){ return texture2D(t, vec2(f.x, 1.0 - f.y), b); }
float A(vec2 f, float b){ return mix(tx(uText, f, b).a, tx(uLogo, f, b).a, uMode); }
void main(){
  vec2 f = vF;
  vec4 lg = tx(uLogo, f, 0.0);
  float a = A(f, 0.0);
  // a soft bevel: the letters blurred (mip bias) are the height, their slope the normal
  vec2 e = uTexel * 2.5;
  float hx = A(f + vec2(e.x, 0.0), 1.7) - A(f - vec2(e.x, 0.0), 1.7);
  float hy = A(f + vec2(0.0, e.y), 1.7) - A(f - vec2(0.0, e.y), 1.7);
  vec3 n = normalize(vec3(-hx * 2.4, hy * 2.4, 1.0));
  vec3 L = normalize(vec3(uLight, 0.85));
  float diff = max(dot(n, L), 0.0), spec = pow(max(dot(reflect(-L, n), vec3(0.0, 0.0, 1.0)), 0.0), 26.0);
  // polished gold: it mirrors a bright sky above and a dark floor below, in soft horizontal bands that roll with the light
  vec3 deep = vec3(0.30, 0.18, 0.06), mid = vec3(0.80, 0.58, 0.24), hi = vec3(1.0, 0.92, 0.66);
  float env = 0.5 + 0.5 * n.y + 0.25 * uLight.y;
  float bands = 0.5 + 0.5 * sin((f.y * 7.0 - n.y * 1.4 + uLight.x * 0.6) * 3.14159);
  vec3 gold = mix(deep, mid, smoothstep(0.05, 0.95, env * 0.62 + bands * 0.28 + diff * 0.3));
  gold = mix(gold, hi, clamp(spec * 0.95 + smoothstep(0.82, 1.0, bands) * 0.18, 0.0, 1.0));
  float sw = exp(-pow((f.x * 2.4 + f.y * 0.7 - uSweep) / 0.11, 2.0));   // the sheen
  gold += hi * sw * 0.6;
  vec3 lr = lg.rgb / max(lg.a, 0.001);
  vec3 logoC = lr * (0.9 + 0.16 * diff) + hi * sw * 0.32 * smoothstep(0.2, 0.8, dot(lr, vec3(0.33)));   // the logo keeps its own colours: only the sheen
  vec3 base = mix(gold, logoC, uMode);
  // lift it off the room: a soft shadow below the letters (light rooms), a warm glow round them (dark rooms)
  float soft = A(f + vec2(0.0, uTexel.y * 3.0), 3.4), wide = A(f, 4.6);
  vec4 halo = mix(vec4(0.0, 0.0, 0.0, 0.34 * soft + 0.12 * wide), vec4(vec3(1.0, 0.8, 0.45) * (0.2 * soft + 0.16 * wide), 0.22 * soft), uDark);
  vec4 c = vec4(base * a, a) + halo * (1.0 - a);
  gl_FragColor = c * uAlpha;
}`;
    const tc = document.createElement('canvas'), lc = document.createElement('canvas');
    const mkT = c => { const tt = new THREE.CanvasTexture(c); tt.minFilter = THREE.LinearMipmapLinearFilter; tt.generateMipmaps = true; tt.premultiplyAlpha = true; textures.push(tt); return tt; };
    const u = { uRect: { value: new THREE.Vector4() }, uView: globals.uView, uText: { value: mkT(tc) }, uLogo: { value: mkT(lc) },
      uTexel: { value: new THREE.Vector2(1, 1) }, uLight: { value: new THREE.Vector2(-0.45, 0.6) }, uMode: { value: 0 }, uAlpha: { value: 0 }, uDark: { value: 0 }, uSweep: { value: -2 } };
    const mesh = new THREE.Mesh(new THREE.PlaneGeometry(1, 1), new THREE.ShaderMaterial({ uniforms: u, vertexShader: TV, fragmentShader: TF, transparent: true,
      premultipliedAlpha: true, depthTest: false, depthWrite: false, blending: THREE.CustomBlending, blendSrc: THREE.OneFactor, blendDst: THREE.OneMinusSrcAlphaFactor }));
    mesh.frustumCulled = false; mesh.renderOrder = 6; mesh.visible = false; scene.add(mesh);
    let ok = false, sweepAge = 1.2, period = 6, lx = -0.45, ly = 0.6;
    function update(w, h, rect, paintText, paintLogo) {
      [tc, lc].forEach(c => { c.width = w; c.height = h; });
      paintText(tc.getContext('2d')); paintLogo(lc.getContext('2d'));
      u.uText.value.needsUpdate = true; u.uLogo.value.needsUpdate = true;
      u.uTexel.value.set(1 / w, 1 / h); u.uRect.value.set(rect.x, rect.y, rect.w, rect.h); ok = true;
    }
    function frame(dt, tt) {
      mesh.visible = ok;
      if (!ok) return;
      u.uMode.value = tt > 0.5 ? 1 : 0;
      u.uAlpha.value = tt < 0.12 ? 1 - tt / 0.12 : tt > 0.88 ? (tt - 0.88) / 0.12 : 0;   // hands over to the particles and back
      u.uDark.value += ((root.dataset.tone === 'dark' ? 1 : 0) - u.uDark.value) * Math.min(1, dt * 4);
      sweepAge += dt; if (sweepAge > period) { sweepAge = 0; period = 5.5 + Math.random() * 2.5; }
      u.uSweep.value = REDUCED ? -2 : -0.7 + sweepAge / 1.7 * 3.6;
      const r = u.uRect.value, cx = r.x + r.z / 2, cy = r.y + r.w / 2;
      let tx = -0.45 + 0.2 * Math.sin(simT * 0.3), ty = 0.6;
      if (P.inside && P.type !== 'touch' && lifted < 0) { tx = clamp((P.x - cx) / (W * 0.3), -1, 1) * 0.9; ty = 0.3 + clamp((cy - P.y) / (H * 0.4), -1, 1) * 0.5; }
      lx += (tx - lx) * Math.min(1, dt * 3); ly += (ty - ly) * Math.min(1, dt * 3); u.uLight.value.set(lx, ly);
    }
    return { update, frame, get ok() { return ok; } };
  })();
  const goldInk = () => root.dataset.tone === 'dark' ? '#E9C67C' : '#A9792B';   // the particles' colour: the gold's
  function sample(draw) {                       // opaque pixels of a drawing on a grid, as [x, y, r, g, b] in device px
    const c = document.createElement('canvas'); c.width = cw; c.height = ch; const x = c.getContext('2d'); draw(x);
    const d = x.getImageData(0, 0, cw, ch).data, out = [], step = Math.max(1, Math.round(1.5 * (cw / cv.clientWidth)));
    for (let yy = 0; yy < ch; yy += step) for (let xx = 0; xx < cw; xx += step) { const i = (yy * cw + xx) * 4; if (d[i + 3] > 140) out.push([xx, yy, d[i], d[i + 1], d[i + 2]]); }
    return out.sort((p, q) => p[0] - q[0] || p[1] - q[1]);
  }
  // re-sampled whenever the tone (logo version), size or fonts change. It checks everything it needs BEFORE touching
  // the canvas, and draw() only hides the text while particles or the logo are really on the canvas: switching rooms
  // quickly used to clear the canvas with the text already hidden, leaving the top of the rack empty.
  function prepare() {
    const r = cv.getBoundingClientRect(); if (!r.width) return;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const lg = $(root.dataset.tone === 'dark' ? '.armory__logo--light' : '.armory__logo--dark');
    if (!lg || !lg.complete || !lg.naturalWidth) { if (lg) lg.addEventListener('load', prepare, { once: true }); shown = -1; return; }
    logo = lg;
    cw = cv.width = Math.round(r.width * dpr); ch = cv.height = Math.round(r.height * dpr); buf = g.createImageData(cw, ch);
    const cs = getComputedStyle(el), er = el.getBoundingClientRect();
    const font = `${cs.fontStyle} ${cs.fontWeight} ${parseFloat(cs.fontSize) * dpr}px ${cs.fontFamily}`;
    const cx = (er.left + er.width / 2 - r.left) * dpr, cy = (er.top - r.top) * dpr, lh = er.height * dpr;
    const paintText = (x, col) => { x.font = font; x.fillStyle = col; x.textAlign = 'center'; x.textBaseline = 'alphabetic';
      const m = x.measureText(el.textContent); const asc = m.fontBoundingBoxAscent || m.actualBoundingBoxAscent, des = m.fontBoundingBoxDescent || m.actualBoundingBoxDescent;
      x.fillText(el.textContent, cx, cy + (lh - (asc + des)) / 2 + asc); };
    const A = sample(x => paintText(x, goldInk()));
    const h = Math.min(80, Math.max(48, H * 0.08)) * dpr, w = h * logo.naturalWidth / logo.naturalHeight;
    logoRect = [cx - w / 2, cy + lh / 2 - h / 2, w, h];
    const B = sample(x => x.drawImage(logo, ...logoRect));
    const rr = root.getBoundingClientRect();
    try { glT.update(cw, ch, { x: r.left - rr.left, y: r.top - rr.top, w: r.width, h: r.height }, x => paintText(x, '#fff'), x => x.drawImage(logo, ...logoRect)); } catch (e) {}
    if (!A.length || !B.length) { ready = false; shown = -1; draw(); return; }
    N = Math.min(7000, Math.max(A.length, B.length));
    [ax, ay, bx, by, dl, an, am] = [0, 0, 0, 0, 0, 0, 0].map(() => new Float32Array(N)); ca = new Uint8ClampedArray(N * 3); cb = new Uint8ClampedArray(N * 3);
    for (let i = 0; i < N; i++) {
      const p = A[Math.floor(i * A.length / N)], q = B[Math.floor(i * B.length / N)];
      ax[i] = p[0]; ay[i] = p[1]; bx[i] = q[0]; by[i] = q[1];
      ca.set(p.slice(2), i * 3); cb.set(q.slice(2), i * 3);
      dl[i] = rnd(i, 1) * 0.35; an[i] = rnd(i, 2) * 6.283; am[i] = (10 + rnd(i, 3) * 34) * dpr;
    }
    ready = true; shown = -1; draw();
  }
  function draw() {
    if (t === shown) return; shown = t;
    el.classList.toggle('is-fx', ready && t > 0);   // the text stays up until there is something to show instead
    el.classList.toggle('is-gl', glT.ok);          // the WebGL title draws the resting states
    g.clearRect(0, 0, cw, ch);
    if (!ready || t === 0) return;
    if (t === 1) { if (!glT.ok) g.drawImage(logo, ...logoRect); return; }
    const d = buf.data; d.fill(0);
    for (let i = 0; i < N; i++) {
      const k = Math.min(1, Math.max(0, t * 1.35 - dl[i])), e = k * k * (3 - 2 * k), s = Math.sin(Math.PI * k) * am[i], th = an[i] + k * 4;
      const x = Math.round(ax[i] + (bx[i] - ax[i]) * e + Math.cos(th) * s), y = Math.round(ay[i] + (by[i] - ay[i]) * e + Math.sin(th) * s);
      if (x < 0 || y < 0 || x >= cw - 1 || y >= ch - 1) continue;
      const r = ca[i * 3] + (cb[i * 3] - ca[i * 3]) * e, gg = ca[i * 3 + 1] + (cb[i * 3 + 1] - ca[i * 3 + 1]) * e, b = ca[i * 3 + 2] + (cb[i * 3 + 2] - ca[i * 3 + 2]) * e;
      for (let o = 0; o < 4; o++) { const j = ((y + (o >> 1)) * cw + x + (o & 1)) * 4; d[j] = r; d[j + 1] = gg; d[j + 2] = b; d[j + 3] = 255; }
    }
    g.putImageData(buf, 0, 0);
  }
  function tick(dt) {
    if (t !== target) t = REDUCED ? target : target > t ? Math.min(1, t + dt / 1.15) : Math.max(0, t - dt / 1.15);
    draw(); glT.frame(dt, t);
  }
  // each hover switches it (text <-> logo) and it stays that way until the next hover; a short guard ignores the
  // pointer grazing the edge
  let lastSwitch = -1e9;
  el.addEventListener('pointerenter', e => { if (e.pointerType === 'touch' || performance.now() - lastSwitch < 350) return; lastSwitch = performance.now(); target = target ? 0 : 1; });
  el.addEventListener('click', () => { if (COARSE) target = target ? 0 : 1; });
  if (document.fonts && document.fonts.load) document.fonts.load(`italic 40px ${getComputedStyle(el).fontFamily}`).then(() => prepare());
  if (document.fonts) { document.fonts.addEventListener && document.fonts.addEventListener('loadingdone', () => prepare()); document.fonts.ready.then(() => prepare()); }
  return { prepare, tick, set(v) { target = v; } };
})();

/* decor DOM: logo, shelves, ticker, shield */
const racks = [];
function buildDecor() {
  const D0 = opts.decor || {};
  if (D0.logo_dark) { [['dark', D0.logo_dark], ['light', D0.logo_light]].forEach(([k, src]) => { const im = $(`.armory__logo--${k}`); im.crossOrigin = 'anonymous'; im.src = src; }); }
  const track = $('.armory__track'); let html = '';
  for (let k = 0; k < 12; k++) html += '<span>Welcome Home King</span><i>&#9670;</i><span>@otk.digital</span><i>&#9670;</i>';
  track.innerHTML = html + html;
  ['l', 'r'].forEach(side => {
    const el = $(`.armory__rack--${side}`); if (!el) return;
    el.querySelector('.armory__rail-img').src = D0.peg_rail || '';
    const caps = el.querySelector('.armory__caps'), label = el.querySelector('.armory__hatlabel');
    const rack = { el, b: 1, hats: [], pegs: [] }; racks.push(rack);
    const list = (D0.hats || []).filter(h => h.shelf === side);
    list.forEach((h, k) => {
      const peg = document.createElement('span'); peg.className = 'armory__peg';
      el.insertBefore(peg, el.querySelector('.armory__rail-img')); rack.pegs.push(peg);
      const a = document.createElement('a'); a.className = 'armory__hat'; a.href = h.url; if (opts.newTab !== false) { a.target = '_blank'; a.rel = 'noopener'; }
      a.setAttribute('aria-label', `${h.name}, ${priceOf(h)}`);
      const img = document.createElement('img'); img.src = h.src; img.alt = ''; a.append(img); caps.append(a);
      const hat = { h, el: a, k, n: list.length, th: 0, w: 0, rest: 0, L: 40, inside: false, armed: false, px: 0, py: 0, hw: 0, hh: 0 };
      rack.hats.push(hat);
      const show = () => { label.querySelector('b').textContent = h.name; const sp = label.querySelector('span'); sp.textContent = ''; const em = document.createElement('em'); em.textContent = priceOf(h); sp.append(em); el.classList.add('is-hover'); };
      const hide = () => { el.classList.remove('is-hover'); hat.armed = false; };
      // a lifted finger always "leaves", so on touch the cap stays armed until the next tap lands somewhere else
      a.addEventListener('pointerenter', show); a.addEventListener('pointerleave', e => { if (e.pointerType !== 'touch') hide(); });
      root.addEventListener('pointerdown', e => { if (e.pointerType === 'touch' && !a.contains(e.target)) hide(); });
      a.addEventListener('focus', () => { show(); hat.w += 1.2; }); a.addEventListener('blur', hide);
      a.addEventListener('click', ev => {
        if (COARSE && !hat.armed) { ev.preventDefault(); hat.armed = true; show(); hat.w += 1.6; return; }
        if (h.views && Object.keys(h.views).length) { ev.preventDefault(); hide(); capView.open(hat); }   // lift it into the viewer
      });
    });
  });
  const shield = $('.armory__shield:not(.armory__shield--tod)');
  shield.addEventListener('click', () => {
    const r = shield.getBoundingClientRect(), rr = root.getBoundingClientRect();
    reveal.set(r.left - rr.left + r.width / 2, r.top - rr.top + r.height / 2);
    needSakura();   // fetch the cherry tree early, before anyone reaches its room
    // in the time-of-day sky the room shield leaves it, back to the room it was showing (on landing: the default room)
    if (tod) { const back = todFrom; leaveTod(); applyTheme(back, true); }
    else applyTheme(nextRoom(), true);
    shield.classList.remove('is-spin'); void shield.offsetWidth; shield.classList.add('is-spin');
    setTimeout(() => shield.classList.remove('is-spin'), 800);
    if (Sound.on) { Sound.clink(1); setTimeout(() => Sound.clink(0.6), 90); }
  });
}
function applyTheme(i, animate, noStore) {
  if (animate && themeT < 1) { themePrev = theme; }       // clicking mid-reveal: start from where we are
  else themePrev = animate ? theme : i;
  theme = i;
  if (i === SAKURA) needSakura();
  if (animate) {
    themeT = 0; themeMix = 0;
    // the page tone (title, labels, logo version) follows what is on screen behind the title: the old room until the
    // reveal's edge passes the title, then the new one. Before, it switched halfway through the reveal, so switching
    // quickly could leave a light title on a white wall (it looked gone)
    if (themeApplied !== themePrev) { themeApplied = themePrev; applyThemeDom(); }
    const tEl = $('.armory__title');
    if (tEl) { const r = tEl.getBoundingClientRect(), rr = root.getBoundingClientRect();
      toneAt = clamp((Math.hypot(r.left - rr.left + r.width / 2 - reveal.x, r.top - rr.top + r.height / 2 - reveal.y) + 30) / (Math.hypot(W, H) * 1.05), 0.05, 0.98); }
  } else { themeT = 1; themeMix = 1; themeApplied = i; applyThemeDom(); }
  if (animate && ROOM_KEY && !noStore && !THEMES[i].hidden) try { localStorage.setItem(ROOM_KEY, String(i)); } catch (e) {}   // only a visitor's own pick is remembered
}
function applyThemeDom() {
  const t = THEMES[themeApplied], retone = root.dataset.tone !== t.tone;
  root.dataset.theme = t.id; root.dataset.tone = t.tone;
  layoutDecor();
  if (retone) title.prepare();   // the text colour and logo version follow the room's tone
}
function layoutRacks() {
  // caps sit on turned pegs that rise from a walnut rail below them; each cap pivots where the peg meets the inside of its crown
  racks.forEach(rk => {
    const rw = rk.el.offsetWidth, boardH = rw * 104 / 700;
    const sizes = rk.hats.map(ht => { const hw = rw * 0.36, hh = hw / ht.h.aspect; return { hw, hh }; });
    const above = Math.max(...sizes.map((z, k) => rk.hats[k].h.pivot[1] * z.hh), 10);
    const below = Math.max(...sizes.map((z, k) => (1 - rk.hats[k].h.pivot[1]) * z.hh), 10);
    const pivotY = 6 + above, boardTop = pivotY + below + Math.max(10, rw * 0.045);
    rk.el.style.height = (boardTop + boardH) + 'px';
    // the bar fills the middle third of its image: the image sits a third higher, so the bar starts at boardTop
    const img = rk.el.querySelector('.armory__rail-img'); img.style.top = (boardTop - boardH * 0.33) + 'px';
    rk.hats.forEach((ht, k) => {
      const { hw, hh } = sizes[k];
      const pegX = rw * (ht.n > 1 ? 0.28 + 0.44 * k / (ht.n - 1) : 0.5);
      const pv = ht.h.pivot, cm = ht.h.com;
      Object.assign(ht.el.style, { width: hw + 'px', left: (pegX - pv[0] * hw) + 'px', top: (pivotY - pv[1] * hh) + 'px', transformOrigin: `${pv[0] * 100}% ${pv[1] * 100}%` });
      // a square-section steel J-hook: it leaves the bar at mid-height, bends and rises into the cap
      const pw = Math.max(5, rw * 0.02), peg = rk.pegs[k];
      Object.assign(peg.style, { left: (pegX - pw / 2) + 'px', top: (pivotY + hh * 0.08) + 'px', width: pw + 'px', height: (boardTop - pivotY - hh * 0.08 + boardH * 0.17) + 'px' });
      const dx = (cm[0] - pv[0]) * hw, dy = (cm[1] - pv[1]) * hh;
      ht.rest = clamp(-Math.atan2(dx, dy), -0.12, 0.12); ht.L = Math.max(10, Math.hypot(dx, dy));
      if (!ht.placed) { ht.th = ht.rest; ht.placed = true; }
      ht.px = rk.el.offsetLeft + pegX; ht.py = rk.el.offsetTop + pivotY; ht.hw = hw; ht.hh = hh;
    });
  });
}
// caps rock on their pegs like little pendulums: brushed by the cursor, kicked when touched
function updateHats(dt) {
  const n = Math.max(1, Math.ceil(dt / (1 / 240))), h = dt / n;
  racks.forEach(rk => rk.hats.forEach(ht => {
    const pv = ht.h.pivot;
    let inside = false, lever = 0, near = 0;
    if (P.inside && lifted < 0) {
      const vx = P.x - ht.px, vy = P.y - ht.py, c = Math.cos(ht.th), s = Math.sin(ht.th);
      const lx = vx * c + vy * s, ly = -vx * s + vy * c;
      const x0 = -pv[0] * ht.hw, x1 = (1 - pv[0]) * ht.hw, y0 = -pv[1] * ht.hh, y1 = (1 - pv[1]) * ht.hh;
      inside = lx > x0 && lx < x1 && ly > y0 && ly < y1;
      near = inside ? 1 : (lx > x0 - 18 && lx < x1 + 18 && ly > y0 - 10 && ly < y1 + 10) ? 0.3 : 0;
      lever = clamp(ly / ht.hh, 0.15, 1);
    }
    if (inside && !ht.inside && !REDUCED) ht.w += clamp(P.vx / 700, -1.4, 1.4) + (P.vx >= 0 ? 0.25 : -0.25);
    ht.inside = inside;
    for (let k = 0; k < n; k++) {
      let tq = -70 * Math.sin(ht.th - ht.rest) - 2.4 * ht.w + (breezeK - 1) * 1.4 * Math.sin(simT * 0.8 + ht.k * 2.1 + ht.px * 0.01) + 26 * gustAt(ht.px);
      if (near && !REDUCED) tq += 1.5 * clamp(P.vx, -2400, 2400) * near * lever / ht.L;
      ht.w += tq * h; ht.th += ht.w * h;
    }
    if (Math.abs(ht.th - ht.rest) > 0.32) { ht.th = ht.rest + Math.sign(ht.th - ht.rest) * 0.32; ht.w *= -0.3; }
    const v = ht.th.toFixed(4);
    if (v !== ht.last) { ht.last = v; ht.el.style.transform = `rotate(${v}rad)`; }
  }));
}
function layoutDecor() {
  spotFixture.x = W / 2; spotFixture.y = -H * 0.55; spotFixture.z = H * 0.95;
  layoutRacks();
}

/* ---------------- the glow round each bolt (every room): brighter on hover and while a piece is lifted; a click opens heaven ---------------- */
function bolts() {
  const Dz = H * 0.5 / Math.tan(FOV / 2 * Math.PI / 180), f = Dz / (Dz - globals.uWallZ.value);
  return [railL, railR].map(x => ({ x: W / 2 + (x + rail.ox - W / 2) * f, y: H / 2 + (railY + rail.oy - H / 2) * f }));
}
function boltHit(x, y) {
  const T = THEMES[themeApplied];   // every room, and the time-of-day sky (hidden from the cycle); not heaven itself
  if ((T.hidden && !(tod && themeApplied === SKY)) || lifted >= 0 || capView.active || themeT < 1) return null;
  return bolts().find(b => Math.hypot(x - b.x, y - b.y) < Math.max(18, S * 0.2)) || null;
}
function enterHeaven(b) {
  boltHover = false; heavenFrom = theme;
  if (tod) { heavenFrom = todFrom; leaveTod(); }   // from the time-of-day sky: night mode ends here
  reveal.set(b.x, b.y); applyTheme(HEAVEN, true, true);
}

/* ---------------- time of day: the dark shield on the left shows the sky as it is outside right now ---------------- */
const TOD = [   // hour, zenith, horizon, cloud lit, cloud shade, sun / moon glow, stars
  [0.0, [0.012, 0.018, 0.055], [0.05, 0.07, 0.15], [0.26, 0.29, 0.4], [0.06, 0.07, 0.12], [0.45, 0.5, 0.65], 1],
  [4.8, [0.02, 0.03, 0.09], [0.1, 0.1, 0.2], [0.3, 0.3, 0.42], [0.08, 0.09, 0.15], [0.5, 0.5, 0.62], 0.85],
  [6.0, [0.16, 0.22, 0.45], [0.98, 0.62, 0.5], [1.0, 0.76, 0.64], [0.45, 0.38, 0.5], [1.0, 0.64, 0.42], 0.1],
  [7.5, [0.17, 0.35, 0.68], [0.86, 0.82, 0.8], [1.0, 0.93, 0.86], [0.5, 0.54, 0.66], [1.0, 0.86, 0.66], 0],
  [9.0, [0.15, 0.38, 0.75], [0.66, 0.8, 0.93], [1.0, 0.985, 0.955], [0.5, 0.57, 0.69], [1.0, 0.95, 0.84], 0],
  [16.0, [0.15, 0.38, 0.75], [0.66, 0.8, 0.93], [1.0, 0.985, 0.955], [0.5, 0.57, 0.69], [1.0, 0.95, 0.84], 0],
  [17.8, [0.17, 0.32, 0.62], [1.0, 0.74, 0.45], [1.0, 0.85, 0.64], [0.52, 0.45, 0.52], [1.0, 0.72, 0.42], 0],
  [19.0, [0.2, 0.2, 0.42], [1.0, 0.5, 0.27], [1.0, 0.62, 0.42], [0.42, 0.3, 0.42], [1.0, 0.52, 0.26], 0.05],
  [20.2, [0.06, 0.07, 0.2], [0.42, 0.22, 0.38], [0.5, 0.35, 0.46], [0.14, 0.12, 0.2], [0.62, 0.38, 0.42], 0.5],
  [21.5, [0.012, 0.018, 0.055], [0.05, 0.07, 0.15], [0.26, 0.29, 0.4], [0.06, 0.07, 0.12], [0.45, 0.5, 0.65], 1],
  [24.0, [0.012, 0.018, 0.055], [0.05, 0.07, 0.15], [0.26, 0.29, 0.4], [0.06, 0.07, 0.12], [0.45, 0.5, 0.65], 1],
];
function todAt(h) {
  h = ((h % 24) + 24) % 24;
  let k = 0; while (k < TOD.length - 2 && TOD[k + 1][0] <= h) k++;
  const a = TOD[k], b = TOD[k + 1], f = clamp((h - a[0]) / Math.max(1e-3, b[0] - a[0]), 0, 1), m = f * f * (3 - 2 * f);
  const mix3 = j => a[j].map((v, c) => lerp(v, b[j][c], m));
  // the sun crosses from the left (sunrise 6:00) to the right (sunset 19:00); the moon comes back across overnight
  const sf = (h - 6) / 13, night = sf < 0 || sf > 1, mf = ((h + 24 - 19) % 24) / 11;
  const sun = night ? [1.05 - 1.1 * mf, -0.08 - 0.3 * Math.sin(Math.PI * mf)] : [-0.15 + 1.3 * sf, -0.1 - 0.38 * Math.sin(Math.PI * sf)];
  return { zen: mix3(1), hor: mix3(2), lit: mix3(3), shade: mix3(4), sunC: mix3(5), stars: lerp(a[6], b[6], m), sun, night,
           moon: [0.86 - 0.72 * Math.min(1, mf), 0.2 - 0.08 * Math.sin(Math.PI * Math.min(1, mf))] };
}
const todBtn = $('.armory__shield--tod'), roomBtn = $('.armory__shield:not(.armory__shield--tod)');
let tod = false, todFrom = 0, todMix = 0;
const hourNow = () => opts.hour != null ? opts.hour : new Date().getHours() + new Date().getMinutes() / 60;
// the room shield stays put through it all (owner, 2026-10-03: no more burning away and bursting back; shieldFx unused)
function setTod(on, animate = true) {
  if (on === tod || !todBtn) return;
  tod = on; todBtn.setAttribute('aria-pressed', String(on));
  try { localStorage.setItem('otk-armory-tod', on ? '1' : '0'); } catch (e) {}
  const r = todBtn.getBoundingClientRect(), rr = root.getBoundingClientRect();
  reveal.set(r.left - rr.left + r.width / 2, r.top - rr.top + r.height / 2);
  if (on) { todFrom = THEMES[theme].hidden ? heavenFrom : theme; applyTheme(SKY, animate, true); }
  else applyTheme(todFrom, animate, true);
}
function leaveTod() {   // night mode ends without a reveal of its own (the caller shows where it goes)
  if (!tod) return; tod = false; if (todBtn) todBtn.setAttribute('aria-pressed', 'false');
  try { localStorage.setItem('otk-armory-tod', '0'); } catch (e) {}
}
if (todBtn) { if (opts.timeOfDay === false) todBtn.hidden = true; else todBtn.addEventListener('click', () => setTod(!tod)); }
function syncSky(dt) {
  todMix += ((tod ? 1 : 0) - todMix) * Math.min(1, dt * 1.6);
  if (themeT >= 1) {   // the page tone follows the sky: after dark the title, labels and logo go light
    const z = bgMat.uniforms.uZen.value, want = tod && themeApplied === SKY && (z.x + z.y + z.z) < 0.6 ? 'dark' : THEMES[themeApplied].tone;
    if (root.dataset.tone !== want) { root.dataset.tone = want; title.prepare(); }
  }
  const d = todAt(12), n = todAt(hourNow()), m = todMix, u = bgMat.uniforms;
  [['zen', u.uZen], ['hor', u.uHor], ['lit', u.uCLit], ['shade', u.uCShade], ['sunC', u.uSunC]].forEach(([k, un]) => un.value.set(lerp(d[k][0], n[k][0], m), lerp(d[k][1], n[k][1], m), lerp(d[k][2], n[k][2], m)));
  u.uSunP.value.set(lerp(d.sun[0], n.sun[0], m), lerp(d.sun[1], n.sun[1], m));
  u.uStars.value = n.stars * m; u.uMoonP.value.set(n.moon[0], n.moon[1]);
  const src = n.night && m > 0.5 ? n.moon : [u.uSunP.value.x, u.uSunP.value.y];   // clouds lit by the sun, or the moon at night
  const dx = src[0] - 0.5, dy = src[1] - 0.45, len = Math.hypot(dx, dy) || 1;
  u.uToSun.value.set(dx / len * 0.038, dy / len * 0.03);
}

/* ---------------- the room shield bursts into flames when time of day takes over, and returns in a burst of light ---------------- */
const shieldFx = (() => {
  const cv = $('.armory__shield-fx'); if (!cv || !roomBtn) return { burn() {}, restore() {} };
  const g2 = cv.getContext('2d');
  let img = null, run = 0;
  function sprite() {
    if (img) return img;
    const svg = roomBtn.querySelector('svg').cloneNode(true); svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg'); svg.setAttribute('width', '136'); svg.setAttribute('height', '160');
    img = new Image(); img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(new XMLSerializer().serializeToString(svg)); return img;
  }
  // the canvas is far larger than the effects (flames rise, the burst spreads), kept inside the section, and every edge
  // is feathered (`feather`), so neither effect ever shows the canvas's boundary
  function place(btn) {
    const r = btn.getBoundingClientRect(), rr = root.getBoundingClientRect(), dpr = Math.min(2, window.devicePixelRatio || 1);
    const cx = r.left - rr.left + r.width / 2, cy = r.top - rr.top + r.height / 2;
    const x0 = Math.max(0, cx - r.width * 5), x1 = Math.min(rr.width, cx + r.width * 5);
    const y0 = Math.max(0, cy - r.height * 5.5), y1 = Math.min(rr.height, cy + r.height * 3.5);
    Object.assign(cv.style, { left: x0 + 'px', top: y0 + 'px', width: (x1 - x0) + 'px', height: (y1 - y0) + 'px' });
    cv.width = Math.round((x1 - x0) * dpr); cv.height = Math.round((y1 - y0) * dpr);
    return { dpr, sx: (r.left - rr.left - x0) * dpr, sy: (r.top - rr.top - y0) * dpr, sw: r.width * dpr, sh: r.height * dpr };
  }
  function feather(G2) {
    const cx = G2.sx + G2.sw / 2, cy = G2.sy + G2.sh / 2, W2 = cv.width, H2 = cv.height;
    g2.globalCompositeOperation = 'destination-in';
    [[0, 0, 1, 0, cx, G2.sw], [W2, 0, -1, 0, W2 - cx, G2.sw], [0, 0, 0, 1, cy, G2.sh], [0, H2, 0, -1, H2 - cy, G2.sh]].forEach(([x, y, dx, dy, dist, size]) => {
      const f = Math.max(1, (dist - size * 0.65) * 0.85), gr = g2.createLinearGradient(x, y, x + dx * f, y + dy * f);   // stops short of the shield itself
      gr.addColorStop(0, 'rgba(0,0,0,0)'); gr.addColorStop(1, 'rgba(0,0,0,1)'); g2.fillStyle = gr; g2.fillRect(0, 0, W2, H2);
    });
    g2.globalCompositeOperation = 'source-over';
  }
  const rnd = (x, y) => { const s = Math.sin(x * 12.9898 + y * 78.233) * 43758.5453; return s - Math.floor(s); };
  function drawFlames(parts, dt, G2) {
    g2.globalCompositeOperation = 'lighter';
    for (let i = parts.length - 1; i >= 0; i--) {
      const q = parts[i]; q.life += dt; if (q.life > q.max) { parts.splice(i, 1); continue; }
      q.vy -= 160 * G2.dpr * dt; q.vx += (Math.random() - 0.5) * 220 * G2.dpr * dt; q.x += q.vx * dt; q.y += q.vy * dt;
      const k = q.life / q.max, r = q.r * (1 - 0.55 * k);
      const c = k < 0.2 ? [255, 246, 214] : k < 0.5 ? [255, 196, 80] : k < 0.8 ? [255, 112, 34] : [170, 40, 18];
      const gr = g2.createRadialGradient(q.x, q.y, 0, q.x, q.y, r);
      gr.addColorStop(0, `rgba(${c[0]},${c[1]},${c[2]},${0.85 * (1 - k)})`); gr.addColorStop(1, `rgba(${c[0]},${c[1]},${c[2]},0)`);
      g2.fillStyle = gr; g2.beginPath(); g2.arc(q.x, q.y, r, 0, 6.2832); g2.fill();
    }
    g2.globalCompositeOperation = 'source-over';
  }
  function burn(btn, animate) {
    btn.classList.add('is-gone'); if (!animate || REDUCED) return;
    const im = sprite(), G2 = place(btn), id = ++run, parts = [];
    const go = () => {
      const off = document.createElement('canvas'); off.width = Math.ceil(G2.sw); off.height = Math.ceil(G2.sh);
      const og = off.getContext('2d'); og.drawImage(im, 0, 0, off.width, off.height);
      const base = og.getImageData(0, 0, off.width, off.height), out = og.createImageData(off.width, off.height), Wd = off.width, Hd = off.height;
      const field = new Float32Array(Wd * Hd);     // where the fire eats first: from the bottom up, ragged
      for (let y = 0; y < Hd; y++) for (let x = 0; x < Wd; x++) {
        const nx = x / Wd, ny = y / Hd, a = rnd(Math.floor(nx * 5), Math.floor(ny * 6)), b = rnd(Math.floor(nx * 11) + 7, Math.floor(ny * 13) + 3);
        field[y * Wd + x] = 0.6 * (1 - ny) + 0.28 * a + 0.12 * b;
      }
      let t0 = 0, last = 0;
      const tick = now => {
        if (id !== run) return;
        if (!t0) t0 = last = now;
        const t = (now - t0) / 1000, dt = Math.min(0.05, (now - last) / 1000); last = now;
        g2.clearRect(0, 0, cv.width, cv.height);
        const pb = clamp((t - 0.45) / 1.15, 0, 1) * 1.05, lick = clamp(t / 0.45, 0, 1), edge = [];
        for (let i = 0; i < field.length; i++) {
          const j = i * 4; let r = base.data[j], gg = base.data[j + 1], b = base.data[j + 2], al = base.data[j + 3];
          const e = field[i] - pb;
          if (pb > 0 && e < 0) al = 0;
          else if (pb > 0 && e < 0.1) { const k = 1 - e / 0.1; r = lerp(r, 255, k); gg = lerp(gg, 120 + 110 * k, k); b = lerp(b, 30, k); if (al > 100 && (i & 7) === 0) edge.push(i); }
          else { r = lerp(r, 255, 0.25 * lick); gg = lerp(gg, 170, 0.18 * lick); }   // the flames' glow on it before it catches
          out.data[j] = r; out.data[j + 1] = gg; out.data[j + 2] = b; out.data[j + 3] = al;
        }
        og.putImageData(out, 0, 0); g2.drawImage(off, G2.sx, G2.sy);
        if (t < 1.75) for (let k = 0; k < 7; k++) {    // new flames: around its lower rim at first, then along the burning front
          let x, y;
          if (edge.length && pb > 0.02) { const i = edge[Math.floor(Math.random() * edge.length)]; x = G2.sx + (i % Wd); y = G2.sy + Math.floor(i / Wd); }
          else { x = G2.sx + G2.sw * (0.1 + 0.8 * Math.random()); y = G2.sy + G2.sh * (0.55 + 0.45 * Math.random()); }
          parts.push({ x, y, vx: (Math.random() - 0.5) * 40 * G2.dpr, vy: -(50 + Math.random() * 90) * G2.dpr, r: (5 + Math.random() * 9) * G2.dpr, life: 0, max: 0.4 + Math.random() * 0.5 });
        }
        drawFlames(parts, dt, G2); feather(G2);
        if (t < 2.6 || parts.length) requestAnimationFrame(tick); else g2.clearRect(0, 0, cv.width, cv.height);
      };
      requestAnimationFrame(tick);
    };
    if (im.complete && im.naturalWidth) go(); else im.onload = go;
  }
  function restore(btn, animate) {
    if (!animate || REDUCED) { run++; g2.clearRect(0, 0, cv.width, cv.height); btn.classList.remove('is-gone'); return; }
    const im = sprite(), G2 = place(btn), id = ++run; let t0 = 0;
    const tick = now => {
      if (id !== run) return;
      if (!t0) t0 = now;
      const t = (now - t0) / 1000, cx = G2.sx + G2.sw / 2, cy = G2.sy + G2.sh / 2, R0 = G2.sh * 2.6, fl = Math.max(0, 1 - t / 0.95);
      g2.clearRect(0, 0, cv.width, cv.height);
      g2.globalCompositeOperation = 'lighter';
      const rg = g2.createRadialGradient(cx, cy, 0, cx, cy, R0 * (0.25 + t * 1.1));
      rg.addColorStop(0, `rgba(255,248,222,${0.95 * fl})`); rg.addColorStop(0.35, `rgba(255,214,120,${0.5 * fl})`); rg.addColorStop(1, 'rgba(255,200,90,0)');
      g2.fillStyle = rg; g2.fillRect(0, 0, cv.width, cv.height);
      for (let k = 0; k < 14; k++) {                 // rays
        const a = k / 14 * 6.2832 + t * 0.7, len = R0 * (0.35 + 0.85 * Math.min(1, t / 0.35)) * (0.55 + 0.45 * ((k * 7) % 5) / 4);
        g2.strokeStyle = `rgba(255,236,170,${0.55 * fl})`; g2.lineWidth = 1.6 * G2.dpr;
        g2.beginPath(); g2.moveTo(cx + Math.cos(a) * G2.sw * 0.3, cy + Math.sin(a) * G2.sw * 0.3); g2.lineTo(cx + Math.cos(a) * len, cy + Math.sin(a) * len); g2.stroke();
      }
      g2.globalCompositeOperation = 'source-over';
      const k = clamp((t - 0.06) / 0.55, 0, 1), sc = 1 + 2.2 * Math.pow(k - 1, 3) + 1.2 * Math.pow(k - 1, 2);   // a spark grows into the shield, overshoots, settles
      if (k > 0) {
        const w = G2.sw * sc, h = G2.sh * sc;
        g2.globalAlpha = Math.min(1, k * 3); g2.drawImage(im, cx - w / 2, cy - h / 2, w, h);
        g2.globalCompositeOperation = 'lighter'; g2.globalAlpha = fl * 0.75; g2.drawImage(im, cx - w / 2, cy - h / 2, w, h);
        g2.globalAlpha = 1; g2.globalCompositeOperation = 'source-over';
      }
      feather(G2);
      if (t < 1.0) requestAnimationFrame(tick); else { g2.clearRect(0, 0, cv.width, cv.height); btn.classList.remove('is-gone'); }
    };
    requestAnimationFrame(tick);
  }
  return { burn, restore };
})();

/* ---------------- caps in the viewer: lifted off the peg in an arc, turned by dragging through photos of each side ---------------- */
const capView = (() => {
  const box = $('.armory__capview'), img = box && box.querySelector('img');
  const ORDER = ['front', 'right', 'back', 'left'];
  let hat = null, colour = null, ang = 0, angV = 0, key = '', last = null;
  const st = { active: false, angT: 0 };
  if (!box) return Object.assign(st, { open() {}, close() {}, snap() {}, step() {}, frame() {} });
  const rectOf = el => { const r = el.getBoundingClientRect(), rr = root.getBoundingClientRect(); return { x: r.left - rr.left, y: r.top - rr.top, w: r.width, h: r.height }; };
  // each colour's four photos share one canvas, so every side shows at the same scale (span = canvas width / front
  // cap width, vh = canvas height / front cap width). Every cap is shown at the same HEIGHT, fitted between the nav and
  // the info panel: sized by width, the taller dad caps on the right rack came out too big and ran over the name.
  const span = () => (hat && hat.h.span) || 1, vh = () => (hat && hat.h.vh) || 0.8;
  const target = () => {
    const Ha = H - inset, top = inset + Math.max(10, Ha * 0.04), bottom = (infoTop > top + 120 ? infoTop : H * 0.72) - 14;
    let ch = Math.min(Ha * (W < 640 ? 0.3 : 0.34), bottom - top), f = ch / vh();
    if (f * span() > W * 0.94) { f = W * 0.94 / span(); ch = f * vh(); }
    const w = f * span();
    return { x: W / 2 - w / 2, y: top + Math.max(0, bottom - top - ch) * 0.5, w, f };
  };
  // where the canvas starts so its front cap sits exactly on the cap on the peg (transform-origin is the top left)
  const onPeg = (R0, T) => { const s0 = R0.w / T.f, pad = (T.w - T.f) / 2 * s0; return { x: R0.x - pad, y: R0.y, s: s0 }; };
  function setColour(c) { colour = c; key = ''; const v = hat.h.views[c]; if (v) ORDER.forEach(k => { const im = new Image(); im.src = v[k]; }); }
  function fillUi() {
    ui.count.textContent = ''; ui.name.textContent = hat.h.name;
    ui.sub.textContent = ''; ui.sub.append(colour || ''); const em = document.createElement('em'); em.textContent = priceOf(hat.h); ui.sub.append(em);
    ui.cta.href = hat.h.url;
    buy.open(Object.assign({}, hat.h, { color: colour }), name => { setColour(name); ui.sub.firstChild.textContent = name; });
    ui.cta.textContent = 'View details';
  }
  function open(ht) {
    if (lifted >= 0) closeViewer();
    if (st.active) { hat.el.style.opacity = ''; }
    hat = ht; st.active = true; ang = 0; angV = 0; st.angT = 0;
    const cols = Object.keys(ht.h.views); setColour(ht.h.colour && ht.h.views[ht.h.colour] ? ht.h.colour : cols[0]);
    root.classList.add('is-open', 'is-cap'); fillUi();
    { const info = $('.armory__info'); infoTop = info ? info.getBoundingClientRect().top - root.getBoundingClientRect().top : 0; }
    const R0 = rectOf(ht.el), T = target(), A = onPeg(R0, T);
    box.style.width = T.w + 'px'; img.src = ht.h.views[colour].front; key = 'front';
    box.getAnimations().forEach(a => a.cancel());
    last = box.animate([
      { transform: `translate(${A.x}px,${A.y}px) scale(${A.s}) rotate(${ht.th}rad)` },
      { transform: `translate(${(A.x + T.x) / 2}px,${Math.min(A.y, T.y) - 50}px) scale(${(A.s + 1) / 2}) rotate(${-0.18 * Math.sign(T.x - A.x)}rad)`, offset: 0.45 },
      { transform: `translate(${T.x}px,${T.y}px) scale(1) rotate(0rad)` }], { duration: REDUCED ? 1 : 780, easing: 'cubic-bezier(.3,.7,.3,1)', fill: 'forwards' });
    box.classList.add('is-on'); ht.el.style.opacity = '0';
  }
  function close() {
    if (!st.active) return; st.active = false; root.classList.remove('is-open', 'is-cap');
    const ht = hat, R0 = rectOf(ht.el), T = target(), A = onPeg(R0, T), from = getComputedStyle(box).transform;
    box.getAnimations().forEach(a => a.cancel());
    img.style.transform = '';
    const a = box.animate([{ transform: from }, { transform: `translate(${A.x}px,${A.y}px) scale(${A.s}) rotate(${ht.th}rad)` }], { duration: REDUCED ? 1 : 620, easing: 'cubic-bezier(.5,0,.3,1)', fill: 'forwards' });
    a.onfinish = () => { if (st.active && hat !== ht) return; box.classList.remove('is-on'); ht.el.style.opacity = ''; ht.w += 1.4; };
  }
  function snap(v) { st.angT = Math.round((st.angT + clamp(v, -600, 600) * 0.05) / 90) * 90; }
  function step(dir) { const all = racks.flatMap(rk => rk.hats).filter(x => x.h.views); const k = (all.indexOf(hat) + dir + all.length) % all.length; if (all[k] && all[k] !== hat) { const prev = hat; open(all[k]); prev.el.style.opacity = ''; } }
  function frame(dt) {
    if (!st.active || !hat) return;
    const n = Math.max(1, Math.ceil(dt / (1 / 240))), h = dt / n;
    for (let k = 0; k < n; k++) { angV += (90 * (st.angT - ang) - 14 * angV) * h; ang += angV * h; }
    const idx = Math.round(ang / 90), k = ORDER[((idx % 4) + 4) % 4], local = ang - idx * 90;
    if (k !== key) { key = k; img.src = hat.h.views[colour][k]; }
    img.style.transform = `scaleX(${(0.3 + 0.7 * Math.abs(Math.cos(local * Math.PI / 90))).toFixed(3)})`;   // squashes edge-on between views
  }
  return Object.assign(st, { open, close, snap, step, frame });
})();

/* ---------------- the drop bag's countdown, then the reveal ---------------- */
const dropTag = DROP && opts.tags === true ? SwingTag('drop') : null;
const fmtLeft = ms => { const s = Math.max(0, Math.floor(ms / 1000)), d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), x = s % 60, p = n => String(n).padStart(2, '0');
  return (d ? `${d}d ` : '') + `${p(h)}:${p(m)}:${p(x)}`; };
function dropFrame(dt) {
  const b = DROP.bag, tee = DROP.tee;
  if (DROP.placeholder) {
    if (focus === b.i) { const el = labelEl.querySelector('.armory__left'), left = DROP.time > Date.now() ? fmtLeft(DROP.time - Date.now()) : 'Coming soon'; if (el && el.textContent !== left) el.textContent = left; }
    if (dropTag) dropTag.update(b.i, b.state === 'hung' && lifted < 0 && !capView.active, dt); return;
  }
  if (DROP.state === 'zipped') {
    const left = fmtLeft(DROP.time - Date.now());
    if (dropTag) dropTag.em(left);
    if (focus === b.i) { const el = labelEl.querySelector('.armory__left'); if (el && el.textContent !== left) el.textContent = left; }
    if (Date.now() >= DROP.time && b.state === 'hung') {
      DROP.state = 'unzip'; DROP.t = 0; tee.visible = true; tee.state = 'hung';
      tee.yaw = tee.yawH = tee.yawTarget = tee.heroYaw; tee.x = b.x; tee.y = b.y; tee.z = b.z;
    }
  } else if (DROP.state === 'unzip') {
    DROP.t += dt; const p = Math.min(1, DROP.t / 2.2), e = p * p * (3 - 2 * p);
    b.sh.uCut.value.set(1, e, hangDrop + 1, b.h);
    b.phiV += Math.sin(DROP.t * 34) * 0.015;     // the tug of the zip
    if (p >= 1) {
      DROP.state = 'fall'; DROP.t = 0; b.kind = 'falling'; b.state = 'falling'; b.vy = -40;
      tee.kind = 'tee'; tee.order = -1; tee.revealed = true; tee.state = 'hung'; tee.d.isNew = true;
      assignSlots(false); setFocus(tee.i); DROP.focusT = 4;
    }
  } else if (DROP.state === 'fall') {
    DROP.t += dt; b.faceA = Math.max(0, 1 - DROP.t / 0.9);
    if (b.y > H + 300 || b.faceA <= 0) { b.kind = 'gone'; b.visible = false; DROP.state = 'done'; Object.values(b.parts).forEach(m => m.visible = false); }
  }
  if (DROP.focusT > 0) { DROP.focusT -= dt; if (DROP.focusT <= 0 && focus === tee.i && !P.inside) setFocus(-1); }
  if (dropTag) dropTag.update(b.i, DROP.state === 'zipped' && b.state === 'hung' && lifted < 0 && !capView.active, dt);   // hidden behind the viewer
}
if (dropTag) dropTag.fill(DROP.bag);

/* ---------------- the knight: the owner's mascot reading the Holy Bible on a stone at the lower right, his lamb asleep
   beside him. One render (scripts/make_knight.py: the figure cut out + a painted stone, same frame) brought to life by a
   warp rig in the shader: he breathes, reads with small movements of the head, blinks, swings his dangling legs in bouts
   (a pendulum, like the hangers), and looks up when you reach for him; the lamb breathes slowly in its sleep and flicks
   an ear now and then. The Bible's light flickers, lights his face and armour (more so in the dark rooms) and lets a
   few motes drift up. A click / tap and he shares a verse. Lit by the room (THEMES[i].kt; the sky by its hour). ---------------- */
const knight = (() => {
  const K = opts.decor && opts.decor.knight; if (!K || !K.src || !K.meta) return null;
  const m = K.meta;
  const KV = `
uniform vec4 uRect; uniform vec2 uView, uOff; varying vec2 vF;
void main(){ vF = vec2(uv.x, 1.0 - uv.y); vec2 px = uRect.xy + vF * uRect.zw + uOff;
  gl_Position = projectionMatrix * viewMatrix * vec4(px.x - uView.x * 0.5, uView.y * 0.5 - px.y, 0.0, 1.0); }`;
  const KF = `
uniform sampler2D uKnight, uStone; uniform vec2 uOrig, uSize, uBook, uNeck, uKnee, uEarP;
uniform vec4 uLambHead, uLambBody, uEarBox, uEye0, uEye1; uniform float uSeat, uLidSkin, uPx;
uniform float uBreath, uHead, uLeg, uLamb, uEar, uBlink, uGlow, uTime, uAlpha, uShadow, uOpen, uWind; uniform vec3 uTint;
varying vec2 vF;
mat2 rot(float a){ float c = cos(a), s = sin(a); return mat2(c, s, -s, c); }
float ell(vec2 p, vec4 e){ vec2 d = (p - e.xy) / e.zw; return dot(d, d); }
float hsh(float n){ return fract(sin(n * 12.9898) * 43758.5453); }
vec4 tex(sampler2D t, vec2 s, float b){ vec2 q = (s - uOrig) / uSize; return texture2D(t, vec2(q.x, 1.0 - q.y), b); }   // textures load flipped (flipY)
// output point -> where it comes from in the render (small, smooth displacements, so one inverse step is exact enough)
vec2 warp(vec2 p){
  vec2 s = p;
  float wl = smoothstep(uLambBody.x, uLambBody.x + 90.0, p.x) * smoothstep(uLambBody.z + 10.0, uLambBody.z - 40.0, p.x)
           * smoothstep(uLambBody.y - 30.0, uLambBody.y + 40.0, p.y) * smoothstep(uLambBody.w + 6.0, uLambBody.w - 4.0, p.y);
  s.y += uLamb * 8.0 * clamp((uLambBody.w - p.y) / (uLambBody.w - uLambBody.y), 0.0, 1.0) * wl;    // the lamb's back rises
  vec4 eb = vec4((uEarBox.xy + uEarBox.zw) * 0.5, (uEarBox.zw - uEarBox.xy) * 0.5);
  s = uEarP + rot(-uEar * smoothstep(1.35, 0.55, ell(p, eb))) * (s - uEarP);                           // its ear flicks
  float lambA = smoothstep(uLambBody.x - 20.0, uLambBody.x + 40.0, p.x) * smoothstep(uLambBody.y - 50.0, uLambBody.y + 10.0, p.y);
  s.y += uBreath * 9.0 * smoothstep(uSeat + 40.0, uSeat - 110.0, p.y) * (1.0 - lambA);                 // he breathes
  vec2 N = uNeck - vec2(0.0, uBreath * 9.0);
  s = N + rot(-uHead * smoothstep(N.y + 45.0, N.y - 45.0, p.y) * smoothstep(360.0, 440.0, p.x)) * (s - N);   // reads
  float wg = smoothstep(uKnee.y - 30.0, uKnee.y + 80.0, p.y) * smoothstep(600.0, 470.0, p.x) * smoothstep(1.0, 1.7, ell(p, uLambHead));
  s = uKnee + rot(-uLeg * wg) * (s - uKnee);                                                           // swings his legs
  return s;
}
// a lid closing over an eye: above its moving edge (curved like a lid, lowest in the middle) the eye is skin; a dark
// lash line rides the edge, so the closed eye is the curved line the render's style draws
float lid(vec2 s, vec4 e, out float lash, out float crease){
  vec2 d = (s - e.xy) / e.zw; float inside = 1.0 - smoothstep(0.92, 1.12, length(d * vec2(0.95, 0.85)));
  float edge = mix(-1.15, 0.55, uBlink) + 0.28 * (1.0 - d.x * d.x) * uBlink;
  lash = exp(-pow((d.y - edge) * e.w / 1.8, 2.0)) * smoothstep(1.05, 0.7, abs(d.x)) * smoothstep(0.05, 0.35, uBlink) * step(abs(d.y), 1.3);
  crease = clamp((d.y - edge + 1.0), 0.0, 1.0);
  return smoothstep(edge + 0.12, edge - 0.12, d.y) * inside;
}
void main(){
  vec2 p = uOrig + vF * uSize;
  vec2 s = warp(p);
  float la0, la1, cr0, cr1, c0 = lid(s, uEye0, la0, cr0), c1 = lid(s, uEye1, la1, cr1);
  vec4 k = tex(uKnight, s, 0.0), st = tex(uStone, p, 0.0);
  vec4 skin = tex(uKnight, uEye0.xy + vec2(-6.0, 34.0), 2.5);          // his cheek, softly averaged: the lids' colour
  float cov = max(c0, c1);
  k = mix(k, vec4(skin.rgb / max(skin.a, 0.01), 1.0) * (0.9 + 0.1 * mix(cr1, cr0, step(c1, c0))) * k.a, cov);
  // the shadow on the wall: both layers blurred (always sampled, so the mip level stays defined)
  float sa = 0.0;
  for (int i = 0; i < 6; i++){ float a = float(i) * 1.0472; vec2 o = vec2(cos(a), sin(a)) * 14.0 * uPx;
    sa += tex(uKnight, p + o, 3.0).a + tex(uStone, p + o, 3.0).a; }
  sa = min(sa / 6.0, 1.0);
  k.rgb = mix(k.rgb, vec3(0.2, 0.11, 0.08) * k.a, max(la0, la1) * 0.85);
  // light: the room's, plus the Bible's (warm, flickering) on what is near it; the pages keep their own glow
  vec2 db = (p - uBook) / vec2(1.0, 1.2); float dB = length(db);
  float tL = dot(uTint, vec3(0.299, 0.587, 0.114));
  float pages = exp(-dB / 70.0);
  vec3 warm = vec3(1.0, 0.8, 0.5);
  vec3 lightK = mix(uTint + warm * exp(-dB / 300.0) * uGlow * (1.25 - tL) * 0.8, vec3(1.0), pages);
  vec4 c = vec4(k.rgb * lightK, k.a);
  c += vec4(st.rgb * (uTint + warm * exp(-length(p - uBook) / 420.0) * uGlow * (1.15 - tL) * 0.35), st.a) * (1.0 - k.a);
  float halo = exp(-dB * dB / 12000.0) * 0.3 * uGlow;                                     // bloom round the pages (gone well before the quad's edge)
  float motes = 0.0;
  for (int i = 0; i < 8; i++){ float fi = float(i), T = 3.6 + 2.4 * hsh(fi + 1.0), ph = fract(uTime / T + hsh(fi + 7.0));
    vec2 q = uBook + vec2(-80.0 + 160.0 * hsh(fi + 3.0) + 22.0 * sin(ph * 5.0 + fi) + uWind * 260.0 * ph, -30.0 - ph * 300.0);   // a gust carries them
    motes += smoothstep(1.8 * uPx, 0.3 * uPx, length(p - q)) * sin(3.14159 * ph) * (0.6 + 0.4 * hsh(fi + 5.0)); }
  c.rgb += warm * (halo + motes * 0.9 * uGlow);
  c.a = max(c.a, (halo * 0.5 + motes * 0.8) * uGlow);
  vec4 sh = vec4(0.0, 0.0, 0.0, sa * 0.2 * (1.0 - uOpen));
  gl_FragColor = mix(c, sh, uShadow) * uAlpha;
}`;
  const u = { uRect: { value: new THREE.Vector4() }, uView: globals.uView, uOff: { value: new THREE.Vector2() },
    uKnight: { value: blankTex() }, uStone: { value: blankTex() },
    uOrig: { value: new THREE.Vector2(...m.origin) }, uSize: { value: new THREE.Vector2(...m.size) },
    uBook: { value: new THREE.Vector2(...m.book) }, uNeck: { value: new THREE.Vector2(...m.neck) }, uKnee: { value: new THREE.Vector2(...m.knee) },
    uEarP: { value: new THREE.Vector2(...m.ear) }, uLambHead: { value: new THREE.Vector4(...m.lambHead) }, uLambBody: { value: new THREE.Vector4(...m.lambBody) },
    uEarBox: { value: new THREE.Vector4(...m.earBox) }, uEye0: { value: new THREE.Vector4(...m.eyes[0]) }, uEye1: { value: new THREE.Vector4(...m.eyes[1]) },
    uSeat: { value: m.seat }, uLidSkin: { value: m.lidSkin }, uPx: { value: 6 },
    uBreath: { value: 0 }, uHead: { value: 0 }, uLeg: { value: 0 }, uLamb: { value: 0 }, uEar: { value: 0 }, uBlink: { value: 0 }, uGlow: { value: 1 },
    uTime: globals.uTime, uAlpha: { value: 0 }, uShadow: { value: 0 }, uOpen: globals.uOpen, uWind: { value: 0 }, uTint: { value: new THREE.Vector3(1, 1, 1) } };
  const mk = shadow => { const uu = Object.assign({}, u, { uShadow: { value: shadow ? 1 : 0 }, uOff: { value: new THREE.Vector2() } });
    const mesh = new THREE.Mesh(new THREE.PlaneGeometry(1, 1), new THREE.ShaderMaterial({ uniforms: uu, vertexShader: KV, fragmentShader: KF,
      transparent: true, premultipliedAlpha: true, depthTest: false, depthWrite: false, blending: THREE.CustomBlending,
      blendSrc: THREE.OneFactor, blendDst: THREE.OneMinusSrcAlphaFactor }));
    mesh.frustumCulled = false; mesh.renderOrder = shadow ? -60 : 5; mesh.visible = false; scene.add(mesh); return mesh; };
  const shadowMesh = mk(true), mesh = mk(false);
  let loaded = 0;
  [['uKnight', K.src], ['uStone', K.stone]].forEach(([key, src]) => loader.load(src, tx => {
    tx.minFilter = THREE.LinearMipmapLinearFilter; tx.generateMipmaps = true; tx.premultiplyAlpha = true; tx.anisotropy = 4; textures.push(tx);
    mesh.material.uniforms[key].value = tx; shadowMesh.material.uniforms[key].value = tx; loaded++; }));

  // DOM: an invisible button over him (hover / focus / click), and the verse he shares
  const btn = document.createElement('button'); btn.type = 'button'; btn.className = 'armory__knight';
  btn.setAttribute('aria-label', 'The OTK knight, reading his Bible with his lamb. Share a verse');
  const say = document.createElement('div'); say.className = 'armory__say'; say.setAttribute('aria-live', 'polite');
  say.innerHTML = '<q></q><cite></cite>';
  root.append(btn, say);
  const VERSES = [
    ['Thy word is a lamp unto my feet, and a light unto my path.', 'Psalm 119:105'],
    ['The LORD is my shepherd; I shall not want.', 'Psalm 23:1'],
    ['Put on the whole armour of God.', 'Ephesians 6:11'],
    ['Be strong in the Lord, and in the power of his might.', 'Ephesians 6:10'],
    ['Behold the Lamb of God, which taketh away the sin of the world.', 'John 1:29'],
    ['I am the good shepherd: the good shepherd giveth his life for the sheep.', 'John 10:11'],
    ['Thy word have I hid in mine heart, that I might not sin against thee.', 'Psalm 119:11'],
    ['Fear thou not; for I am with thee.', 'Isaiah 41:10'],
    ['Heaven and earth shall pass away, but my words shall not pass away.', 'Matthew 24:35'],
  ];
  let vi = Math.floor(Math.random() * VERSES.length), sayT = 0;
  const speak = () => { vi = (vi + 1) % VERSES.length; say.querySelector('q').textContent = VERSES[vi][0]; say.querySelector('cite').textContent = VERSES[vi][1];
    say.classList.remove('is-on'); void say.offsetWidth; say.classList.add('is-on'); sayT = 7; st.look = 1.6; st.glowKick = 0.6; st.earV += 9; };
  const st = { on: false, k: 0, x0: 0, y0: 0, hover: false, look: 0, head: 0, headV: 0, leg: 0, legV: 0, bout: 3, boutOn: false, boutT: 0,
    blinkT: 2.5, blinkP: -1, dbl: false, ear: 0, earV: 0, earT: 9, glow: 1, glowKick: 0, tint: [1, 1, 1] };
  btn.addEventListener('pointerenter', e => { if (e.pointerType !== 'touch') { st.hover = true; st.earV += 6; } });
  btn.addEventListener('pointerleave', e => { if (e.pointerType !== 'touch') st.hover = false; });
  btn.addEventListener('focus', () => { st.hover = true; }); btn.addEventListener('blur', () => { st.hover = false; });
  btn.addEventListener('click', e => { e.stopPropagation(); speak(); });

  // where he sits: on the floor line (the top of the ticker) at the lower right, below the tees and their labels, about
  // as tall as a tee. Phones keep their cap racks at the bottom corners, so there the racks move up under the tees'
  // labels and he takes the corner, clear of the room shield
  function layout() {
    const tick = $('.armory__ticker'), tH = tick ? tick.offsetHeight : 28, phone = W <= 760;
    const tees = G.filter(g => g.visible && g.kind === 'tee');
    const hem = railY + Math.max(...tees.map(g => hangDrop + g.h), S);
    const top = hem + (phone ? 18 + 50 : 22);   // below the hems (phones: below the hover label too); desktop labels step aside
    const floor = H - tH + Math.max(4, tH * 0.25);
    const span = m.floor - m.top, fig = m.figure[3] - m.top, wide = m.cut - m.figure[0];
    // half the size it was (owner, 2026-10-03: the rack and clothes are the main attraction)
    let k = Math.min((floor - top) / span, (S * (phone ? 0.935 : 0.73)) / fig, (W * (phone ? 0.187 : 0.1)) / wide);
    st.on = k * fig >= (phone ? 60 : 70);
    st.k = k;
    st.x0 = W - (m.cut - m.origin[0]) * k;                            // the stone runs off the right edge: he sits against it
    st.y0 = floor - (m.floor - m.origin[1]) * k;                      // and its top
    u.uRect.value.set(st.x0, st.y0, m.size[0] * k, m.size[1] * k);
    u.uPx.value = 1 / Math.max(k, 1e-3) * (window.devicePixelRatio > 1.5 ? 1.0 : 1.2);
    const fx = st.x0 + (m.figure[0] - m.origin[0]) * k, fy = st.y0 + (m.figure[1] - m.origin[1]) * k;
    Object.assign(btn.style, { left: fx + 'px', top: fy + 'px', width: (m.figure[2] - m.figure[0]) * k + 'px', height: (m.figure[3] - m.figure[1]) * k + 'px', display: st.on ? '' : 'none' });
    // the verse appears beside him, at head height, on the side of the Bible he reads it from
    say.style.right = (W - fx + 14) + 'px'; say.style.top = (fy + (m.figure[3] - m.figure[1]) * k * 0.1) + 'px'; say.style.bottom = 'auto';
    say.style.maxWidth = Math.max(140, Math.min(320, fx - (phone ? 52 : 40))) + 'px';
    const box = (x0, y0, x1, y1) => ({ l: st.x0 + (x0 - m.origin[0]) * k, t: st.y0 + (y0 - m.origin[1]) * k, r: st.x0 + (x1 - m.origin[0]) * k, b: st.y0 + (y1 - m.origin[1]) * k });
    st.avoid = st.on ? [box(395, 290, 845, 730), box(40, 720, 300, 1010)] : [];
    root.classList.toggle('has-knight-low', phone && st.on);           // phones: the room shield moves to the bottom left
  }
  const spring = (x, v, target, w, z, h) => { v += (w * w * (target - x) - 2 * z * w * v) * h; return [x + v * h, v]; };
  function frame(dt) {
    const show = st.on && loaded >= 2;
    mesh.visible = shadowMesh.visible = show;
    u.uAlpha.value += ((show ? 1 : 0) - u.uAlpha.value) * Math.min(1, dt * 2.5);
    if (sayT > 0) { sayT -= dt; if (sayT <= 0) say.classList.remove('is-on'); }
    if (!show) return;
    const t = simT, R = REDUCED ? 0 : 1;
    // breathing: in slowly, out a little quicker; the lamb slower and deeper, asleep
    const br = 0.5 - 0.5 * Math.cos(2 * Math.PI * t / 4.2); u.uBreath.value = R * (br * br * (3 - 2 * br));
    u.uLamb.value = R * (0.5 - 0.5 * Math.cos(2 * Math.PI * (t + 1.3) / 3.3));
    const n = Math.max(1, Math.ceil(dt / (1 / 240))), h = dt / n;
    // the head: small reading movements, a look up when you reach for him or when he shares a verse
    st.look = Math.max(0, st.look - dt);
    const read = 0.016 * Math.sin(t * 0.43) + 0.009 * Math.sin(t * 1.21 + 1.0) + 0.006 * Math.sin(t * 2.7 + 0.4) * (0.5 + 0.5 * Math.sin(t * 0.17));
    const target = R * (st.hover || st.look > 0 ? 0.13 : read);
    for (let k = 0; k < n; k++) [st.head, st.headV] = spring(st.head, st.headV, target, 5.5, 0.75, h);
    u.uHead.value = st.head;
    // the legs: swinging in bouts, like a boy on a high seat (a pendulum driven at its own pace, then left to settle)
    st.bout -= dt;
    if (st.bout <= 0) { st.boutOn = !st.boutOn; st.bout = st.boutOn ? 5 + Math.random() * 6 : 3 + Math.random() * 5; }
    const w0 = 2 * Math.PI / 1.45, drive = R * (st.boutOn ? 0.55 : 0) * Math.sin(t * w0);
    for (let k = 0; k < n; k++) { st.legV += (-w0 * w0 * st.leg - 2 * 0.09 * w0 * st.legV + drive) * h; st.leg += st.legV * h; }
    u.uLeg.value = clamp(st.leg, -0.09, 0.09);
    // blinking, now and then twice
    st.blinkT -= dt;
    if (st.blinkT <= 0 && st.blinkP < 0) { st.blinkP = 0; st.dbl = Math.random() < 0.2; st.blinkT = 2.4 + Math.random() * 4; }
    if (st.blinkP >= 0) { st.blinkP += dt; const b = st.blinkP; u.uBlink.value = b < 0.07 ? b / 0.07 : b < 0.11 ? 1 : Math.max(0, 1 - (b - 0.11) / 0.12);
      if (b > 0.24) { st.blinkP = -1; u.uBlink.value = 0; if (st.dbl) { st.dbl = false; st.blinkT = 0.12; } } }
    if (REDUCED) u.uBlink.value = 0;
    if (st.forceBlink != null) u.uBlink.value = st.forceBlink;   // tests
    // a gust passing: the motes drift with it and the lamb flicks an ear
    const gw = gustAt(st.x0 + ((m.figure[0] + m.figure[2]) / 2 - m.origin[0]) * st.k);
    st.wind = (st.wind || 0) + (gw - (st.wind || 0)) * Math.min(1, dt * 4); u.uWind.value = st.wind;
    if (Math.abs(gw) > 0.35 && !st.gustFlick) { st.gustFlick = true; st.earV += R * 10 * Math.sign(gw); } else if (Math.abs(gw) < 0.05) st.gustFlick = false;
    // the lamb's ear: a quick flick every so often
    st.earT -= dt; if (st.earT <= 0) { st.earV += R * (8 + Math.random() * 6); st.earT = 7 + Math.random() * 9; }
    for (let k = 0; k < n; k++) [st.ear, st.earV] = spring(st.ear, st.earV, 0, 2 * Math.PI / 0.32, 0.22, h);
    u.uEar.value = clamp(st.ear, -0.35, 0.35);
    // the Bible's light: a slow candle-like flicker, brighter when he is reached for or speaks
    st.glowKick = Math.max(0, st.glowKick - dt * 0.5);
    const fl = 0.9 + 0.06 * Math.sin(t * 2.3) + 0.04 * Math.sin(t * 5.7 + 1.1) + 0.03 * Math.sin(t * 11.3);
    st.glow += (fl + (st.hover ? 0.25 : 0) + st.glowKick - st.glow) * Math.min(1, dt * 4); u.uGlow.value = st.glow;
    // the room's light on him
    const tA = THEMES[themePrev].kt || [1, 1, 1], tB = THEMES[theme].kt || [1, 1, 1];
    let want = [0, 1, 2].map(j => lerp(tA[j], tB[j], themeMix));
    if (THEMES[themeApplied].id === 'sky' || (tod && theme === SKY)) { const nn = bgMat.uniforms.uStars.value; want = want.map((v, j) => lerp(v, [0.42, 0.45, 0.62][j], nn)); }
    st.tint = st.tint.map((v, j) => v + (want[j] - v) * Math.min(1, dt * 3));
    u.uTint.value.set(...st.tint);
    shadowMesh.material.uniforms.uOff.value.set(S * 0.045, S * 0.025);
  }
  return { layout, frame, speak, u, st, get on() { return st.on; }, get avoid() { return st.avoid || []; }, get rect() { return { x: st.x0, y: st.y0, k: st.k }; } };
})();

function extrasFrame(dt) {
  glow += ((lifted >= 0 || capView.active ? 1 : boltHover ? 0.75 : 0.3) - glow) * Math.min(1, dt * 3);
  bgMat.uniforms.uGlow.value = glow;
  syncSky(dt);
  capView.frame(dt);
  if (knight) knight.frame(dt);
  if (DROP) dropFrame(dt);
}

/* ---------------- render ---------------- */
let last = 0, t0 = 0, simT = 0, introStart = 0;
function syncUniforms() {
  updateSpot(lastDt);
  lightX = W * 0.32;   // soft room key from the upper left
  syncBackdrop();
  railMat.uniforms.uRailOff.value.set(rail.ox, rail.oy); railMat.uniforms.uLight.value.set(clamp((lightX - W / 2) / (W * 0.45), -1, 1) * 0.6, 0);
  metalExtras.forEach(m => { m.material.uniforms.uRailOff.value.set(rail.ox, rail.oy); m.material.uniforms.uLight.value.set(clamp((lightX - W / 2) / (W * 0.45), -1, 1) * 0.6, 0); });
  G.forEach(g => { if (!g.visible) Object.values(g.parts).forEach(m => m.visible = false); });
  const wall = i => THEMES[i].open ? 0 : 1, wallness = lerp(wall(themePrev), wall(theme), themeMix);   // fades with the reveal
  globals.uOpen.value = 1 - wallness;
  { const eB = THEMES[theme].env || THEMES[themePrev].env, eA = THEMES[themePrev].env || eB;
    if (eA) { const m = themeMix; ['uEnvTop', 'uEnvHor', 'uEnvLow'].forEach((k, j) => globals[k].value.set(lerp(eA[j][0], eB[j][0], m), lerp(eA[j][1], eB[j][1], m), lerp(eA[j][2], eB[j][2], m)));
      globals.uEnvSun.value = lerp(eA[3], eB[3], m); } }
  title.tick(lastDt);
  const order = G.filter(g => g.visible).sort((a, b) => (a.z - b.z) || (a.i - b.i));
  order.forEach((g, rank) => {
    const s = g.sh, onRail = g.state !== 'lift' && g.state !== 'return';
    const px = g.x + (onRail ? rail.ox : 0);
    s.uPivot.value.set(px, g.y); s.uPivotZ.value = g.z;
    // the shank reaches the wood: inside the neck with the front to you; in a dipping back neckline from behind
    const reach = v => v && v.bar ? Math.max(0, hangDrop - (v.lift || 0) * S + v.bar * S + 1.5 - globals.uHookJ.value.y) : 0;
    const cy = Math.cos(g.yaw);
    s.uHookExt.value = smooth(0.5, 0.85, cy) * reach(g.rects.front) + smooth(0.5, 0.85, -cy) * reach(g.rects.back);
    // a hood: from behind, the hook comes out over the top of the hood, so the shank pulls up as far as it can
    if (g.lift) s.uHookExt.value -= smooth(0.3, 0.8, -Math.cos(g.yaw)) * Math.min(g.lift, (globals.uHookJ.value.y - globals.uHookJ.value.x) * 0.85);
    s.uHookYaw.value = g.hookYaw; s.uYawTop.value = g.yaw; s.uYawHem.value = g.yawH; s.uYawMid.value = g.yaw * 0.6 + g.yawH * 0.4; s.uSwing.value = g.phi; s.uHem.value = g.hem; s.uPitch.value = g.pitch; s.uRipple.value = g.rip;
    s.uLight.value.set(clamp((lightX - px) / (W * 0.45), -1, 1) * 0.95, 0);
    s.uShadowOff.value.set((px - W / 2) * 0.012, S * 0.05);
    const ym = g.yaw * 0.6 + g.yawH * 0.4, af = g.wF * Math.abs(Math.cos(ym)), as = g.wS * Math.abs(Math.sin(ym));
    const fv = g.side ? smooth(0.488, 0.512, af / (af + as + 0.001)) : 1;
    g.faceA = 1; g.sideA = 1;
    const shown = g.state !== 'wait' && g.visible ? 1 : 0;
    const lit = wallness;   // no wall behind the rack in the open sky, so no shadows on it
    const shadowK = window.__noShadow ? 0 : shown * (1 - clamp(g.z / (D * 0.12), 0, 1)) * 0.13 * lit;
    const p = g.parts;
    p.face.material.uniforms.uAlpha.value = g.faceA * shown;
    p.shadowFace.material.uniforms.uAlpha.value = shadowK * fv;
    if (p.side) { p.side.material.uniforms.uAlpha.value = g.sideA * shown; p.shadowSide.material.uniforms.uAlpha.value = (1 - fv) * shadowK; }
    p.hook.material.uniforms.uAlpha.value = 1;
    const base = rank * 10 + 10;
    p.shadowFace.renderOrder = -100 + rank; if (p.shadowSide) p.shadowSide.renderOrder = -100 + rank;
    p.face.renderOrder = base + 1; if (p.side) p.side.renderOrder = base + 2; p.hook.renderOrder = base + 3;
    Object.values(p).forEach(m => m.visible = !!shown && !window.__noGarments && window.__hideGarment !== g.i);   // __hideGarment: tests
  });
  // floating label under the focused piece
  const fg = G[focus];
  if (fg && lifted < 0 && fg.state === 'hung') {
    // under the body as it hangs: the swing carries the lower body off the hook's line (the shader's bend, at 70%)
    const yl = hangDrop + fg.h * 0.7, aMid = fg.phi + (fg.hem - fg.phi) * Math.pow(0.7, 1.6);
    const bodyX = fg.x + rail.ox + Math.sin(aMid) * yl;
    labelX = labelFor === focus ? labelX + (bodyX - labelX) * Math.min(1, lastDt * 18) : bodyX; labelFor = focus;
    let lx = clamp(labelX, 90, W - 90);
    const ly = railY + hangDrop + Math.max(S * 1.0, fg.h) + 18;
    if (knight && knight.on) {   // a label that would land on the knight's head or Bible steps left of it
      const lw = labelEl.offsetWidth || 160, lh = labelEl.offsetHeight || 46;
      knight.avoid.forEach(b => { if (lx + lw / 2 > b.l - 8 && lx - lw / 2 < b.r && ly + lh > b.t && ly < b.b) lx = Math.max(90, b.l - 8 - lw / 2); });
    }
    labelEl.style.left = lx.toFixed(1) + 'px'; labelEl.style.top = ly.toFixed(1) + 'px';
    labelEl.classList.add('is-on'); labelEl.classList.toggle('is-kbd', kbdFocus);
  } else labelEl.classList.remove('is-on', 'is-kbd');
  // the swing tag shows once the focused tee has turned to its hero side
  if (tagFocus) { const fg = G[focus]; const show = !!fg && lifted < 0 && fg.state === 'hung' && fg.kind !== 'bag' && Math.cos(fg.yaw - fg.heroYaw) > 0.75; tagFocus.update(show ? focus : -1, show, lastDt); }
  extrasFrame(lastDt);
}
function frame(now) {
  if (!running) { last = 0; return; }
  requestAnimationFrame(frame);
  if (!last) last = now;
  let dt = Math.min(0.05, (now - last) / 1000); last = now; lastDt = dt;
  if (pending > 0) return; // wait for textures before the intro
  if (!introStart) { introStart = simT + 0.001; startIntro(); }
  const sub = Math.ceil(dt / (1 / 240)), h = dt / sub;
  clinkBudget = 0;
  for (let k = 0; k < sub; k++) { simT += h; physics(h, simT); }
  globals.uTime.value = simT;
  syncUniforms();
  cam.layers.set(0); renA.render(scene, cam);
  const flying = G.some(g => g.layer === 1);
  if (flying || liftCanvas.dataset.dirty) { cam.layers.set(1); renB.render(scene, cam); liftCanvas.dataset.dirty = flying ? '1' : ''; }
}
function startIntro() {
  const vis = G.filter(g => g.visible);
  vis.forEach((g, k) => {
    g.x = g.rest; g.tx = g.rest;
    if (REDUCED) { g.state = 'hung'; g.y = railY; }
    else { g.state = 'drop'; g.delay = simT + 0.15 + k * 0.075; g.y = railY - S * 1.4 - 160; g.vy = 0; g.phi = (Math.random() - 0.5) * 0.3; }
  });
  introDone = true;
}

/* ---------------- lifecycle ---------------- */
buildDecor(); layoutMetrics(); lightX = W / 2; spotS.x = W / 2; spotS.y = railY + S * 0.45; applyTheme(theme, false);
try { if (ROOM_KEY && opts.timeOfDay !== false && localStorage.getItem('otk-armory-tod') === '1') setTod(true, false); } catch (e) {}
if (opts.startTod && opts.timeOfDay !== false) setTod(true, false);   // lands on the sky at the visitor's hour (section setting)
const ro = new ResizeObserver(() => { layoutMetrics(); }); ro.observe(root);
let inView = false;
const io = new IntersectionObserver(es => { inView = es[es.length - 1].isIntersecting; if (inView && !running && !document.hidden) { running = true; requestAnimationFrame(frame); } else if (!inView) running = false; }, { threshold: 0.2 });
io.observe(root);
const onVis = () => { if (document.hidden) running = false; else if (inView && !running) { running = true; requestAnimationFrame(frame); } };
document.addEventListener('visibilitychange', onVis);
function destroy() {
  running = false; io.disconnect(); ro.disconnect(); clearTimeout(unfocusTimer);
  document.removeEventListener('keydown', onKey); document.removeEventListener('visibilitychange', onVis);
  scene.traverse(o => { if (o.geometry) o.geometry.dispose(); if (o.material) o.material.dispose(); });
  textures.forEach(t => t.dispose());
  [renA, renB].forEach(r => { r.dispose(); r.forceContextLoss(); });   // free the GL contexts (the theme editor re-mounts often)
  if (Sound.ctx) Sound.ctx.close();
  if (window.__armory === api) delete window.__armory;
}
function advance(sec, draw = true){ if(!introStart){introStart=0.001;startIntro();} const n=Math.round(sec*240); for(let k=0;k<n;k++){simT+=1/240; physics(1/240,simT);} globals.uTime.value=simT; lastDt=sec; syncUniforms(); if(!draw) return; cam.layers.set(0); renA.render(scene,cam); cam.layers.set(1); renB.render(scene,cam); }
const api = { advance, pause(){running=false;}, resume(){ if (!running) { running = true; last = 0; requestAnimationFrame(frame); } }, CONTACT, setTheme(i){ leaveTod(); applyTheme(i,false); }, G, get focus() { return focus; }, setFocus, openViewer, closeViewer, P, rail, get S() { return S; }, title(v) { title.set(v); }, get room() { return theme; }, rooms: THEMES.filter(x => !x.hidden).map(x => x.id),
  setHour(h) { opts.hour = h; }, get breeze() { return breezeK; }, get time() { return simT; }, tod(on) { setTod(!!on); }, get todOn() { return tod; }, heaven() { enterHeaven(bolts()[0]); }, bolts,
  get drop() { return DROP && (DROP.placeholder ? 'placeholder' : DROP.state); }, openCap(k) { const all = racks.flatMap(rk => rk.hats).filter(x => x.h.views); if (all[k]) capView.open(all[k]); }, closeCap() { capView.close(); },
  get cap() { return capView.active; }, knight() { if (knight) knight.speak(); }, gust(dir) { wind.wait = 0; wind.forceDir = dir || 1; }, get wind() { return wind; }, get knightRig() { return knight; }, get knightOn() { return !!knight && knight.on; }, get knightRect() { return knight && knight.rect; }, destroy };
window.__armory = api;
return api;
};

/* Shopify glue for The Armory (bundled after backdrop.js + engine.js into assets/otk-armory.js).
   Each [data-otk-armory] section starts only when it nears the viewport: three.js r128 is loaded once from cdnjs,
   otk-armory-data.json (geometry + texture file names, keyed by product handle) is fetched once, and the live product
   data Liquid rendered into the section (title, price, URL, availability) is merged in by handle. Products without
   packed images are skipped. The theme editor's shopify:section:load / unload mount and destroy instances. */
(() => {
'use strict';
if (window.OTK_ARMORY_SHOPIFY) { window.OTK_ARMORY_SHOPIFY.scan(); return; }   // script re-run by the theme editor

const THREE_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
const THREE_SRI = 'sha512-dLxUelApnYxpLt6K2iomGngnHO83iUvZytA3YjDUCjT0HDOHKXnVYdf3hU4JjM8uEhxf9nD1/ey98U3t2vZ0qQ==';
const MAX_TEES = 16, MAX_CAPS = 4;
let threeP = null;
const dataP = {};

function loadThree() {
  if (window.THREE) return Promise.resolve();
  return threeP || (threeP = new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = THREE_SRC; s.integrity = THREE_SRI; s.crossOrigin = 'anonymous'; s.async = true;
    s.onload = () => resolve(); s.onerror = () => { threeP = null; s.remove(); reject(new Error('three.js did not load')); };
    document.head.appendChild(s);
  }));
}
function loadData(url) {
  return dataP[url] || (dataP[url] = fetch(url).then(r => { if (!r.ok) throw new Error('otk-armory-data.json ' + r.status); return r.json(); })
    .catch(e => { delete dataP[url]; throw e; }));
}

// "2026-10-12 18:00 -0500" (the theme setting plus the store's offset) -> ms
function parseDropTime(t) {
  const m = /^(\d{4}-\d{2}-\d{2})[ T](\d{1,2}):(\d{2})\s*([+-]\d{2}):?(\d{2})?/.exec(String(t || '').trim());
  return m ? Date.parse(`${m[1]}T${m[2].padStart(2, '0')}:${m[3]}:00${m[4]}:${m[5] || '00'}`) : NaN;
}
// add to cart the way Dawn-family themes do, so the theme's own cart notification (or drawer) opens with the item
function addToCart(id) {
  const cn = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const fd = new FormData(); fd.append('id', id); fd.append('quantity', '1');
  if (cn && typeof cn.getSectionsToRender === 'function') {
    fd.append('sections', cn.getSectionsToRender().map(x => x.id)); fd.append('sections_url', location.pathname);
    if (typeof cn.setActiveElement === 'function') cn.setActiveElement(document.activeElement);
  }
  return fetch((window.routes && window.routes.cart_add_url) || '/cart/add', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
    .then(r => r.json()).then(res => {
      if (res.status) throw new Error(res.description || res.message || 'That could not be added to your cart.');
      if (cn && typeof cn.renderContents === 'function') { cn.classList.remove('is-empty'); cn.renderContents(res); }
      return res;
    });
}

function assemble(root, data) {
  const base = root.dataset.assets;
  const file = f => base + f.file + '?v=' + f.v;
  const live = JSON.parse(root.querySelector('[data-armory-products]').textContent);
  const q = new URLSearchParams(location.search), preview = q.get('armory-drop') === 'now';
  const shop = p => ({ handle: p.handle, id: p.id, title: p.title, url: p.url, price: p.price, priceText: p.priceText, available: p.available,
                       isNew: p.isNew, lowStock: p.lowStock, about: p.about, options: p.options, variants: p.variants });
  const tee = p => {
    const g = data.garments[p.handle], views = {};
    Object.keys(g.views).forEach(k => { const v = g.views[k]; views[k] = { src: file(v), bb: v.bb, neck: v.neck, bar: v.bar, lift: v.lift }; });
    return Object.assign(shop(p), { hero: g.hero, color: g.color, display: [g.name || p.title, g.sub || ''], verse: g.verse, ref: g.ref, views });
  };
  // the next drop hangs in its garment bag until release; till then it is kept off the rail
  const dp = live.drop && live.drop.product, dropTime = live.drop && live.drop.time ? parseDropTime(live.drop.time) : NaN;
  const dropOn = !!(dp && data.garments[dp.handle] && data.decor.bag && (preview || dropTime > Date.now()));
  const garments = live.tees.filter(p => data.garments[p.handle] && !(dropOn && p.handle === dp.handle)).slice(0, MAX_TEES).map(tee);
  // caps: the first half hang on the left rack, the rest on the right
  const caps = live.caps.filter(p => data.hats[p.handle]).slice(0, MAX_CAPS), nl = Math.ceil(caps.length / 2);
  const hats = caps.map((p, k) => { const h = data.hats[p.handle], views = {};
    Object.keys(h.views || {}).forEach(c => { views[c] = {}; Object.keys(h.views[c]).forEach(v => { views[c][v] = file(h.views[c][v]); }); });
    return Object.assign(shop(p), { name: h.name || p.title, shelf: k < nl ? 'l' : 'r', src: file(h), aspect: h.aspect, pivot: h.pivot, com: h.com,
      views: Object.keys(views).length ? views : null, colour: h.colour, span: h.span || 1, vh: h.vh || 0.8 }); });
  const d = data.decor;
  const bagOf = b => ({ src: file(b), bb: b.bb, neck: b.neck, back: b.back ? { src: file(b.back), bb: b.back.bb, neck: b.back.neck } : null });
  return {
    garments, swatches: data.swatches || {},
    decor: { hats, logo_dark: file(d.logo_dark), logo_light: file(d.logo_light), peg_rail: file(d.peg_rail), sakura: d.sakura ? file(d.sakura) : '',
      knight: d.knight && root.dataset.knight !== 'false' ? { src: file(d.knight), stone: file(d.knight.stone), meta: d.knight.meta } : null },
    // a scheduled drop, or (when the section says so) an empty bag holding its place
    // with no product (or before it has rack images) the empty bag still counts down to the release time, if one is set
    drop: dropOn ? { time: dropTime, garment: tee(dp), bag: bagOf(d.bag) }
      : live.dropPlaceholder !== false && d.bag ? { placeholder: true, time: dropTime, bag: bagOf(d.bag) } : null, dropPreview: preview,
    hour: q.has('armory-hour') ? parseFloat(q.get('armory-hour')) : undefined,
    timeOfDay: root.dataset.tod !== 'false', startTod: root.dataset.startTod === 'true', addToCart: root.dataset.quickAdd === 'false' ? null : addToCart,
  };
}

function mount(root) {
  if (root.__otkArmory) return;
  const st = root.__otkArmory = { io: null, api: null };
  const design = !!(window.Shopify && window.Shopify.designMode);
  const start = () => {
    st.io.disconnect();
    Promise.all([loadThree(), loadData(root.dataset.src)]).then(([, data]) => {
      if (root.__otkArmory !== st || !root.isConnected) return;   // unloaded while we were loading
      const o = assemble(root, data);
      st.api = window.OTK_ARMORY(root, Object.assign(o, { room: parseInt(root.dataset.room, 10) || 0, roomKey: null, newTab: false }));
      root.classList.add(st.api ? 'is-ready' : 'is-nogl');
    }).catch(err => { console.warn('[otk-armory]', err); root.classList.add('is-nogl'); });
  };
  st.io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) start(); }, { rootMargin: '400px 0px' });
  st.io.observe(root);
  // while the hero fills the screen, the store's help button (fixed bottom right) would sit on the knight: it steps aside
  // until the visitor scrolls on (CSS in build_shopify's THEME_FIXES keys off this body class)
  if (root.classList.contains('armory--hero')) {
    st.vis = new IntersectionObserver(es => es.forEach(e => document.body.classList.toggle('armory-hero-on', e.isIntersecting && e.intersectionRatio > 0.6)), { threshold: [0, 0.6, 1] });
    st.vis.observe(root);
  }
}
function unmount(root) {
  const st = root.__otkArmory; if (!st) return;
  st.io.disconnect(); if (st.vis) { st.vis.disconnect(); document.body.classList.remove('armory-hero-on'); } if (st.api) st.api.destroy(); delete root.__otkArmory;
}
const scan = (el = document) => el.querySelectorAll('[data-otk-armory]').forEach(mount);

window.OTK_ARMORY_SHOPIFY = { scan, mount, unmount };
document.addEventListener('shopify:section:load', e => scan(e.target));
document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('[data-otk-armory]').forEach(unmount));
scan();
})();
